import { jsx as g, jsxs as oe, Fragment as Pe } from "react/jsx-runtime";
import * as j from "react";
import Ks, { Fragment as Ki, createContext as mt, use as Te, useRef as Z, useEffect as ce, useMemo as fn, useEffectEvent as po, useState as re, useLayoutEffect as mo, useCallback as de, useId as ho, Children as Ui, Activity as Us, cloneElement as Kt, createElement as yt, useImperativeHandle as Xs, memo as su } from "react";
import * as iu from "react-dom";
import au, { createPortal as lu, flushSync as cu } from "react-dom";
function xe(e) {
  return Object.keys(e);
}
function cr(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
function Gr(e, t) {
  const n = { ...e }, o = t;
  return cr(e) && cr(t) && Object.keys(t).forEach((r) => {
    cr(o[r]) && r in e ? n[r] = Gr(n[r], o[r]) : n[r] = o[r];
  }), n;
}
function uu(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
function du(e) {
  return typeof e != "string" || !e.includes("var(--mantine-scale)") ? e : e.match(/^calc\((.*?)\)$/)?.[1].split("*")[0].trim();
}
function Mn(e) {
  const t = du(e);
  return typeof t == "number" ? t : typeof t == "string" ? t.includes("calc") || t.includes("var") ? t : t.includes("px") ? Number(t.replace("px", "")) : t.includes("rem") ? Number(t.replace("rem", "")) * 16 : t.includes("em") ? Number(t.replace("em", "")) * 16 : Number(t) : NaN;
}
function qs(e) {
  return e === "0rem" ? "0rem" : `calc(${e} * var(--mantine-scale))`;
}
function Xi(e, { shouldScale: t = !1 } = {}) {
  function n(o) {
    if (o === 0 || o === "0") return `0${e}`;
    if (typeof o == "number") {
      const r = `${o / 16}${e}`;
      return t ? qs(r) : r;
    }
    if (typeof o == "string") {
      if (o === "" || o.startsWith("calc(") || o.startsWith("clamp(") || o.includes("rgba(")) return o;
      if (o.includes(",")) return o.split(",").map((s) => n(s)).join(",");
      if (o.includes(" ")) return o.split(" ").map((s) => n(s)).join(" ");
      const r = o.replace("px", "");
      if (!Number.isNaN(Number(r))) {
        const s = `${Number(r) / 16}${e}`;
        return t ? qs(s) : s;
      }
    }
    return o;
  }
  return n;
}
const W = Xi("rem", { shouldScale: !0 }), Zs = Xi("em");
function Et(e) {
  return Object.keys(e).reduce((t, n) => (e[n] !== void 0 && (t[n] = e[n]), t), {});
}
function qi(e) {
  if (typeof e == "number") return !0;
  if (typeof e == "string") {
    if (e.startsWith("calc(") || e.startsWith("var(") || e.includes(" ") && e.trim() !== "") return !0;
    const t = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
    return e.trim().split(/\s+/).every((n) => t.test(n));
  }
  return !1;
}
function Zi(e) {
  return Array.isArray(e) || e === null ? !1 : typeof e == "object" ? e.type !== Ki : !1;
}
function hn(e) {
  const t = mt(null);
  return [t, () => {
    const o = Te(t);
    if (o === null) throw new Error(e);
    return o;
  }];
}
const fu = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function go(e) {
  return fu[e];
}
const pu = () => {
};
function mu(e, t = { active: !0 }) {
  return typeof e != "function" || !t.active ? t.onKeyDown || pu : (n) => {
    n.key === "Escape" && (e(n), t.onTrigger?.());
  };
}
function he(e, t = "size", n = !0) {
  if (e !== void 0)
    return qi(e) ? n ? W(e) : e : `var(--${t}-${e})`;
}
function _e(e) {
  return he(e, "mantine-spacing");
}
function Ve(e) {
  return e === void 0 ? "var(--mantine-radius-default)" : he(e, "mantine-radius");
}
function we(e) {
  return he(e, "mantine-font-size");
}
function hu(e) {
  return he(e, "mantine-line-height", !1);
}
function Ji(e) {
  if (e)
    return he(e, "mantine-shadow", !1);
}
function an(e, t) {
  return (n) => {
    e?.(n), t?.(n);
  };
}
function gu(e, t) {
  return e in t ? Mn(t[e]) : Mn(e);
}
function Kr(e, t) {
  const n = e.map((o) => ({
    value: o,
    px: gu(o, t)
  }));
  return n.sort((o, r) => o.px - r.px), n;
}
function Ue(e) {
  return typeof e == "object" && e !== null ? "base" in e ? e.base : void 0 : e;
}
function vu(e, t, n) {
  return t === void 0 && n === void 0 ? e : t !== void 0 && n === void 0 ? Math.max(e, t) : Math.min(t === void 0 && n !== void 0 ? e : Math.max(e, t), n);
}
function Dr(e = "mantine-") {
  return `${e}${Math.random().toString(36).slice(2, 11)}`;
}
function yu(e, t) {
  if (e === t || Number.isNaN(e) && Number.isNaN(t)) return !0;
  if (!(e instanceof Object) || !(t instanceof Object)) return !1;
  const n = Object.keys(e), { length: o } = n;
  if (o !== Object.keys(t).length) return !1;
  for (let r = 0; r < o; r += 1) {
    const s = n[r];
    if (!(s in t) || e[s] !== t[s] && !(Number.isNaN(e[s]) && Number.isNaN(t[s]))) return !1;
  }
  return !0;
}
function un(e) {
  const t = Z(e);
  return ce(() => {
    t.current = e;
  }), fn(() => ((...n) => t.current?.(...n)), []);
}
function vo(e, t) {
  const { delay: n, flushOnUnmount: o, leading: r, maxWait: s } = typeof t == "number" ? {
    delay: t,
    flushOnUnmount: !1,
    leading: !1,
    maxWait: void 0
  } : t, i = un(e), a = Z(0), l = Z(0), c = Z(null), p = fn(() => {
    const f = Object.assign((...u) => {
      window.clearTimeout(a.current), c.current = u;
      const d = f._isFirstCall;
      f._isFirstCall = !1;
      function m() {
        window.clearTimeout(a.current), window.clearTimeout(l.current), a.current = 0, l.current = 0, f._isFirstCall = !0, f._hasPendingCallback = !1;
      }
      function h() {
        s !== void 0 && l.current === 0 && (l.current = window.setTimeout(() => {
          if (a.current !== 0) {
            const _ = c.current;
            m(), i(..._);
          }
        }, s));
      }
      if (r && d) {
        i(...u);
        const _ = () => {
          m();
        }, w = () => {
          a.current !== 0 && (m(), i(...u));
        }, x = () => {
          m();
        };
        f.flush = w, f.cancel = x, a.current = window.setTimeout(_, n), h();
        return;
      }
      if (r && !d) {
        f._hasPendingCallback = !0;
        const _ = () => {
          a.current !== 0 && (m(), i(...u));
        }, w = () => {
          m();
        };
        f.flush = _, f.cancel = w;
        const x = () => {
          m();
        };
        a.current = window.setTimeout(x, n), h();
        return;
      }
      f._hasPendingCallback = !0;
      const v = () => {
        a.current !== 0 && (m(), i(...u));
      }, y = () => {
        m();
      };
      f.flush = v, f.cancel = y, a.current = window.setTimeout(v, n), h();
    }, {
      flush: () => {
      },
      cancel: () => {
      },
      isPending: () => f._hasPendingCallback,
      _isFirstCall: !0,
      _hasPendingCallback: !1
    });
    return f;
  }, [
    i,
    n,
    r,
    s
  ]);
  return ce(() => () => {
    o ? p.flush() : p.cancel();
  }, [p, o]), p;
}
const bu = ["mousedown", "touchstart"];
function Qi(e, t, n, o = !0) {
  const r = Z(null), s = t || bu, i = po((l) => {
    const { target: c } = l ?? {};
    if (!document.body.contains(c) && c?.tagName !== "HTML") return;
    const p = l.composedPath();
    Array.isArray(n) ? n.every((f) => !!f && !p.includes(f)) && e(l) : r.current && !p.includes(r.current) && e(l);
  }), a = s.join(",");
  return ce(() => {
    if (!o) return;
    const l = a.split(",");
    return l.forEach((c) => document.addEventListener(c, i)), () => {
      l.forEach((c) => document.removeEventListener(c, i));
    };
  }, [a, o]), r;
}
function wu(e, t) {
  return typeof window < "u" && "matchMedia" in window ? window.matchMedia(e).matches : !1;
}
function Cu(e, t, { getInitialValueInEffect: n } = { getInitialValueInEffect: !0 }) {
  const [o, r] = re(n ? t : wu(e));
  return ce(() => {
    try {
      if ("matchMedia" in window) {
        const s = window.matchMedia(e);
        r(s.matches);
        const i = (a) => r(a.matches);
        return s.addEventListener("change", i), () => {
          s.removeEventListener("change", i);
        };
      }
    } catch {
      return;
    }
  }, [e]), o || !1;
}
const Ct = typeof document < "u" ? mo : ce;
function Ur(e, t) {
  const n = Z(!1);
  ce(() => () => {
    n.current = !1;
  }, []), ce(() => {
    if (n.current) return e();
    n.current = !0;
  }, t);
}
function _u({ opened: e, shouldReturnFocus: t = !0 }) {
  const n = Z(null), o = () => {
    n.current && "focus" in n.current && typeof n.current.focus == "function" && n.current?.focus({ preventScroll: !0 });
  };
  return Ur(() => {
    let r = -1;
    const s = (i) => {
      i.key === "Tab" && window.clearTimeout(r);
    };
    if (document.addEventListener("keydown", s), e) n.current = document.activeElement;
    else if (t) {
      const i = document.activeElement;
      r = window.setTimeout(() => {
        const a = document.activeElement;
        (a === null || a === document.body || a === i) && o();
      }, 10);
    }
    return () => {
      window.clearTimeout(r), document.removeEventListener("keydown", s);
    };
  }, [e, t]), o;
}
const xu = /input|select|textarea|button|object/, ea = "a, input, select, textarea, button, object, [tabindex]";
function Su(e) {
  return e.style.display === "none";
}
function Ru(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden") return !1;
  let t = e;
  for (; t && !(t === document.body || t.nodeType === 11); ) {
    if (Su(t)) return !1;
    t = t.parentNode;
  }
  return !0;
}
function ta(e) {
  let t = e.getAttribute("tabindex");
  return t === null && (t = void 0), parseInt(t, 10);
}
function $r(e) {
  const t = e.nodeName.toLowerCase(), n = !Number.isNaN(ta(e));
  return (xu.test(t) && !e.disabled || e instanceof HTMLAnchorElement && e.href || n) && Ru(e);
}
function na(e) {
  const t = ta(e);
  return (Number.isNaN(t) || t >= 0) && $r(e);
}
function Du(e) {
  return Array.from(e.querySelectorAll(ea)).filter(na);
}
function $u(e, t) {
  const n = Du(e);
  if (!n.length) {
    t.preventDefault();
    return;
  }
  const o = n[t.shiftKey ? 0 : n.length - 1], r = e.getRootNode();
  let s = o === r.activeElement || e === r.activeElement;
  const i = r.activeElement;
  if (i.tagName === "INPUT" && i.getAttribute("type") === "radio" && (s = n.filter((l) => l.getAttribute("type") === "radio" && l.getAttribute("name") === i.getAttribute("name")).includes(o)), !s) return;
  t.preventDefault();
  const a = n[t.shiftKey ? n.length - 1 : 0];
  a && a.focus();
}
function Pu(e = !0) {
  const t = Z(null), n = (r) => {
    let s = r.querySelector("[data-autofocus]");
    if (!s) {
      const i = Array.from(r.querySelectorAll(ea));
      s = i.find(na) || i.find($r) || null, !s && $r(r) && (s = r);
    }
    s ? s.focus({ preventScroll: !0 }) : console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", r);
  }, o = de((r) => {
    if (e) {
      if (r === null) {
        t.current = null;
        return;
      }
      t.current !== r && (setTimeout(() => {
        r.getRootNode() ? n(r) : console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", r);
      }), t.current = r);
    }
  }, [e]);
  return ce(() => {
    if (!e) return;
    t.current && setTimeout(() => {
      t.current && n(t.current);
    });
    const r = (s) => {
      s.key === "Tab" && t.current && $u(t.current, s);
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e]), o;
}
function Ot(e) {
  const t = ho(), [n, o] = re(`mantine-${t.replace(/:/g, "")}`), r = Z(!1);
  return Ct(() => {
    r.current || (r.current = !0, o(Dr()));
  }, []), typeof e == "string" ? e : n;
}
function Pr(e, t) {
  if (typeof e == "function") return e(t);
  typeof e == "object" && e !== null && "current" in e && (e.current = t);
}
function Mu(...e) {
  const t = /* @__PURE__ */ new Map();
  return (n) => {
    if (e.forEach((o) => {
      const r = Pr(o, n);
      r && t.set(o, r);
    }), t.size > 0) return () => {
      e.forEach((o) => {
        const r = t.get(o);
        r && typeof r == "function" ? r() : Pr(o, null);
      }), t.clear();
    };
  };
}
function Me(...e) {
  return de(Mu(...e), e);
}
function _t({ value: e, defaultValue: t, finalValue: n, onChange: o = () => {
} }) {
  const [r, s] = re(t !== void 0 ? t : n), i = (a, ...l) => {
    s(a), o?.(a, ...l);
  };
  return e !== void 0 ? [
    e,
    o,
    !0
  ] : [
    r,
    i,
    !1
  ];
}
function oa(e, t) {
  return Cu("(prefers-reduced-motion: reduce)", e, t);
}
function Tu(e, t) {
  if (!e || !t) return !1;
  if (e === t) return !0;
  if (e.length !== t.length) return !1;
  for (let n = 0; n < e.length; n += 1) if (!yu(e[n], t[n])) return !1;
  return !0;
}
function Nu(e) {
  const t = Z([]), n = Z(0);
  return Tu(t.current, e) || (t.current = e, n.current += 1), [n.current];
}
function ku(e, t) {
  ce(e, Nu(t));
}
function Lu(e, t, n = { autoInvoke: !1 }) {
  const o = Z(null), r = un(e), s = de((...a) => {
    o.current || (o.current = window.setTimeout(() => {
      r(...a), o.current = null;
    }, t));
  }, [t]), i = de(() => {
    o.current && (window.clearTimeout(o.current), o.current = null);
  }, []);
  return ce(() => (n.autoInvoke && s(), i), [i, s]), {
    start: s,
    clear: i
  };
}
function Eu(e) {
  const t = Z(void 0);
  return ce(() => {
    t.current = e;
  }, [e]), t.current;
}
function Ou(e, t, n) {
  const o = Z(null);
  ce(() => {
    o.current && (o.current.disconnect(), o.current = null);
    const r = typeof n == "function" ? n() : n;
    return r && (o.current = new MutationObserver(e), o.current.observe(r, t)), () => {
      o.current && (o.current.disconnect(), o.current = null);
    };
  }, [
    e,
    t,
    n
  ]);
}
function Au() {
  const [e, t] = re(!1);
  return ce(() => t(!0), []), e;
}
const Iu = ["mouse", "touch"], Yu = 10;
function Fu(e, t = {}) {
  const { threshold: n = 400, events: o = Iu, cancelOnMove: r = !1, onStart: s, onFinish: i, onCancel: a } = t, l = Z(!1), c = Z(!1), p = Z(-1), f = Z(null);
  ce(() => () => window.clearTimeout(p.current), []);
  const u = o.join(",");
  return fn(() => {
    if (typeof e != "function") return {};
    const d = r !== !1, m = r === !0 ? Yu : r === !1 ? 0 : r, h = (w) => {
      !Qs(w) && !Mr(w) || (s && s(w), f.current = Js(w), c.current = !0, p.current = window.setTimeout(() => {
        e(w), l.current = !0;
      }, n));
    }, v = (w) => {
      !Qs(w) && !Mr(w) || (l.current ? i && i(w) : c.current && a && a(w), l.current = !1, c.current = !1, f.current = null, p.current !== -1 && (window.clearTimeout(p.current), p.current = -1));
    }, y = (w) => {
      if (!d || !c.current || l.current) return;
      const x = Js(w);
      if (!x || !f.current) return;
      const C = x.x - f.current.x, $ = x.y - f.current.y;
      Math.sqrt(C * C + $ * $) > m && v(w);
    }, _ = {};
    return o.includes("mouse") && (_.onMouseDown = h, _.onMouseUp = v, _.onMouseLeave = v, d && (_.onMouseMove = y)), o.includes("touch") && (_.onTouchStart = h, _.onTouchEnd = v, _.onTouchCancel = v, d && (_.onTouchMove = y)), _;
  }, [
    e,
    n,
    a,
    i,
    s,
    r,
    u
  ]);
}
function Js(e) {
  if (Mr(e)) {
    const t = e.touches[0] ?? e.changedTouches[0];
    return t ? {
      x: t.clientX,
      y: t.clientY
    } : null;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function Mr(e) {
  return window.TouchEvent ? e.nativeEvent instanceof TouchEvent : "touches" in e.nativeEvent;
}
function Qs(e) {
  return e.nativeEvent instanceof MouseEvent;
}
function Wu() {
  return typeof process < "u" && process.env, "development";
}
function yo(e) {
  const t = Ks.version;
  return typeof Ks.version != "string" || t.startsWith("18.") ? e?.ref : e?.props?.ref;
}
function Bu(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint";
}
function Zn(e, t = document) {
  const n = t.querySelector(e);
  if (n) return n;
  const o = t.querySelectorAll("*");
  for (let r = 0; r < o.length; r += 1) {
    const s = o[r];
    if (s.shadowRoot) {
      const i = Zn(e, s.shadowRoot);
      if (i) return i;
    }
  }
  return null;
}
function vt(e, t = document) {
  const n = [], o = t.querySelectorAll(e);
  n.push(...Array.from(o));
  const r = t.querySelectorAll("*");
  for (let s = 0; s < r.length; s += 1) {
    const i = r[s];
    if (i.shadowRoot) {
      const a = vt(e, i.shadowRoot);
      n.push(...a);
    }
  }
  return n;
}
function ct(e) {
  if (!e) return document;
  const t = e.getRootNode();
  return t instanceof ShadowRoot || t instanceof Document ? t : document;
}
function Ut(e) {
  const t = Ui.toArray(e);
  return t.length !== 1 || !Zi(t[0]) ? null : t[0];
}
function ra(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = ra(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function st() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = ra(e)) && (o && (o += " "), o += t);
  return o;
}
const zu = {};
function Hu(e) {
  const t = {};
  return e.forEach((n) => {
    Object.entries(n).forEach(([o, r]) => {
      t[o] ? t[o] = st(t[o], r) : t[o] = r;
    });
  }), t;
}
function Tn({ theme: e, classNames: t, props: n, stylesCtx: o }) {
  return Hu((Array.isArray(t) ? t : [t]).map((r) => typeof r == "function" ? r(e, n, o) : r || zu));
}
function io({ theme: e, styles: t, props: n, stylesCtx: o }) {
  const r = Array.isArray(t) ? t : [t], s = {};
  for (const i of r) typeof i == "function" ? Object.assign(s, i(e, n, o)) : i && Object.assign(s, i);
  return s;
}
function ei(e) {
  return e === "auto" || e === "dark" || e === "light";
}
function Vu({ key: e = "mantine-color-scheme-value" } = {}) {
  let t;
  return {
    get: (n) => {
      if (typeof window > "u") return n;
      try {
        const o = window.localStorage.getItem(e);
        return ei(o) ? o : n;
      } catch {
        return n;
      }
    },
    set: (n) => {
      try {
        window.localStorage.setItem(e, n);
      } catch (o) {
        console.warn("[@mantine/core] Local storage color scheme manager was unable to save color scheme.", o);
      }
    },
    subscribe: (n) => {
      t = (o) => {
        o.storageArea === window.localStorage && o.key === e && ei(o.newValue) && n(o.newValue);
      }, window.addEventListener("storage", t);
    },
    unsubscribe: () => {
      window.removeEventListener("storage", t);
    },
    clear: () => {
      window.localStorage.removeItem(e);
    }
  };
}
function Nn(e, t) {
  return typeof e.primaryShade == "number" ? e.primaryShade : t === "dark" ? e.primaryShade.dark : e.primaryShade.light;
}
function ju(e) {
  return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(e);
}
function Gu(e) {
  let t = e.replace("#", "");
  if (t.length === 3) {
    const o = t.split("");
    t = [
      o[0],
      o[0],
      o[1],
      o[1],
      o[2],
      o[2]
    ].join("");
  }
  if (t.length === 8) {
    const o = parseInt(t.slice(6, 8), 16) / 255;
    return {
      r: parseInt(t.slice(0, 2), 16),
      g: parseInt(t.slice(2, 4), 16),
      b: parseInt(t.slice(4, 6), 16),
      a: o
    };
  }
  const n = parseInt(t, 16);
  return {
    r: n >> 16 & 255,
    g: n >> 8 & 255,
    b: n & 255,
    a: 1
  };
}
function Ku(e) {
  const [t, n, o, r] = e.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number);
  return {
    r: t,
    g: n,
    b: o,
    a: r === void 0 ? 1 : r
  };
}
function Uu(e) {
  const t = e.match(/^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i);
  if (!t) return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
  const n = parseInt(t[1], 10), o = parseInt(t[2], 10) / 100, r = parseInt(t[3], 10) / 100, s = t[5] ? parseFloat(t[5]) : void 0, i = (1 - Math.abs(2 * r - 1)) * o, a = n / 60, l = i * (1 - Math.abs(a % 2 - 1)), c = r - i / 2;
  let p, f, u;
  return a >= 0 && a < 1 ? (p = i, f = l, u = 0) : a >= 1 && a < 2 ? (p = l, f = i, u = 0) : a >= 2 && a < 3 ? (p = 0, f = i, u = l) : a >= 3 && a < 4 ? (p = 0, f = l, u = i) : a >= 4 && a < 5 ? (p = l, f = 0, u = i) : (p = i, f = 0, u = l), {
    r: Math.round((p + c) * 255),
    g: Math.round((f + c) * 255),
    b: Math.round((u + c) * 255),
    a: s || 1
  };
}
function Xr(e) {
  return ju(e) ? Gu(e) : e.startsWith("rgb") ? Ku(e) : e.startsWith("hsl") ? Uu(e) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function ur(e) {
  return e <= 0.03928 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
}
function Xu(e) {
  const t = e.match(/oklch\((.*?)%\s/);
  return t ? parseFloat(t[1]) : null;
}
function qu(e) {
  if (e.startsWith("oklch(")) return (Xu(e) || 0) / 100;
  const { r: t, g: n, b: o } = Xr(e), r = t / 255, s = n / 255, i = o / 255, a = ur(r), l = ur(s), c = ur(i);
  return 0.2126 * a + 0.7152 * l + 0.0722 * c;
}
function Sn(e, t = 0.179) {
  return e.startsWith("var(") ? !1 : qu(e) > t;
}
function Xt({ color: e, theme: t, colorScheme: n }) {
  if (typeof e != "string") throw new Error(`[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof e}`);
  if (e === "bright") return {
    color: e,
    value: n === "dark" ? t.white : t.black,
    shade: void 0,
    isThemeColor: !1,
    isLight: Sn(n === "dark" ? t.white : t.black, t.luminanceThreshold),
    variable: "--mantine-color-bright"
  };
  if (e === "dimmed") return {
    color: e,
    value: n === "dark" ? t.colors.dark[2] : t.colors.gray[7],
    shade: void 0,
    isThemeColor: !1,
    isLight: Sn(n === "dark" ? t.colors.dark[2] : t.colors.gray[6], t.luminanceThreshold),
    variable: "--mantine-color-dimmed"
  };
  if (e === "white" || e === "black") return {
    color: e,
    value: e === "white" ? t.white : t.black,
    shade: void 0,
    isThemeColor: !1,
    isLight: Sn(e === "white" ? t.white : t.black, t.luminanceThreshold),
    variable: `--mantine-color-${e}`
  };
  const [o, r] = e.split("."), s = r ? Number(r) : void 0, i = o in t.colors;
  if (i) {
    const a = s !== void 0 ? t.colors[o][s] : t.colors[o][Nn(t, n || "light")];
    return {
      color: o,
      value: a,
      shade: s,
      isThemeColor: i,
      isLight: Sn(a, t.luminanceThreshold),
      variable: r ? `--mantine-color-${o}-${s}` : `--mantine-color-${o}-filled`
    };
  }
  return {
    color: e,
    value: e,
    isThemeColor: i,
    isLight: Sn(e, t.luminanceThreshold),
    shade: s,
    variable: void 0
  };
}
function Ie(e, t) {
  const n = Xt({
    color: e || t.primaryColor,
    theme: t
  });
  return n.variable ? `var(${n.variable})` : e;
}
function qr(e) {
  return !!e && typeof e == "object" && "mantine-virtual-color" in e;
}
function zt(e, t) {
  if (e.startsWith("var(")) return `color-mix(in srgb, ${e}, black ${t * 100}%)`;
  const { r: n, g: o, b: r, a: s } = Xr(e), i = 1 - t, a = (l) => Math.round(l * i);
  return `rgba(${a(n)}, ${a(o)}, ${a(r)}, ${s})`;
}
function Tr(e, t) {
  const n = {
    from: e?.from || t.defaultGradient.from,
    to: e?.to || t.defaultGradient.to,
    deg: e?.deg ?? t.defaultGradient.deg ?? 0
  }, o = Ie(n.from, t), r = Ie(n.to, t);
  return `linear-gradient(${n.deg}deg, ${o} 0%, ${r} 100%)`;
}
function Pt(e, t) {
  if (typeof e != "string" || t > 1 || t < 0) return "rgba(0, 0, 0, 1)";
  if (e.startsWith("var(")) return `color-mix(in srgb, ${e}, transparent ${(1 - t) * 100}%)`;
  if (e.startsWith("oklch"))
    return e.includes("/") ? e.replace(/\/\s*[\d.]+\s*\)/, `/ ${t})`) : e.replace(")", ` / ${t})`);
  const { r: n, g: o, b: r } = Xr(e);
  return `rgba(${n}, ${o}, ${r}, ${t})`;
}
const ti = Pt, Zu = ({ color: e, theme: t, variant: n, gradient: o, autoContrast: r }) => {
  const s = Xt({
    color: e,
    theme: t
  }), i = typeof r == "boolean" ? r : t.autoContrast;
  if (n === "none") return {
    background: "transparent",
    hover: "transparent",
    color: "inherit",
    border: "none"
  };
  if (n === "filled") {
    const a = s.isThemeColor && s.shade === void 0 && qr(t.colors[s.color]), l = i ? a ? `var(--mantine-color-${s.color}-contrast)` : s.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)" : "var(--mantine-color-white)";
    return s.isThemeColor ? s.shade === void 0 ? {
      background: `var(--mantine-color-${e}-filled)`,
      hover: `var(--mantine-color-${e}-filled-hover)`,
      color: l,
      border: `${W(1)} solid transparent`
    } : {
      background: `var(--mantine-color-${s.color}-${s.shade})`,
      hover: `var(--mantine-color-${s.color}-${s.shade === 9 ? 8 : s.shade + 1})`,
      color: l,
      border: `${W(1)} solid transparent`
    } : {
      background: e,
      hover: zt(e, 0.1),
      color: l,
      border: `${W(1)} solid transparent`
    };
  }
  if (n === "light") {
    if (s.isThemeColor) {
      if (s.shade === void 0) return {
        background: `var(--mantine-color-${e}-light)`,
        hover: `var(--mantine-color-${e}-light-hover)`,
        color: `var(--mantine-color-${e}-light-color)`,
        border: `${W(1)} solid transparent`
      };
      const a = t.colors[s.color][s.shade];
      return {
        background: a,
        hover: zt(a, 0.1),
        color: `var(--mantine-color-${s.color}-light-color)`,
        border: `${W(1)} solid transparent`
      };
    }
    return {
      background: Pt(e, 0.1),
      hover: Pt(e, 0.12),
      color: e,
      border: `${W(1)} solid transparent`
    };
  }
  if (n === "outline")
    return s.isThemeColor ? s.shade === void 0 ? {
      background: "transparent",
      hover: `var(--mantine-color-${e}-outline-hover)`,
      color: `var(--mantine-color-${e}-outline)`,
      border: `${W(1)} solid var(--mantine-color-${e}-outline)`
    } : {
      background: "transparent",
      hover: Pt(t.colors[s.color][s.shade], 0.05),
      color: `var(--mantine-color-${s.color}-${s.shade})`,
      border: `${W(1)} solid var(--mantine-color-${s.color}-${s.shade})`
    } : {
      background: "transparent",
      hover: Pt(e, 0.05),
      color: e,
      border: `${W(1)} solid ${e}`
    };
  if (n === "subtle") {
    if (s.isThemeColor) {
      if (s.shade === void 0) return {
        background: "transparent",
        hover: `var(--mantine-color-${e}-light-hover)`,
        color: `var(--mantine-color-${e}-light-color)`,
        border: `${W(1)} solid transparent`
      };
      const a = t.colors[s.color][s.shade];
      return {
        background: "transparent",
        hover: Pt(a, 0.12),
        color: `var(--mantine-color-${s.color}-${Math.min(s.shade, 6)})`,
        border: `${W(1)} solid transparent`
      };
    }
    return {
      background: "transparent",
      hover: Pt(e, 0.12),
      color: e,
      border: `${W(1)} solid transparent`
    };
  }
  return n === "transparent" ? s.isThemeColor ? s.shade === void 0 ? {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${e}-light-color)`,
    border: `${W(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${s.color}-${Math.min(s.shade, 6)})`,
    border: `${W(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: e,
    border: `${W(1)} solid transparent`
  } : n === "white" ? s.isThemeColor ? s.shade === void 0 ? {
    background: "var(--mantine-color-white)",
    hover: zt(t.white, 0.01),
    color: `var(--mantine-color-${e}-filled)`,
    border: `${W(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: zt(t.white, 0.01),
    color: `var(--mantine-color-${s.color}-${s.shade})`,
    border: `${W(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: zt(t.white, 0.01),
    color: e,
    border: `${W(1)} solid transparent`
  } : n === "gradient" ? {
    background: Tr(o, t),
    hover: Tr(o, t),
    color: "var(--mantine-color-white)",
    border: "none"
  } : n === "default" ? {
    background: "var(--mantine-color-default)",
    hover: "var(--mantine-color-default-hover)",
    color: "var(--mantine-color-default-color)",
    border: `${W(1)} solid var(--mantine-color-default-border)`
  } : {};
};
function En({ color: e, theme: t, autoContrast: n, colorScheme: o }) {
  return (typeof n == "boolean" ? n : t.autoContrast) && Xt({
    color: e || t.primaryColor,
    theme: t,
    colorScheme: o
  }).isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function Nr(e, t, n) {
  return En({
    color: n === "dark" ? e.dark : e.light,
    theme: t,
    colorScheme: n,
    autoContrast: !0
  });
}
function ni(e, t) {
  const n = e.colors[e.primaryColor];
  return qr(n) ? e.autoContrast ? Nr(n, e, t) : "var(--mantine-color-white)" : En({
    color: n[Nn(e, t)],
    theme: e,
    autoContrast: null
  });
}
function sa(e, t) {
  return typeof e == "boolean" ? e : t.autoContrast;
}
const ia = mt(null);
function xt() {
  const e = Te(ia);
  if (!e) throw new Error("[@mantine/core] MantineProvider was not found in tree");
  return e;
}
function Ju() {
  return xt().cssVariablesResolver;
}
function Qu() {
  return xt().classNamesPrefix;
}
function Zr() {
  return xt().getStyleNonce;
}
function ed() {
  return xt().withStaticClasses;
}
function td() {
  return xt().headless;
}
function nd() {
  return xt().stylesTransform?.sx;
}
function od() {
  return xt().stylesTransform?.styles;
}
function Jr() {
  return xt().env || "default";
}
function aa() {
  return xt().deduplicateInlineStyles;
}
function ln(e, t) {
  const n = typeof window < "u" && "matchMedia" in window && window.matchMedia("(prefers-color-scheme: dark)")?.matches, o = e !== "auto" ? e : n ? "dark" : "light";
  t()?.setAttribute("data-mantine-color-scheme", o);
}
function rd({ manager: e, defaultColorScheme: t, getRootElement: n, forceColorScheme: o }) {
  const r = Z(null), [s, i] = re(() => e.get(t)), a = o || s, l = de((p) => {
    o || (ln(p, n), i(p), e.set(p));
  }, [
    e.set,
    a,
    o
  ]), c = de(() => {
    i(t), ln(t, n), e.clear();
  }, [e.clear, t]);
  return ce(() => (e.subscribe(l), e.unsubscribe), [e.subscribe, e.unsubscribe]), Ct(() => {
    ln(e.get(t), n);
  }, []), ce(() => {
    if (o)
      return ln(o, n), () => {
      };
    o === void 0 && ln(s, n), typeof window < "u" && "matchMedia" in window && (r.current = window.matchMedia("(prefers-color-scheme: dark)"));
    const p = (f) => {
      s === "auto" && ln(f.matches ? "dark" : "light", n);
    };
    return r.current?.addEventListener("change", p), () => r.current?.removeEventListener("change", p);
  }, [s, o]), {
    colorScheme: a,
    setColorScheme: l,
    clearColorScheme: c
  };
}
const sd = {
  dark: [
    "#C9C9C9",
    "#b8b8b8",
    "#828282",
    "#696969",
    "#424242",
    "#3b3b3b",
    "#2e2e2e",
    "#242424",
    "#1f1f1f",
    "#141414"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
}, oi = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji", Qr = {
  scale: 1,
  fontSmoothing: !0,
  focusRing: "auto",
  white: "#fff",
  black: "#000",
  colors: sd,
  primaryShade: {
    light: 6,
    dark: 8
  },
  primaryColor: "blue",
  variantColorResolver: Zu,
  autoContrast: !1,
  luminanceThreshold: 0.3,
  fontFamily: oi,
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  respectReducedMotion: !1,
  cursorType: "default",
  defaultGradient: {
    from: "blue",
    to: "cyan",
    deg: 45
  },
  defaultRadius: "md",
  activeClassName: "mantine-active",
  focusClassName: "",
  headings: {
    fontFamily: oi,
    fontWeight: "700",
    textWrap: "wrap",
    sizes: {
      h1: {
        fontSize: W(34),
        lineHeight: "1.3"
      },
      h2: {
        fontSize: W(26),
        lineHeight: "1.35"
      },
      h3: {
        fontSize: W(22),
        lineHeight: "1.4"
      },
      h4: {
        fontSize: W(18),
        lineHeight: "1.45"
      },
      h5: {
        fontSize: W(16),
        lineHeight: "1.5"
      },
      h6: {
        fontSize: W(14),
        lineHeight: "1.5"
      }
    }
  },
  fontSizes: {
    xs: W(12),
    sm: W(14),
    md: W(16),
    lg: W(18),
    xl: W(20)
  },
  lineHeights: {
    xs: "1.4",
    sm: "1.45",
    md: "1.55",
    lg: "1.6",
    xl: "1.65"
  },
  fontWeights: {
    regular: "400",
    medium: "600",
    bold: "700"
  },
  radius: {
    xs: W(2),
    sm: W(4),
    md: W(8),
    lg: W(16),
    xl: W(32)
  },
  spacing: {
    xs: W(10),
    sm: W(12),
    md: W(16),
    lg: W(20),
    xl: W(32)
  },
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em"
  },
  shadows: {
    xs: `0 ${W(1)} ${W(3)} rgba(0, 0, 0, 0.05), 0 ${W(1)} ${W(2)} rgba(0, 0, 0, 0.1)`,
    sm: `0 ${W(1)} ${W(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${W(10)} ${W(15)} ${W(-5)}, rgba(0, 0, 0, 0.04) 0 ${W(7)} ${W(7)} ${W(-5)}`,
    md: `0 ${W(1)} ${W(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${W(20)} ${W(25)} ${W(-5)}, rgba(0, 0, 0, 0.04) 0 ${W(10)} ${W(10)} ${W(-5)}`,
    lg: `0 ${W(1)} ${W(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${W(28)} ${W(23)} ${W(-7)}, rgba(0, 0, 0, 0.04) 0 ${W(12)} ${W(12)} ${W(-7)}`,
    xl: `0 ${W(1)} ${W(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${W(36)} ${W(28)} ${W(-7)}, rgba(0, 0, 0, 0.04) 0 ${W(17)} ${W(17)} ${W(-7)}`
  },
  other: {},
  components: {}
}, id = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more – https://mantine.dev/theming/colors/#primary-color", ri = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function dr(e) {
  return e < 0 || e > 9 ? !1 : parseInt(e.toString(), 10) === e;
}
function si(e) {
  if (!(e.primaryColor in e.colors)) throw new Error(id);
  if (typeof e.primaryShade == "object" && (!dr(e.primaryShade.dark) || !dr(e.primaryShade.light)))
    throw new Error(ri);
  if (typeof e.primaryShade == "number" && !dr(e.primaryShade)) throw new Error(ri);
}
function ad(e, t) {
  if (!t)
    return si(e), e;
  const n = Gr(e, t);
  return t.fontFamily && !t.headings?.fontFamily && (n.headings = {
    ...n.headings,
    fontFamily: t.fontFamily
  }), si(n), n;
}
const es = mt(null), ld = () => Te(es) || Qr;
function Xe() {
  const e = Te(es);
  if (!e) throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
  return e;
}
function la({ theme: e, children: t, inherit: n = !0 }) {
  const o = ld(), r = fn(() => ad(n ? o : Qr, e), [
    e,
    o,
    n
  ]);
  return /* @__PURE__ */ g(es, {
    value: r,
    children: t
  });
}
la.displayName = "@mantine/core/MantineThemeProvider";
function fr(e) {
  return Object.entries(e).map(([t, n]) => `${t}: ${n};`).join("");
}
function ca(e, t) {
  const n = t ? [t] : [":root", ":host"], o = fr(e.variables), r = o ? `${n.join(", ")}{${o}}` : "", s = fr(e.dark), i = fr(e.light), a = (l) => n.map((c) => c === ":host" ? `${c}([data-mantine-color-scheme="${l}"])` : `${c}[data-mantine-color-scheme="${l}"]`).join(", ");
  return `${r}

${s ? `${a("dark")}{${s}}` : ""}

${i ? `${a("light")}{${i}}` : ""}`;
}
function Kn({ theme: e, color: t, colorScheme: n, name: o = t, withColorValues: r = !0 }) {
  if (!e.colors[t]) return {};
  if (n === "light") {
    const a = Nn(e, "light"), l = {
      [`--mantine-color-${o}-text`]: `var(--mantine-color-${o}-filled)`,
      [`--mantine-color-${o}-filled`]: `var(--mantine-color-${o}-${a})`,
      [`--mantine-color-${o}-filled-hover`]: `var(--mantine-color-${o}-${a === 9 ? 8 : a + 1})`,
      [`--mantine-color-${o}-light`]: `var(--mantine-color-${o}-1)`,
      [`--mantine-color-${o}-light-hover`]: `var(--mantine-color-${o}-2)`,
      [`--mantine-color-${o}-light-color`]: `var(--mantine-color-${o}-9)`,
      [`--mantine-color-${o}-outline`]: `var(--mantine-color-${o}-${a})`,
      [`--mantine-color-${o}-outline-hover`]: ti(e.colors[t][a], 0.05)
    };
    return r ? {
      [`--mantine-color-${o}-0`]: e.colors[t][0],
      [`--mantine-color-${o}-1`]: e.colors[t][1],
      [`--mantine-color-${o}-2`]: e.colors[t][2],
      [`--mantine-color-${o}-3`]: e.colors[t][3],
      [`--mantine-color-${o}-4`]: e.colors[t][4],
      [`--mantine-color-${o}-5`]: e.colors[t][5],
      [`--mantine-color-${o}-6`]: e.colors[t][6],
      [`--mantine-color-${o}-7`]: e.colors[t][7],
      [`--mantine-color-${o}-8`]: e.colors[t][8],
      [`--mantine-color-${o}-9`]: e.colors[t][9],
      ...l
    } : l;
  }
  const s = Nn(e, "dark"), i = {
    [`--mantine-color-${o}-text`]: `var(--mantine-color-${o}-4)`,
    [`--mantine-color-${o}-filled`]: `var(--mantine-color-${o}-${s})`,
    [`--mantine-color-${o}-filled-hover`]: `var(--mantine-color-${o}-${s === 9 ? 8 : s + 1})`,
    [`--mantine-color-${o}-light`]: zt(e.colors[t][9], 0.5),
    [`--mantine-color-${o}-light-hover`]: zt(e.colors[t][9], 0.3),
    [`--mantine-color-${o}-light-color`]: `var(--mantine-color-${o}-0)`,
    [`--mantine-color-${o}-outline`]: `var(--mantine-color-${o}-${Math.max(s - 4, 0)})`,
    [`--mantine-color-${o}-outline-hover`]: ti(e.colors[t][Math.max(s - 4, 0)], 0.05)
  };
  return r ? {
    [`--mantine-color-${o}-0`]: e.colors[t][0],
    [`--mantine-color-${o}-1`]: e.colors[t][1],
    [`--mantine-color-${o}-2`]: e.colors[t][2],
    [`--mantine-color-${o}-3`]: e.colors[t][3],
    [`--mantine-color-${o}-4`]: e.colors[t][4],
    [`--mantine-color-${o}-5`]: e.colors[t][5],
    [`--mantine-color-${o}-6`]: e.colors[t][6],
    [`--mantine-color-${o}-7`]: e.colors[t][7],
    [`--mantine-color-${o}-8`]: e.colors[t][8],
    [`--mantine-color-${o}-9`]: e.colors[t][9],
    ...i
  } : i;
}
function Wt(e, t, n) {
  xe(t).forEach((o) => Object.assign(e, { [`--mantine-${n}-${o}`]: t[o] }));
}
const ua = (e) => {
  const t = Nn(e, "light"), n = e.defaultRadius in e.radius ? e.radius[e.defaultRadius] : W(e.defaultRadius), o = {
    variables: {
      "--mantine-z-index-app": "100",
      "--mantine-z-index-modal": "200",
      "--mantine-z-index-popover": "300",
      "--mantine-z-index-overlay": "400",
      "--mantine-z-index-max": "9999",
      "--mantine-scale": e.scale.toString(),
      "--mantine-cursor-type": e.cursorType,
      "--mantine-webkit-font-smoothing": e.fontSmoothing ? "antialiased" : "unset",
      "--mantine-moz-font-smoothing": e.fontSmoothing ? "grayscale" : "unset",
      "--mantine-color-white": e.white,
      "--mantine-color-black": e.black,
      "--mantine-line-height": e.lineHeights.md,
      "--mantine-font-family": e.fontFamily,
      "--mantine-font-family-monospace": e.fontFamilyMonospace,
      "--mantine-font-family-headings": e.headings.fontFamily,
      "--mantine-heading-font-weight": e.headings.fontWeight,
      "--mantine-heading-text-wrap": e.headings.textWrap,
      "--mantine-radius-default": n,
      "--mantine-primary-color-filled": `var(--mantine-color-${e.primaryColor}-filled)`,
      "--mantine-primary-color-filled-hover": `var(--mantine-color-${e.primaryColor}-filled-hover)`,
      "--mantine-primary-color-light": `var(--mantine-color-${e.primaryColor}-light)`,
      "--mantine-primary-color-light-hover": `var(--mantine-color-${e.primaryColor}-light-hover)`,
      "--mantine-primary-color-light-color": `var(--mantine-color-${e.primaryColor}-light-color)`
    },
    light: {
      "--mantine-color-scheme": "light",
      "--mantine-primary-color-contrast": ni(e, "light"),
      "--mantine-color-bright": "var(--mantine-color-black)",
      "--mantine-color-text": e.black,
      "--mantine-color-body": e.white,
      "--mantine-color-error": "var(--mantine-color-red-6)",
      "--mantine-color-success": "var(--mantine-color-teal-8)",
      "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
      "--mantine-color-anchor": `var(--mantine-color-${e.primaryColor}-${t})`,
      "--mantine-color-default": "var(--mantine-color-white)",
      "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
      "--mantine-color-default-color": "var(--mantine-color-black)",
      "--mantine-color-default-border": "var(--mantine-color-gray-4)",
      "--mantine-color-dimmed": "var(--mantine-color-gray-6)",
      "--mantine-color-disabled": "var(--mantine-color-gray-2)",
      "--mantine-color-disabled-color": "var(--mantine-color-gray-5)",
      "--mantine-color-disabled-border": "var(--mantine-color-gray-3)"
    },
    dark: {
      "--mantine-color-scheme": "dark",
      "--mantine-primary-color-contrast": ni(e, "dark"),
      "--mantine-color-bright": "var(--mantine-color-white)",
      "--mantine-color-text": "var(--mantine-color-dark-0)",
      "--mantine-color-body": "var(--mantine-color-dark-7)",
      "--mantine-color-error": "var(--mantine-color-red-8)",
      "--mantine-color-success": "var(--mantine-color-teal-8)",
      "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
      "--mantine-color-anchor": `var(--mantine-color-${e.primaryColor}-4)`,
      "--mantine-color-default": "var(--mantine-color-dark-6)",
      "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
      "--mantine-color-default-color": "var(--mantine-color-white)",
      "--mantine-color-default-border": "var(--mantine-color-dark-4)",
      "--mantine-color-dimmed": "var(--mantine-color-dark-2)",
      "--mantine-color-disabled": "var(--mantine-color-dark-6)",
      "--mantine-color-disabled-color": "var(--mantine-color-dark-3)",
      "--mantine-color-disabled-border": "var(--mantine-color-dark-4)"
    }
  };
  Wt(o.variables, e.breakpoints, "breakpoint"), Wt(o.variables, e.spacing, "spacing"), Wt(o.variables, e.fontSizes, "font-size"), Wt(o.variables, e.lineHeights, "line-height"), Wt(o.variables, e.shadows, "shadow"), Wt(o.variables, e.radius, "radius"), Wt(o.variables, e.fontWeights, "font-weight"), e.colors[e.primaryColor].forEach((s, i) => {
    o.variables[`--mantine-primary-color-${i}`] = `var(--mantine-color-${e.primaryColor}-${i})`;
  }), xe(e.colors).forEach((s) => {
    const i = e.colors[s];
    if (qr(i)) {
      Object.assign(o.light, Kn({
        theme: e,
        name: i.name,
        color: i.light,
        colorScheme: "light",
        withColorValues: !0
      })), Object.assign(o.dark, Kn({
        theme: e,
        name: i.name,
        color: i.dark,
        colorScheme: "dark",
        withColorValues: !0
      })), o.light[`--mantine-color-${i.name}-contrast`] = Nr(i, e, "light"), o.dark[`--mantine-color-${i.name}-contrast`] = Nr(i, e, "dark");
      return;
    }
    i.forEach((a, l) => {
      o.variables[`--mantine-color-${s}-${l}`] = a;
    }), Object.assign(o.light, Kn({
      theme: e,
      color: s,
      colorScheme: "light",
      withColorValues: !1
    })), Object.assign(o.dark, Kn({
      theme: e,
      color: s,
      colorScheme: "dark",
      withColorValues: !1
    }));
  });
  const r = e.headings.sizes;
  return xe(r).forEach((s) => {
    o.variables[`--mantine-${s}-font-size`] = r[s].fontSize, o.variables[`--mantine-${s}-line-height`] = r[s].lineHeight, o.variables[`--mantine-${s}-font-weight`] = r[s].fontWeight || e.headings.fontWeight;
  }), o;
};
function cd() {
  const e = Xe(), t = Zr(), n = xe(e.breakpoints).reduce((o, r) => {
    const s = e.breakpoints[r].includes("px"), i = Mn(e.breakpoints[r]);
    return `${o}@media (max-width: ${s ? `${i - 0.1}px` : Zs(i - 0.1)}) {.mantine-visible-from-${r} {display: none !important;}}@media (min-width: ${s ? `${i}px` : Zs(i)}) {.mantine-hidden-from-${r} {display: none !important;}}`;
  }, "");
  return /* @__PURE__ */ g("style", {
    "data-mantine-styles": "classes",
    nonce: t?.(),
    dangerouslySetInnerHTML: { __html: n }
  });
}
function ud({ theme: e, generator: t }) {
  const n = ua(e), o = t?.(e);
  return o ? Gr(n, o) : n;
}
const pr = ua(Qr);
function dd(e) {
  const t = {
    variables: {},
    light: {},
    dark: {}
  };
  return xe(e.variables).forEach((n) => {
    pr.variables[n] !== e.variables[n] && (t.variables[n] = e.variables[n]);
  }), xe(e.light).forEach((n) => {
    pr.light[n] !== e.light[n] && (t.light[n] = e.light[n]);
  }), xe(e.dark).forEach((n) => {
    pr.dark[n] !== e.dark[n] && (t.dark[n] = e.dark[n]);
  }), t;
}
function fd(e) {
  return ca({
    variables: {},
    dark: { "--mantine-color-scheme": "dark" },
    light: { "--mantine-color-scheme": "light" }
  }, e);
}
function da({ cssVariablesSelector: e, deduplicateCssVariables: t }) {
  const n = Xe(), o = Zr(), r = Ju(), s = ud({
    theme: n,
    generator: r
  }), i = (e === void 0 || e === ":root" || e === ":host") && t, a = i ? dd(s) : s, l = ca(a, e);
  return l ? /* @__PURE__ */ g("style", {
    "data-mantine-styles": !0,
    nonce: o?.(),
    dangerouslySetInnerHTML: { __html: `${l}${i ? "" : fd(e)}` }
  }) : null;
}
da.displayName = "@mantine/CssVariables";
function pd({ respectReducedMotion: e, getRootElement: t }) {
  Ct(() => {
    e && t()?.setAttribute("data-respect-reduced-motion", "true");
  }, [e]);
}
function fa({ theme: e, children: t, getStyleNonce: n, withStaticClasses: o = !0, withGlobalClasses: r = !0, deduplicateCssVariables: s = !0, withCssVariables: i = !0, cssVariablesSelector: a, classNamesPrefix: l = "mantine", colorSchemeManager: c = Vu(), defaultColorScheme: p = "light", getRootElement: f = () => document.documentElement, cssVariablesResolver: u, forceColorScheme: d, stylesTransform: m, env: h, deduplicateInlineStyles: v = !1 }) {
  const { colorScheme: y, setColorScheme: _, clearColorScheme: w } = rd({
    defaultColorScheme: p,
    forceColorScheme: d,
    manager: c,
    getRootElement: f
  });
  return pd({
    respectReducedMotion: e?.respectReducedMotion || !1,
    getRootElement: f
  }), /* @__PURE__ */ g(ia, {
    value: {
      colorScheme: y,
      setColorScheme: _,
      clearColorScheme: w,
      getRootElement: f,
      classNamesPrefix: l,
      getStyleNonce: n,
      cssVariablesResolver: u,
      cssVariablesSelector: a ?? ":root",
      withStaticClasses: o,
      stylesTransform: m,
      env: h,
      deduplicateInlineStyles: v
    },
    children: /* @__PURE__ */ oe(la, {
      theme: e,
      children: [
        i && /* @__PURE__ */ g(da, {
          cssVariablesSelector: a,
          deduplicateCssVariables: s
        }),
        r && /* @__PURE__ */ g(cd, {}),
        t
      ]
    })
  });
}
fa.displayName = "@mantine/core/MantineProvider";
function K(e, t, n) {
  const o = Xe(), r = (Array.isArray(e) ? e : [e]).filter(Boolean);
  let s = {};
  for (const i of r) {
    const a = o.components[i]?.defaultProps, l = typeof a == "function" ? a(o) : a;
    l && (s = {
      ...s,
      ...l
    });
  }
  return {
    ...t,
    ...s,
    ...Et(n)
  };
}
function gn({ classNames: e, styles: t, props: n, stylesCtx: o }) {
  const r = Xe();
  return {
    resolvedClassNames: e === void 0 ? void 0 : Tn({
      theme: r,
      classNames: e,
      props: n,
      stylesCtx: o || void 0
    }),
    resolvedStyles: t === void 0 ? void 0 : io({
      theme: r,
      styles: t,
      props: n,
      stylesCtx: o || void 0
    })
  };
}
const md = {
  always: "mantine-focus-always",
  auto: "mantine-focus-auto",
  never: "mantine-focus-never"
};
function hd({ theme: e, options: t, unstyled: n }) {
  return st(t?.focusable && !n && (e.focusClassName || md[e.focusRing]), t?.active && !n && e.activeClassName);
}
function gd({ selector: e, stylesCtx: t, options: n, props: o, theme: r }) {
  return Tn({
    theme: r,
    classNames: n?.classNames,
    props: n?.props || o,
    stylesCtx: t
  })[e];
}
function vd({ selector: e, stylesCtx: t, theme: n, classNames: o, props: r }) {
  return Tn({
    theme: n,
    classNames: o,
    props: r,
    stylesCtx: t
  })[e];
}
function yd({ rootSelector: e, selector: t, className: n }) {
  return e === t ? n : void 0;
}
function bd({ selector: e, classes: t, unstyled: n }) {
  return n ? void 0 : t[e];
}
function wd({ themeName: e, classNamesPrefix: t, selector: n, withStaticClass: o }) {
  return o === !1 ? [] : e.map((r) => `${t}-${r}-${n}`);
}
function Cd({ options: e, classes: t, selector: n, unstyled: o }) {
  return e?.variant && !o ? t[`${n}--${e.variant}`] : void 0;
}
function _d({ theme: e, options: t, themeName: n, selector: o, classNamesPrefix: r, resolvedClassNames: s, resolvedThemeClassNames: i, classes: a, unstyled: l, className: c, rootSelector: p, props: f, stylesCtx: u, withStaticClasses: d, headless: m, transformedStyles: h }) {
  return st(hd({
    theme: e,
    options: t,
    unstyled: l || m
  }), i.map((v) => v[o]), Cd({
    options: t,
    classes: a,
    selector: o,
    unstyled: l || m
  }), s[o], vd({
    selector: o,
    stylesCtx: u,
    theme: e,
    classNames: h,
    props: f
  }), gd({
    selector: o,
    stylesCtx: u,
    options: t,
    props: f,
    theme: e
  }), yd({
    rootSelector: p,
    selector: o,
    className: c
  }), bd({
    selector: o,
    classes: a,
    unstyled: l || m
  }), d && !m && wd({
    themeName: n,
    classNamesPrefix: r,
    selector: o,
    withStaticClass: t?.withStaticClass
  }), t?.className);
}
function ts({ style: e, theme: t }) {
  return Array.isArray(e) ? e.reduce((n, o) => ({
    ...n,
    ...ts({
      style: o,
      theme: t
    })
  }), {}) : typeof e == "function" ? e(t) : e ?? {};
}
function xd({ theme: e, selector: t, options: n, props: o, stylesCtx: r, rootSelector: s, withStylesTransform: i, resolvedStyles: a, resolvedThemeStyles: l, resolvedVars: c, resolvedRootStyle: p }) {
  return {
    ...l[t],
    ...a[t],
    ...!i && io({
      theme: e,
      styles: n?.styles,
      props: n?.props || o,
      stylesCtx: r
    })[t],
    ...c[t],
    ...s === t ? p : null,
    ...ts({
      style: n?.style,
      theme: e
    })
  };
}
function Sd(e) {
  return e.reduce((t, n) => (n && Object.keys(n).forEach((o) => {
    t[o] = {
      ...t[o],
      ...Et(n[o])
    };
  }), t), {});
}
function Rd({ props: e, stylesCtx: t, themeName: n, theme: o }) {
  const r = od()?.();
  return {
    getTransformedStyles: (i) => r ? [...i.map((a) => r(a, {
      props: e,
      theme: o,
      ctx: t
    })), ...n.map((a) => r(o.components[a]?.styles, {
      props: e,
      theme: o,
      ctx: t
    }))].filter(Boolean) : [],
    withStylesTransform: !!r
  };
}
function se({ name: e, classes: t, props: n, stylesCtx: o, className: r, style: s, rootSelector: i = "root", unstyled: a, classNames: l, styles: c, vars: p, varsResolver: f, attributes: u }) {
  const d = Xe(), m = Qu(), h = ed(), v = td(), y = (Array.isArray(e) ? e : [e]).filter((E) => E), { withStylesTransform: _, getTransformedStyles: w } = Rd({
    props: n,
    stylesCtx: o,
    themeName: y,
    theme: d
  }), x = Tn({
    theme: d,
    classNames: l,
    props: n,
    stylesCtx: o
  }), C = y.map((E) => Tn({
    theme: d,
    classNames: d.components[E]?.classNames,
    props: n,
    stylesCtx: o
  })), $ = _ ? {} : io({
    theme: d,
    styles: c,
    props: n,
    stylesCtx: o
  }), M = {};
  if (!_) for (const E of y) {
    const O = io({
      theme: d,
      styles: d.components[E]?.styles,
      props: n,
      stylesCtx: o
    });
    for (const B of Object.keys(O)) M[B] = {
      ...M[B],
      ...O[B]
    };
  }
  const N = Sd([
    v ? {} : f?.(d, n, o),
    ...y.map((E) => d.components?.[E]?.vars?.(d, n, o)),
    p?.(d, n, o)
  ]), I = ts({
    style: s,
    theme: d
  });
  return (E, O) => ({
    ...u?.[E],
    className: _d({
      theme: d,
      options: O,
      themeName: y,
      selector: E,
      classNamesPrefix: m,
      resolvedClassNames: x,
      resolvedThemeClassNames: C,
      classes: t,
      unstyled: a,
      className: r,
      rootSelector: i,
      props: n,
      stylesCtx: o,
      withStaticClasses: h,
      headless: v,
      transformedStyles: w([O?.styles, c])
    }),
    style: xd({
      theme: d,
      selector: E,
      options: O,
      props: n,
      stylesCtx: o,
      rootSelector: i,
      withStylesTransform: _,
      resolvedStyles: $,
      resolvedThemeStyles: M,
      resolvedVars: N,
      resolvedRootStyle: I
    })
  });
}
function $n(e) {
  return xe(e).reduce((t, n) => e[n] !== void 0 ? `${t}${uu(n)}:${e[n]};` : t, "").trim();
}
function Dd({ selector: e, styles: t, media: n, container: o }) {
  const r = t ? $n(t) : "", s = Array.isArray(n) ? n.map((a) => `@media${a.query}{${e}{${$n(a.styles)}}}`) : [], i = Array.isArray(o) ? o.map((a) => `@container ${a.query}{${e}{${$n(a.styles)}}}`) : [];
  return `${r ? `${e}{${r}}` : ""}${s.join("")}${i.join("")}`.trim();
}
function $d(e) {
  let t = 5381;
  for (let n = 0; n < e.length; n++) t = (t << 5) + t + e.charCodeAt(n) & 4294967295;
  return (t >>> 0).toString(36);
}
function vn({ deduplicate: e, ...t }) {
  const n = Zr(), o = Dd(t);
  return e ? /* @__PURE__ */ g("style", {
    href: `mantine-${$d(o)}`,
    precedence: "mantine",
    nonce: n?.(),
    children: o
  }) : /* @__PURE__ */ g("style", {
    "data-mantine-styles": "inline",
    nonce: n?.(),
    dangerouslySetInnerHTML: { __html: o }
  });
}
function Pd(e) {
  let t = 5381;
  for (let n = 0; n < e.length; n++) t = (t << 5) + t + e.charCodeAt(n) & 4294967295;
  return (t >>> 0).toString(36);
}
function pa(e, t) {
  return `__mdi__-${Pd(`${e ? $n(e) : ""}|${Array.isArray(t) ? t.map((n) => `${n.query}:${$n(n.styles)}`).join("|") : ""}`)}`;
}
function bo(e) {
  const { m: t, mx: n, my: o, mt: r, mb: s, ml: i, mr: a, me: l, ms: c, mis: p, mie: f, p: u, px: d, py: m, pt: h, pb: v, pl: y, pr: _, pe: w, ps: x, pis: C, pie: $, bd: M, bdrs: N, bg: I, c: E, opacity: O, ff: B, fz: A, fw: S, lts: k, ta: R, lh: D, fs: b, tt: T, td: P, w: F, miw: L, maw: Y, h: z, mih: V, mah: U, bgsz: ee, bgp: X, bgr: G, bga: J, pos: ie, top: ae, left: ne, bottom: ue, right: le, inset: Q, display: me, flex: be, hiddenFrom: Re, visibleFrom: Ne, lightHidden: We, darkHidden: ke, sx: Ge, ...ge } = e;
  return {
    styleProps: Et({
      m: t,
      mx: n,
      my: o,
      mt: r,
      mb: s,
      ml: i,
      mr: a,
      me: l,
      ms: c,
      mis: p,
      mie: f,
      p: u,
      px: d,
      py: m,
      pt: h,
      pb: v,
      pl: y,
      pr: _,
      pis: C,
      pie: $,
      pe: w,
      ps: x,
      bd: M,
      bg: I,
      c: E,
      opacity: O,
      ff: B,
      fz: A,
      fw: S,
      lts: k,
      ta: R,
      lh: D,
      fs: b,
      tt: T,
      td: P,
      w: F,
      miw: L,
      maw: Y,
      h: z,
      mih: V,
      mah: U,
      bgsz: ee,
      bgp: X,
      bgr: G,
      bga: J,
      pos: ie,
      top: ae,
      left: ne,
      bottom: ue,
      right: le,
      inset: Q,
      display: me,
      flex: be,
      bdrs: N,
      hiddenFrom: Re,
      visibleFrom: Ne,
      lightHidden: We,
      darkHidden: ke,
      sx: Ge
    }),
    rest: ge
  };
}
const Md = {
  m: {
    type: "spacing",
    property: "margin"
  },
  mt: {
    type: "spacing",
    property: "marginTop"
  },
  mb: {
    type: "spacing",
    property: "marginBottom"
  },
  ml: {
    type: "spacing",
    property: "marginLeft"
  },
  mr: {
    type: "spacing",
    property: "marginRight"
  },
  ms: {
    type: "spacing",
    property: "marginInlineStart"
  },
  me: {
    type: "spacing",
    property: "marginInlineEnd"
  },
  mis: {
    type: "spacing",
    property: "marginInlineStart"
  },
  mie: {
    type: "spacing",
    property: "marginInlineEnd"
  },
  mx: {
    type: "spacing",
    property: "marginInline"
  },
  my: {
    type: "spacing",
    property: "marginBlock"
  },
  p: {
    type: "spacing",
    property: "padding"
  },
  pt: {
    type: "spacing",
    property: "paddingTop"
  },
  pb: {
    type: "spacing",
    property: "paddingBottom"
  },
  pl: {
    type: "spacing",
    property: "paddingLeft"
  },
  pr: {
    type: "spacing",
    property: "paddingRight"
  },
  ps: {
    type: "spacing",
    property: "paddingInlineStart"
  },
  pe: {
    type: "spacing",
    property: "paddingInlineEnd"
  },
  pis: {
    type: "spacing",
    property: "paddingInlineStart"
  },
  pie: {
    type: "spacing",
    property: "paddingInlineEnd"
  },
  px: {
    type: "spacing",
    property: "paddingInline"
  },
  py: {
    type: "spacing",
    property: "paddingBlock"
  },
  bd: {
    type: "border",
    property: "border"
  },
  bdrs: {
    type: "radius",
    property: "borderRadius"
  },
  bg: {
    type: "color",
    property: "background"
  },
  c: {
    type: "textColor",
    property: "color"
  },
  opacity: {
    type: "identity",
    property: "opacity"
  },
  ff: {
    type: "fontFamily",
    property: "fontFamily"
  },
  fz: {
    type: "fontSize",
    property: "fontSize"
  },
  fw: {
    type: "identity",
    property: "fontWeight"
  },
  lts: {
    type: "size",
    property: "letterSpacing"
  },
  ta: {
    type: "identity",
    property: "textAlign"
  },
  lh: {
    type: "lineHeight",
    property: "lineHeight"
  },
  fs: {
    type: "identity",
    property: "fontStyle"
  },
  tt: {
    type: "identity",
    property: "textTransform"
  },
  td: {
    type: "identity",
    property: "textDecoration"
  },
  w: {
    type: "spacing",
    property: "width"
  },
  miw: {
    type: "spacing",
    property: "minWidth"
  },
  maw: {
    type: "spacing",
    property: "maxWidth"
  },
  h: {
    type: "spacing",
    property: "height"
  },
  mih: {
    type: "spacing",
    property: "minHeight"
  },
  mah: {
    type: "spacing",
    property: "maxHeight"
  },
  bgsz: {
    type: "size",
    property: "backgroundSize"
  },
  bgp: {
    type: "identity",
    property: "backgroundPosition"
  },
  bgr: {
    type: "identity",
    property: "backgroundRepeat"
  },
  bga: {
    type: "identity",
    property: "backgroundAttachment"
  },
  pos: {
    type: "identity",
    property: "position"
  },
  top: {
    type: "size",
    property: "top"
  },
  left: {
    type: "size",
    property: "left"
  },
  bottom: {
    type: "size",
    property: "bottom"
  },
  right: {
    type: "size",
    property: "right"
  },
  inset: {
    type: "size",
    property: "inset"
  },
  display: {
    type: "identity",
    property: "display"
  },
  flex: {
    type: "identity",
    property: "flex"
  }
};
function ns(e, t) {
  const n = Xt({
    color: e,
    theme: t
  });
  return n.color === "dimmed" ? "var(--mantine-color-dimmed)" : n.color === "bright" ? "var(--mantine-color-bright)" : n.variable ? `var(${n.variable})` : n.color;
}
function Td(e, t) {
  const n = Xt({
    color: e,
    theme: t
  });
  return n.isThemeColor && n.shade === void 0 ? `var(--mantine-color-${n.color}-text)` : ns(e, t);
}
function Nd(e, t) {
  if (typeof e == "number") return W(e);
  if (typeof e == "string") {
    const [n, o, ...r] = e.split(" ").filter((i) => i.trim() !== "");
    let s = `${W(n)}`;
    return o && (s += ` ${o}`), r.length > 0 && (s += ` ${ns(r.join(" "), t)}`), s.trim();
  }
  return e;
}
const ii = {
  text: "var(--mantine-font-family)",
  mono: "var(--mantine-font-family-monospace)",
  monospace: "var(--mantine-font-family-monospace)",
  heading: "var(--mantine-font-family-headings)",
  headings: "var(--mantine-font-family-headings)"
};
function kd(e) {
  return typeof e == "string" && e in ii ? ii[e] : e;
}
const Ld = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6"
];
function Ed(e, t) {
  return typeof e == "string" && e in t.fontSizes ? `var(--mantine-font-size-${e})` : typeof e == "string" && Ld.includes(e) ? `var(--mantine-${e}-font-size)` : typeof e == "number" || typeof e == "string" ? W(e) : e;
}
function Od(e) {
  return e;
}
const Ad = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6"
];
function Id(e, t) {
  return typeof e == "string" && e in t.lineHeights ? `var(--mantine-line-height-${e})` : typeof e == "string" && Ad.includes(e) ? `var(--mantine-${e}-line-height)` : e;
}
function Yd(e, t) {
  return typeof e == "string" && e in t.radius ? `var(--mantine-radius-${e})` : typeof e == "number" || typeof e == "string" ? W(e) : e;
}
function Fd(e) {
  return typeof e == "number" ? W(e) : e;
}
function Wd(e, t) {
  if (typeof e == "number") return W(e);
  if (typeof e == "string") {
    const n = e.replace("-", "");
    if (!(n in t.spacing)) return W(e);
    const o = `--mantine-spacing-${n}`;
    return e.startsWith("-") ? `calc(var(${o}) * -1)` : `var(${o})`;
  }
  return e;
}
const mr = {
  color: ns,
  textColor: Td,
  fontSize: Ed,
  spacing: Wd,
  radius: Yd,
  identity: Od,
  size: Fd,
  lineHeight: Id,
  fontFamily: kd,
  border: Nd
};
function ai(e) {
  return e.replace("(min-width: ", "").replace("em)", "");
}
function Bd({ media: e, ...t }) {
  const n = Object.keys(e).sort((o, r) => Number(ai(o)) - Number(ai(r))).map((o) => ({
    query: o,
    styles: e[o]
  }));
  return {
    ...t,
    media: n
  };
}
function zd(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = Object.keys(e);
  return !(t.length === 1 && t[0] === "base");
}
function Hd(e) {
  return typeof e == "object" && e !== null ? "base" in e ? e.base : void 0 : e;
}
function Vd(e) {
  return typeof e == "object" && e !== null ? xe(e).filter((t) => t !== "base") : [];
}
function jd(e, t) {
  return typeof e == "object" && e !== null && t in e ? e[t] : e;
}
function ma({ styleProps: e, data: t, theme: n }) {
  return Bd(xe(e).reduce((o, r) => {
    if (r === "hiddenFrom" || r === "visibleFrom" || r === "sx") return o;
    const s = t[r], i = Array.isArray(s.property) ? s.property : [s.property], a = Hd(e[r]);
    if (!zd(e[r]))
      return i.forEach((c) => {
        o.inlineStyles[c] = mr[s.type](a, n);
      }), o;
    o.hasResponsiveStyles = !0;
    const l = Vd(e[r]);
    return i.forEach((c) => {
      a != null && (o.styles[c] = mr[s.type](a, n)), l.forEach((p) => {
        const f = `(min-width: ${n.breakpoints[p]})`;
        o.media[f] = {
          ...o.media[f],
          [c]: mr[s.type](jd(e[r], p), n)
        };
      });
    }), o;
  }, {
    hasResponsiveStyles: !1,
    styles: {},
    inlineStyles: {},
    media: {}
  }));
}
function On() {
  return `__m__-${ho().replace(/[:«»]/g, "")}`;
}
function ha(e, t) {
  return Array.isArray(e) ? [...e].reduce((n, o) => ({
    ...n,
    ...ha(o, t)
  }), {}) : typeof e == "function" ? e(t) : e ?? {};
}
function Gd(e) {
  return e;
}
const Kd = Gd;
function ga(e) {
  return e;
}
function te(e) {
  const t = e;
  return t.extend = ga, t.withProps = (n) => {
    const o = (r) => /* @__PURE__ */ g(t, {
      ...n,
      ...r
    });
    return o.extend = t.extend, o.displayName = `WithProps(${t.displayName})`, o;
  }, t;
}
function os(e) {
  return te(e);
}
function it(e) {
  const t = e;
  return t.withProps = (n) => {
    const o = (r) => /* @__PURE__ */ g(t, {
      ...n,
      ...r
    });
    return o.extend = t.extend, o.displayName = `WithProps(${t.displayName})`, o;
  }, t.extend = ga, t;
}
function va(e) {
  return `data-${(e.startsWith("data-") ? e.slice(5) : e).replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
}
function Ud(e) {
  return Object.keys(e).reduce((t, n) => {
    const o = e[n];
    return o === void 0 || o === "" || o === !1 || o === null || (t[va(n)] = e[n]), t;
  }, {});
}
function ya(e) {
  return e ? typeof e == "string" ? { [va(e)]: !0 } : Array.isArray(e) ? [...e].reduce((t, n) => ({
    ...t,
    ...ya(n)
  }), {}) : Ud(e) : null;
}
function kr(e, t) {
  return Array.isArray(e) ? [...e].reduce((n, o) => ({
    ...n,
    ...kr(o, t)
  }), {}) : typeof e == "function" ? e(t) : e ?? {};
}
function Xd({ theme: e, style: t, vars: n, styleProps: o }) {
  const r = kr(t, e), s = kr(n, e);
  return {
    ...r,
    ...s,
    ...o
  };
}
function ba({ component: e, style: t, __vars: n, className: o, variant: r, mod: s, size: i, hiddenFrom: a, visibleFrom: l, lightHidden: c, darkHidden: p, renderRoot: f, __size: u, ref: d, ...m }) {
  const h = Xe(), v = e || "div", { styleProps: y, rest: _ } = bo(m), w = nd()?.()?.(y.sx), x = On(), C = ma({
    styleProps: y,
    theme: h,
    data: Md
  }), $ = aa(), M = $ && C.hasResponsiveStyles ? pa(C.styles, C.media) : x, N = {
    ref: d,
    style: Xd({
      theme: h,
      style: t,
      vars: n,
      styleProps: C.inlineStyles
    }),
    className: st(o, w, {
      [M]: C.hasResponsiveStyles,
      "mantine-light-hidden": c,
      "mantine-dark-hidden": p,
      [`mantine-hidden-from-${a}`]: a,
      [`mantine-visible-from-${l}`]: l
    }),
    "data-variant": r,
    "data-size": qi(i) ? void 0 : i || void 0,
    size: u,
    ...ya(s),
    ..._
  };
  return /* @__PURE__ */ oe(Pe, { children: [C.hasResponsiveStyles && /* @__PURE__ */ g(vn, {
    selector: `.${M}`,
    styles: C.styles,
    media: C.media,
    deduplicate: $
  }), typeof f == "function" ? f(N) : /* @__PURE__ */ g(v, { ...N })] });
}
ba.displayName = "@mantine/core/Box";
const q = Kd(ba), qd = mt({
  dir: "ltr",
  toggleDirection: () => {
  },
  setDirection: () => {
  }
});
function An() {
  return Te(qd);
}
const [Zd, Qe] = hn("ScrollArea.Root component was not found in tree");
function kt(e, t) {
  const n = po(t);
  Ct(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e]);
}
function Jd(e) {
  const { style: t, ...n } = e, o = Qe(), [r, s] = re(0), [i, a] = re(0), l = !!(r && i);
  return kt(o.scrollbarX, () => {
    const c = o.scrollbarX?.offsetHeight || 0;
    o.onCornerHeightChange(c), a(c);
  }), kt(o.scrollbarY, () => {
    const c = o.scrollbarY?.offsetWidth || 0;
    o.onCornerWidthChange(c), s(c);
  }), l ? /* @__PURE__ */ g("div", {
    ...n,
    style: {
      ...t,
      width: r,
      height: i
    }
  }) : null;
}
function Qd(e) {
  const t = Qe(), n = !!(t.scrollbarX && t.scrollbarY);
  return t.type !== "scroll" && n ? /* @__PURE__ */ g(Jd, { ...e }) : null;
}
const ef = {
  scrollHideDelay: 1e3,
  type: "hover"
};
function wa(e) {
  const { type: t, scrollHideDelay: n, scrollbars: o, getStyles: r, ref: s, ...i } = K("ScrollAreaRoot", ef, e), [a, l] = re(null), [c, p] = re(null), [f, u] = re(null), [d, m] = re(null), [h, v] = re(null), [y, _] = re(0), [w, x] = re(0), [C, $] = re(!1), [M, N] = re(!1), I = Me(s, l);
  return /* @__PURE__ */ g(Zd, {
    value: {
      type: t,
      scrollHideDelay: n,
      scrollArea: a,
      viewport: c,
      onViewportChange: p,
      content: f,
      onContentChange: u,
      scrollbarX: d,
      onScrollbarXChange: m,
      scrollbarXEnabled: C,
      onScrollbarXEnabledChange: $,
      scrollbarY: h,
      onScrollbarYChange: v,
      scrollbarYEnabled: M,
      onScrollbarYEnabledChange: N,
      onCornerWidthChange: _,
      onCornerHeightChange: x,
      getStyles: r
    },
    children: /* @__PURE__ */ g(q, {
      ...i,
      ref: I,
      __vars: {
        "--sa-corner-width": o !== "xy" ? "0px" : `${y}px`,
        "--sa-corner-height": o !== "xy" ? "0px" : `${w}px`
      }
    })
  });
}
wa.displayName = "@mantine/core/ScrollAreaRoot";
function Ca(e, t) {
  const n = e / t;
  return Number.isNaN(n) ? 0 : n;
}
function wo(e) {
  const t = Ca(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function _a(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function tf(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function li(e, t, n = "ltr") {
  const o = wo(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, s = t.scrollbar.size - r, i = t.content - t.viewport, a = s - o, l = tf(e, n === "ltr" ? [0, i] : [i * -1, 0]);
  return _a([0, i], [0, a])(l);
}
function nf(e, t, n, o = "ltr") {
  const r = wo(n), s = r / 2, i = t || s, a = r - i, l = n.scrollbar.paddingStart + i, c = n.scrollbar.size - n.scrollbar.paddingEnd - a, p = n.content - n.viewport, f = o === "ltr" ? [0, p] : [p * -1, 0];
  return _a([l, c], f)(e);
}
function xa(e, t) {
  return e > 0 && e < t;
}
function Mt(e) {
  return e ? parseInt(e, 10) : 0;
}
function Vt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return (o) => {
    e?.(o), (n === !1 || !o.defaultPrevented) && t?.(o);
  };
}
const [of, Sa] = hn("ScrollAreaScrollbar was not found in tree");
function Ra(e) {
  const { sizes: t, hasThumb: n, onThumbChange: o, onThumbPointerUp: r, onThumbPointerDown: s, onThumbPositionChange: i, onDragScroll: a, onWheelScroll: l, onResize: c, ref: p, ...f } = e, u = Qe(), [d, m] = re(null), h = Me(p, m), v = Z(null), y = Z(""), { viewport: _ } = u, w = t.content - t.viewport, x = po(l), C = un(i), $ = vo(c, 10), M = (N) => {
    if (v.current) {
      const I = N.clientX - v.current.left, E = N.clientY - v.current.top;
      a({
        x: I,
        y: E
      });
    }
  };
  return ce(() => {
    const N = (I) => {
      const E = I.target;
      d?.contains(E) && x(I, w);
    };
    return document.addEventListener("wheel", N, { passive: !1 }), () => document.removeEventListener("wheel", N, { passive: !1 });
  }, [
    _,
    d,
    w
  ]), ce(C, [t, C]), kt(d, $), kt(u.content, $), /* @__PURE__ */ g(of, {
    value: {
      scrollbar: d,
      hasThumb: n,
      onThumbChange: un(o),
      onThumbPointerUp: un(r),
      onThumbPositionChange: C,
      onThumbPointerDown: un(s)
    },
    children: /* @__PURE__ */ g("div", {
      ...f,
      ref: h,
      "data-mantine-scrollbar": !0,
      style: {
        position: "absolute",
        ...f.style
      },
      onPointerDown: Vt(e.onPointerDown, (N) => {
        N.preventDefault(), N.button === 0 && (N.target.setPointerCapture(N.pointerId), v.current = d.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", M(N));
      }),
      onPointerMove: Vt(e.onPointerMove, M),
      onPointerUp: Vt(e.onPointerUp, (N) => {
        const I = N.target;
        I.hasPointerCapture(N.pointerId) && (N.preventDefault(), I.releasePointerCapture(N.pointerId));
      }),
      onLostPointerCapture: () => {
        document.body.style.webkitUserSelect = y.current, v.current = null;
      }
    })
  });
}
const Da = (e) => {
  const { sizes: t, onSizesChange: n, style: o, ref: r, ...s } = e, i = Qe(), [a, l] = re(), c = Z(null), p = Me(r, c, i.onScrollbarXChange);
  return ce(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ g(Ra, {
    "data-orientation": "horizontal",
    ...s,
    ref: p,
    sizes: t,
    style: {
      ...o,
      "--sa-thumb-width": `${wo(t)}px`
    },
    onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
    onDragScroll: (f) => e.onDragScroll(f.x),
    onWheelScroll: (f, u) => {
      if (i.viewport) {
        const d = i.viewport.scrollLeft + f.deltaX;
        e.onWheelScroll(d), xa(d, u) && f.preventDefault();
      }
    },
    onResize: () => {
      c.current && i.viewport && a && n({
        content: i.viewport.scrollWidth,
        viewport: i.viewport.offsetWidth,
        scrollbar: {
          size: c.current.clientWidth,
          paddingStart: Mt(a.paddingLeft),
          paddingEnd: Mt(a.paddingRight)
        }
      });
    }
  });
};
Da.displayName = "@mantine/core/ScrollAreaScrollbarX";
function $a(e) {
  const { sizes: t, onSizesChange: n, style: o, ref: r, ...s } = e, i = Qe(), [a, l] = re(), c = Z(null), p = Me(r, c, i.onScrollbarYChange);
  return ce(() => {
    c.current && l(window.getComputedStyle(c.current));
  }, []), /* @__PURE__ */ g(Ra, {
    ...s,
    "data-orientation": "vertical",
    ref: p,
    sizes: t,
    style: {
      "--sa-thumb-height": `${wo(t)}px`,
      ...o
    },
    onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
    onDragScroll: (f) => e.onDragScroll(f.y),
    onWheelScroll: (f, u) => {
      if (i.viewport) {
        const d = i.viewport.scrollTop + f.deltaY;
        e.onWheelScroll(d), xa(d, u) && f.preventDefault();
      }
    },
    onResize: () => {
      c.current && i.viewport && a && n({
        content: i.viewport.scrollHeight,
        viewport: i.viewport.offsetHeight,
        scrollbar: {
          size: c.current.clientHeight,
          paddingStart: Mt(a.paddingTop),
          paddingEnd: Mt(a.paddingBottom)
        }
      });
    }
  });
}
$a.displayName = "@mantine/core/ScrollAreaScrollbarY";
function Co(e) {
  const { orientation: t = "vertical", ...n } = e, { dir: o } = An(), r = Qe(), s = Z(null), i = Z(0), [a, l] = re({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), c = Ca(a.viewport, a.content), p = {
    ...n,
    sizes: a,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (u) => {
      s.current = u;
    },
    onThumbPointerUp: () => {
      i.current = 0;
    },
    onThumbPointerDown: (u) => {
      i.current = u;
    }
  }, f = (u, d) => nf(u, i.current, a, d);
  return t === "horizontal" ? /* @__PURE__ */ g(Da, {
    ...p,
    onThumbPositionChange: () => {
      if (r.viewport && s.current) {
        const u = r.viewport.scrollLeft, d = li(u, a, o);
        s.current.style.transform = `translate3d(${d}px, 0, 0)`;
      }
    },
    onWheelScroll: (u) => {
      r.viewport && (r.viewport.scrollLeft = u);
    },
    onDragScroll: (u) => {
      r.viewport && (r.viewport.scrollLeft = f(u, o));
    }
  }) : t === "vertical" ? /* @__PURE__ */ g($a, {
    ...p,
    onThumbPositionChange: () => {
      if (r.viewport && s.current) {
        const u = r.viewport.scrollTop, d = li(u, a);
        a.scrollbar.size === 0 ? s.current.style.setProperty("--thumb-opacity", "0") : s.current.style.setProperty("--thumb-opacity", "1"), s.current.style.transform = `translate3d(0, ${d}px, 0)`;
      }
    },
    onWheelScroll: (u) => {
      r.viewport && (r.viewport.scrollTop = u);
    },
    onDragScroll: (u) => {
      r.viewport && (r.viewport.scrollTop = f(u));
    }
  }) : null;
}
Co.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
function rs(e) {
  const t = Qe(), { forceMount: n, ...o } = e, [r, s] = re(!1), i = e.orientation === "horizontal", a = vo(() => {
    if (t.viewport) {
      const l = t.viewport.offsetWidth < t.viewport.scrollWidth, c = t.viewport.offsetHeight < t.viewport.scrollHeight;
      s(i ? l : c);
    }
  }, 10);
  return kt(t.viewport, a), kt(t.content, a), n || r ? /* @__PURE__ */ g(Co, {
    "data-state": r ? "visible" : "hidden",
    ...o
  }) : null;
}
rs.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
function Pa(e) {
  const { forceMount: t, ...n } = e, o = Qe(), [r, s] = re(!1);
  return ce(() => {
    const { scrollArea: i } = o;
    let a = 0;
    if (i) {
      const l = () => {
        window.clearTimeout(a), s(!0);
      }, c = () => {
        a = window.setTimeout(() => s(!1), o.scrollHideDelay);
      };
      return i.addEventListener("pointerenter", l), i.addEventListener("pointerleave", c), () => {
        window.clearTimeout(a), i.removeEventListener("pointerenter", l), i.removeEventListener("pointerleave", c);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), t || r ? /* @__PURE__ */ g(rs, {
    "data-state": r ? "visible" : "hidden",
    ...n
  }) : null;
}
Pa.displayName = "@mantine/core/ScrollAreaScrollbarHover";
function rf(e) {
  const { forceMount: t, ...n } = e, o = Qe(), r = e.orientation === "horizontal", [s, i] = re("hidden"), a = vo(() => i("idle"), 100);
  return ce(() => {
    if (s === "idle") {
      const l = window.setTimeout(() => i("hidden"), o.scrollHideDelay);
      return () => window.clearTimeout(l);
    }
  }, [s, o.scrollHideDelay]), ce(() => {
    const { viewport: l } = o, c = r ? "scrollLeft" : "scrollTop";
    if (l) {
      let p = l[c];
      const f = () => {
        const u = l[c];
        p !== u && (i("scrolling"), a()), p = u;
      };
      return l.addEventListener("scroll", f), () => l.removeEventListener("scroll", f);
    }
  }, [
    o.viewport,
    r,
    a
  ]), t || s !== "hidden" ? /* @__PURE__ */ g(Co, {
    "data-state": s === "hidden" ? "hidden" : "visible",
    ...n,
    onPointerEnter: Vt(e.onPointerEnter, () => i("interacting")),
    onPointerLeave: Vt(e.onPointerLeave, () => i("idle"))
  }) : null;
}
function Lr(e) {
  const { forceMount: t, ...n } = e, o = Qe(), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: s } = o, i = e.orientation === "horizontal";
  return ce(() => (i ? r(!0) : s(!0), () => {
    i ? r(!1) : s(!1);
  }), [
    i,
    r,
    s
  ]), o.type === "hover" ? /* @__PURE__ */ g(Pa, {
    ...n,
    forceMount: t
  }) : o.type === "scroll" ? /* @__PURE__ */ g(rf, {
    ...n,
    forceMount: t
  }) : o.type === "auto" ? /* @__PURE__ */ g(rs, {
    ...n,
    forceMount: t
  }) : o.type === "always" ? /* @__PURE__ */ g(Co, { ...n }) : null;
}
Lr.displayName = "@mantine/core/ScrollAreaScrollbar";
function sf(e, t = () => {
}) {
  let n = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, o = 0;
  return (function r() {
    const s = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, i = n.left !== s.left, a = n.top !== s.top;
    (i || a) && t(), n = s, o = window.requestAnimationFrame(r);
  })(), () => window.cancelAnimationFrame(o);
}
function Ma(e) {
  const { style: t, ref: n, ...o } = e, r = Qe(), s = Sa(), { onThumbPositionChange: i } = s, a = Me(n, s.onThumbChange), l = Z(void 0), c = vo(() => {
    l.current && (l.current(), l.current = void 0);
  }, 100);
  return ce(() => {
    const { viewport: p } = r;
    if (p) {
      const f = () => {
        if (c(), !l.current) {
          const u = sf(p, i);
          l.current = u, i();
        }
      };
      return i(), p.addEventListener("scroll", f), () => p.removeEventListener("scroll", f);
    }
  }, [
    r.viewport,
    c,
    i
  ]), /* @__PURE__ */ g("div", {
    "data-state": s.hasThumb ? "visible" : "hidden",
    ...o,
    ref: a,
    style: {
      width: "var(--sa-thumb-width)",
      height: "var(--sa-thumb-height)",
      ...t
    },
    onPointerDownCapture: Vt(e.onPointerDownCapture, (p) => {
      const f = p.target.getBoundingClientRect(), u = p.clientX - f.left, d = p.clientY - f.top;
      s.onThumbPointerDown({
        x: u,
        y: d
      });
    }),
    onPointerUp: Vt(e.onPointerUp, s.onThumbPointerUp)
  });
}
Ma.displayName = "@mantine/core/ScrollAreaThumb";
function Er(e) {
  const { forceMount: t, ...n } = e, o = Sa();
  return t || o.hasThumb ? /* @__PURE__ */ g(Ma, { ...n }) : null;
}
Er.displayName = "@mantine/core/ScrollAreaThumb";
function Ta({ children: e, style: t, ref: n, onWheel: o, ...r }) {
  const s = Qe(), i = Me(n, s.onViewportChange);
  return /* @__PURE__ */ g(q, {
    ...r,
    ref: i,
    onWheel: (l) => {
      if (o?.(l), s.scrollbarXEnabled && s.viewport && l.shiftKey) {
        const { scrollTop: c, scrollHeight: p, clientHeight: f, scrollWidth: u, clientWidth: d } = s.viewport, m = c < 1, h = c >= p - f - 1;
        u > d && (m || h) && l.stopPropagation();
      }
    },
    "data-scrollarea-viewport": !0,
    style: {
      overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
      ...t
    },
    children: /* @__PURE__ */ g("div", {
      ...s.getStyles("content"),
      ref: s.onContentChange,
      children: e
    })
  });
}
Ta.displayName = "@mantine/core/ScrollAreaViewport";
var ss = {
  root: "m_d57069b5",
  content: "m_b1336c6",
  viewport: "m_c0783ff9",
  viewportInner: "m_f8f631dd",
  scrollbar: "m_c44ba933",
  thumb: "m_d8b5e363",
  corner: "m_21657268"
};
function _o() {
  return typeof window < "u";
}
function yn(e) {
  return Na(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ye(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function St(e) {
  var t;
  return (t = (Na(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Na(e) {
  return _o() ? e instanceof Node || e instanceof Ye(e).Node : !1;
}
function ye(e) {
  return _o() ? e instanceof Element || e instanceof Ye(e).Element : !1;
}
function at(e) {
  return _o() ? e instanceof HTMLElement || e instanceof Ye(e).HTMLElement : !1;
}
function ao(e) {
  return !_o() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ye(e).ShadowRoot;
}
function xo(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = ot(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && r !== "inline" && r !== "contents";
}
function af(e) {
  return /^(table|td|th)$/.test(yn(e));
}
function So(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const lf = /transform|translate|scale|rotate|perspective|filter/, cf = /paint|layout|strict|content/, Bt = (e) => !!e && e !== "none";
let hr;
function is(e) {
  const t = ye(e) ? ot(e) : e;
  return Bt(t.transform) || Bt(t.translate) || Bt(t.scale) || Bt(t.rotate) || Bt(t.perspective) || !Ro() && (Bt(t.backdropFilter) || Bt(t.filter)) || lf.test(t.willChange || "") || cf.test(t.contain || "");
}
function uf(e) {
  let t = Lt(e);
  for (; at(t) && !Tt(t); ) {
    if (is(t))
      return t;
    if (So(t))
      return null;
    t = Lt(t);
  }
  return null;
}
function Ro() {
  return hr == null && (hr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), hr;
}
function Tt(e) {
  return /^(html|body|#document)$/.test(yn(e));
}
function ot(e) {
  return Ye(e).getComputedStyle(e);
}
function Do(e) {
  return ye(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Lt(e) {
  if (yn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ao(e) && e.host || // Fallback.
    St(e)
  );
  return ao(t) ? t.host : t;
}
function ka(e) {
  const t = Lt(e);
  return Tt(t) ? (e.ownerDocument || e).body : at(t) && xo(t) ? t : ka(t);
}
function bt(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = ka(e), s = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = Ye(r);
  if (s) {
    const a = Or(i);
    return t.concat(i, i.visualViewport || [], xo(r) ? r : [], a && n ? bt(a) : []);
  } else
    return t.concat(r, bt(r, [], n));
}
function Or(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const df = ["top", "right", "bottom", "left"], rt = Math.min, Je = Math.max, lo = Math.round, Un = Math.floor, wt = (e) => ({
  x: e,
  y: e
}), ff = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function La(e, t, n) {
  return Je(e, rt(t, n));
}
function ft(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function pt(e) {
  return e.split("-")[0];
}
function bn(e) {
  return e.split("-")[1];
}
function as(e) {
  return e === "x" ? "y" : "x";
}
function ls(e) {
  return e === "y" ? "height" : "width";
}
function et(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function cs(e) {
  return as(et(e));
}
function pf(e, t, n) {
  n === void 0 && (n = !1);
  const o = bn(e), r = cs(e), s = ls(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = co(i)), [i, co(i)];
}
function mf(e) {
  const t = co(e);
  return [Ar(e), t, Ar(t)];
}
function Ar(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const ci = ["left", "right"], ui = ["right", "left"], hf = ["top", "bottom"], gf = ["bottom", "top"];
function vf(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? ui : ci : t ? ci : ui;
    case "left":
    case "right":
      return t ? hf : gf;
    default:
      return [];
  }
}
function yf(e, t, n, o) {
  const r = bn(e);
  let s = vf(pt(e), n === "start", o);
  return r && (s = s.map((i) => i + "-" + r), t && (s = s.concat(s.map(Ar)))), s;
}
function co(e) {
  const t = pt(e);
  return ff[t] + e.slice(t.length);
}
function bf(e) {
  var t, n, o, r;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (o = e.bottom) != null ? o : 0,
    left: (r = e.left) != null ? r : 0
  };
}
function us(e) {
  return typeof e != "number" ? bf(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Nt(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function wf() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Cf() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: o
    } = t;
    return n + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function _f() {
  return /apple/i.test(navigator.vendor);
}
function xf() {
  return wf().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Sf() {
  return Cf().includes("jsdom/");
}
const di = "data-floating-ui-focusable", Rf = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function fi(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function kn(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ao(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function cn(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function gr(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Df(e) {
  return e.matches("html,body");
}
function Ht(e) {
  return e?.ownerDocument || document;
}
function $f(e) {
  return at(e) && e.matches(Rf);
}
function Pf(e) {
  if (!e || Sf()) return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Mf(e) {
  return e ? e.hasAttribute(di) ? e : e.querySelector("[" + di + "]") || e : null;
}
function Jn(e, t, n) {
  return n === void 0 && (n = !0), e.filter((r) => {
    var s;
    return r.parentId === t && (!n || ((s = r.context) == null ? void 0 : s.open));
  }).flatMap((r) => [r, ...Jn(e, r.id, n)]);
}
function Tf(e) {
  return "nativeEvent" in e;
}
function Ir(e, t) {
  const n = ["mouse", "pen"];
  return n.push("", void 0), n.includes(e);
}
var Nf = typeof document < "u", kf = function() {
}, dt = Nf ? mo : kf;
const Lf = {
  ...j
};
function Xn(e) {
  const t = j.useRef(e);
  return dt(() => {
    t.current = e;
  }), t;
}
const Ef = Lf.useInsertionEffect, Of = Ef || ((e) => e());
function ut(e) {
  const t = j.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Of(() => {
    t.current = e;
  }), j.useCallback(function() {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
      o[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...o);
  }, []);
}
function pi(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const s = et(t), i = cs(t), a = ls(i), l = pt(t), c = s === "y", p = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, u = o[a] / 2 - r[a] / 2;
  let d;
  switch (l) {
    case "top":
      d = {
        x: p,
        y: o.y - r.height
      };
      break;
    case "bottom":
      d = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      d = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      d = {
        x: o.x,
        y: o.y
      };
  }
  const m = bn(t);
  return m && (d[i] += u * (m === "end" ? 1 : -1) * (n && c ? -1 : 1)), d;
}
async function Af(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: u = !1,
    padding: d = 0
  } = ft(t, e), m = us(d), v = a[u ? f === "floating" ? "reference" : "floating" : f], y = Nt(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(v))) == null || n ? v : v.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: p,
    strategy: l
  })), _ = f === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), x = await (s.isElement == null ? void 0 : s.isElement(w)) && await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  }, C = Nt(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: _,
    offsetParent: w,
    strategy: l
  }) : _);
  return {
    top: (y.top - C.top + m.top) / x.y,
    bottom: (C.bottom - y.bottom + m.bottom) / x.y,
    left: (y.left - C.left + m.left) / x.x,
    right: (C.right - y.right + m.right) / x.x
  };
}
const If = 50, Yf = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = i.detectOverflow ? i : {
    ...i,
    detectOverflow: Af
  }, l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: p,
    y: f
  } = pi(c, o, l), u = o, d = 0;
  const m = {};
  for (let h = 0; h < s.length; h++) {
    const v = s[h];
    if (!v)
      continue;
    const {
      name: y,
      fn: _
    } = v, {
      x: w,
      y: x,
      data: C,
      reset: $
    } = await _({
      x: p,
      y: f,
      initialPlacement: o,
      placement: u,
      strategy: r,
      middlewareData: m,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = w ?? p, f = x ?? f, m[y] = {
      ...m[y],
      ...C
    }, $ && d < If && (d++, typeof $ == "object" && ($.placement && (u = $.placement), $.rects && (c = $.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : $.rects), {
      x: p,
      y: f
    } = pi(c, u, l)), h = -1);
  }
  return {
    x: p,
    y: f,
    placement: u,
    strategy: r,
    middlewareData: m
  };
}, Ff = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: p = 0
    } = ft(e, t) || {};
    if (c == null)
      return {};
    const f = us(p), u = {
      x: n,
      y: o
    }, d = cs(r), m = ls(d), h = await i.getDimensions(c), v = d === "y", y = v ? "top" : "left", _ = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", x = s.reference[m] + s.reference[d] - u[d] - s.floating[m], C = u[d] - s.reference[d], $ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let M = $ ? $[w] : 0;
    (!M || !await (i.isElement == null ? void 0 : i.isElement($))) && (M = a.floating[w] || s.floating[m]);
    const N = x / 2 - C / 2, I = M / 2 - h[m] / 2 - 1, E = rt(f[y], I), O = rt(f[_], I), B = M - h[m] - O, A = M / 2 - h[m] / 2 + N, S = La(E, A, B), k = !l.arrow && bn(r) != null && A !== S && s.reference[m] / 2 - (A < E ? E : O) - h[m] / 2 < 0, R = k ? A < E ? A - E : A - B : 0;
    return {
      [d]: u[d] + R,
      data: {
        [d]: S,
        centerOffset: A - S - R,
        ...k && {
          alignmentOffset: R
        }
      },
      reset: k
    };
  }
}), Wf = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: u,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...v
      } = ft(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const y = pt(r), _ = et(a), w = pt(a) === a, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), C = u || (w || !h ? [co(a)] : mf(a)), $ = m !== "none";
      !u && $ && C.push(...yf(a, h, m, x));
      const M = [a, ...C], N = await l.detectOverflow(t, v), I = [];
      let E = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (p && I.push(N[y]), f) {
        const S = pf(r, i, x);
        I.push(N[S[0]], N[S[1]]);
      }
      if (E = [...E, {
        placement: r,
        overflows: I
      }], !I.every((S) => S <= 0)) {
        var O, B;
        const S = (((O = s.flip) == null ? void 0 : O.index) || 0) + 1, k = M[S];
        if (k && (!(f === "alignment" ? _ !== et(k) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        E.every((b) => et(b.placement) === _ ? b.overflows[0] > 0 : !0)))
          return {
            data: {
              index: S,
              overflows: E
            },
            reset: {
              placement: k
            }
          };
        let R = (B = E.filter((D) => D.overflows[0] <= 0).sort((D, b) => D.overflows[1] - b.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!R)
          switch (d) {
            case "bestFit": {
              var A;
              const D = (A = E.filter((b) => {
                if ($) {
                  const T = et(b.placement);
                  return T === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  T === "y";
                }
                return !0;
              }).map((b) => [b.placement, b.overflows.filter((T) => T > 0).reduce((T, P) => T + P, 0)]).sort((b, T) => b[1] - T[1])[0]) == null ? void 0 : A[0];
              D && (R = D);
              break;
            }
            case "initialPlacement":
              R = a;
              break;
          }
        if (r !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
};
function mi(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function hi(e) {
  return df.some((t) => e[t] >= 0);
}
const Bf = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: o
      } = t, {
        strategy: r = "referenceHidden",
        ...s
      } = ft(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await o.detectOverflow(t, {
            ...s,
            elementContext: "reference"
          }), a = mi(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: hi(a)
            }
          };
        }
        case "escaped": {
          const i = await o.detectOverflow(t, {
            ...s,
            altBoundary: !0
          }), a = mi(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: hi(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function Ea(e) {
  const t = rt(...e.map((s) => s.left)), n = rt(...e.map((s) => s.top)), o = Je(...e.map((s) => s.right)), r = Je(...e.map((s) => s.bottom));
  return {
    x: t,
    y: n,
    width: o - t,
    height: r - n
  };
}
function zf(e) {
  const t = e.slice().sort((r, s) => r.y - s.y), n = [];
  let o = null;
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    !o || s.y - o.y > o.height / 2 ? n.push([s]) : n[n.length - 1].push(s), o = s;
  }
  return n.map((r) => Nt(Ea(r)));
}
const Hf = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(t) {
      const {
        placement: n,
        elements: o,
        rects: r,
        platform: s,
        strategy: i
      } = t, {
        padding: a = 2,
        x: l,
        y: c
      } = ft(e, t), p = Array.from(await (s.getClientRects == null ? void 0 : s.getClientRects(o.reference)) || []);
      if (!p.length)
        return {};
      const f = zf(p), u = Nt(Ea(p)), d = us(a);
      function m() {
        if (f.length === 2 && (f[0].left > f[1].right || f[1].left > f[0].right) && l != null && c != null)
          return f.find((v) => l > v.left - d.left && l < v.right + d.right && c > v.top - d.top && c < v.bottom + d.bottom) || u;
        if (f.length >= 2) {
          if (et(n) === "y") {
            const $ = f[0], M = f[f.length - 1], N = pt(n) === "top", I = $.top, E = M.bottom, O = N ? $.left : M.left, B = N ? $.right : M.right;
            return Nt({
              x: O,
              y: I,
              width: B - O,
              height: E - I
            });
          }
          const v = pt(n) === "left", y = Je(...f.map(($) => $.right)), _ = rt(...f.map(($) => $.left)), w = f.filter(($) => v ? $.left === _ : $.right === y), x = w[0].top, C = w[w.length - 1].bottom;
          return Nt({
            x: _,
            y: x,
            width: y - _,
            height: C - x
          });
        }
        return u;
      }
      const h = await s.getElementRects({
        reference: {
          getBoundingClientRect: m
        },
        floating: o.floating,
        strategy: i
      });
      return r.reference.x !== h.reference.x || r.reference.y !== h.reference.y || r.reference.width !== h.reference.width || r.reference.height !== h.reference.height ? {
        reset: {
          rects: h
        }
      } : {};
    }
  };
}, Oa = /* @__PURE__ */ new Set(["left", "top"]);
async function Vf(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, s = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = pt(n), a = bn(n), l = et(n) === "y", c = Oa.has(i) ? -1 : 1, p = s && l ? -1 : 1, f = ft(t, e);
  let {
    mainAxis: u,
    crossAxis: d,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof m == "number" && (d = a === "end" ? m * -1 : m), l ? {
    x: d * p,
    y: u * c
  } : {
    x: u * c,
    y: d * p
  };
}
const jf = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: i,
        middlewareData: a
      } = t, l = await Vf(t, e);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, Gf = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: s
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (_) => {
            let {
              x: w,
              y: x
            } = _;
            return {
              x: w,
              y: x
            };
          }
        },
        ...c
      } = ft(e, t), p = {
        x: n,
        y: o
      }, f = await s.detectOverflow(t, c), u = et(r), d = as(u);
      let m = p[d], h = p[u];
      const v = (_, w) => La(w + f[_ === "y" ? "top" : "left"], w, w - f[_ === "y" ? "bottom" : "right"]);
      i && (m = v(d, m)), a && (h = v(u, h));
      const y = l.fn({
        ...t,
        [d]: m,
        [u]: h
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o,
          enabled: {
            [d]: i,
            [u]: a
          }
        }
      };
    }
  };
}, Kf = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: i,
        rects: a,
        middlewareData: l
      } = t, {
        offset: c = 0,
        mainAxis: p = !0,
        crossAxis: f = !0
      } = ft(e, t), u = {
        x: r,
        y: s
      }, d = et(i), m = as(d);
      let h = u[m], v = u[d];
      const y = ft(c, t), _ = typeof y == "number" ? {
        mainAxis: y,
        crossAxis: 0
      } : {
        mainAxis: (n = y.mainAxis) != null ? n : 0,
        crossAxis: (o = y.crossAxis) != null ? o : 0
      };
      if (p) {
        const C = m === "y" ? "height" : "width", $ = a.reference[m] - a.floating[C] + _.mainAxis, M = a.reference[m] + a.reference[C] - _.mainAxis;
        h < $ ? h = $ : h > M && (h = M);
      }
      if (f) {
        var w, x;
        const C = m === "y" ? "width" : "height", $ = Oa.has(pt(i)), M = a.reference[d] - a.floating[C] + ($ && ((w = l.offset) == null ? void 0 : w[d]) || 0) + ($ ? 0 : _.crossAxis), N = a.reference[d] + a.reference[C] + ($ ? 0 : ((x = l.offset) == null ? void 0 : x[d]) || 0) - ($ ? _.crossAxis : 0);
        v < M ? v = M : v > N && (v = N);
      }
      return {
        [m]: h,
        [d]: v
      };
    }
  };
}, Uf = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: o,
        platform: r,
        elements: s
      } = t, {
        apply: i = () => {
        },
        ...a
      } = ft(e, t), l = await r.detectOverflow(t, a), c = pt(n), p = bn(n), f = et(n) === "y", {
        width: u,
        height: d
      } = o.floating;
      let m, h;
      c === "top" || c === "bottom" ? (m = c, h = p === (await (r.isRTL == null ? void 0 : r.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (h = c, m = p === "end" ? "top" : "bottom");
      const v = d - l.top - l.bottom, y = u - l.left - l.right, _ = rt(d - l[m], v), w = rt(u - l[h], y), x = t.middlewareData.shift, C = !x;
      let $ = _, M = w;
      x != null && x.enabled.x && (M = y), x != null && x.enabled.y && ($ = v), C && !p && (f ? M = u - 2 * Je(l.left, l.right) : $ = d - 2 * Je(l.top, l.bottom)), await i({
        ...t,
        availableWidth: M,
        availableHeight: $
      });
      const N = await r.getDimensions(s.floating);
      return u !== N.width || d !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Aa(e) {
  const t = ot(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = at(e), s = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, a = lo(n) !== s || lo(o) !== i;
  return a && (n = s, o = i), {
    width: n,
    height: o,
    $: a
  };
}
function ds(e) {
  return ye(e) ? e : e.contextElement;
}
function dn(e) {
  const t = ds(e);
  if (!at(t))
    return wt(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = Aa(t);
  let i = (s ? lo(n.width) : n.width) / o, a = (s ? lo(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const Xf = /* @__PURE__ */ wt(0);
function Ia(e) {
  const t = Ye(e);
  return !Ro() || !t.visualViewport ? Xf : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qf(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Ye(e);
}
function jt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = ds(e);
  let i = wt(1);
  t && (o ? ye(o) && (i = dn(o)) : i = dn(e));
  const a = qf(s, n, o) ? Ia(s) : wt(0);
  let l = (r.left + a.x) / i.x, c = (r.top + a.y) / i.y, p = r.width / i.x, f = r.height / i.y;
  if (s && o) {
    const u = Ye(s), d = ye(o) ? Ye(o) : o;
    let m = u, h = Or(m);
    for (; h && d !== m; ) {
      const v = dn(h), y = h.getBoundingClientRect(), _ = ot(h), w = y.left + (h.clientLeft + parseFloat(_.paddingLeft)) * v.x, x = y.top + (h.clientTop + parseFloat(_.paddingTop)) * v.y;
      l *= v.x, c *= v.y, p *= v.x, f *= v.y, l += w, c += x, m = Ye(h), h = Or(m);
    }
  }
  return Nt({
    width: p,
    height: f,
    x: l,
    y: c
  });
}
function $o(e, t) {
  const n = Do(e).scrollLeft;
  return t ? t.left + n : jt(St(e)).left + n;
}
function Ya(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - $o(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function Zf(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const s = r === "fixed", i = St(o), a = t ? So(t.floating) : !1;
  if (o === i || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = wt(1);
  const p = wt(0), f = at(o);
  if ((f || !s) && ((yn(o) !== "body" || xo(i)) && (l = Do(o)), f)) {
    const d = jt(o);
    c = dn(o), p.x = d.x + o.clientLeft, p.y = d.y + o.clientTop;
  }
  const u = i && !f && !s ? Ya(i, l) : wt(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + p.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + p.y + u.y
  };
}
function Jf(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Qf(e) {
  const t = Do(e), n = e.ownerDocument.body, o = Je(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = Je(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -t.scrollLeft + $o(e);
  const i = -t.scrollTop;
  return ot(n).direction === "rtl" && (s += Je(e.clientWidth, n.clientWidth) - o), {
    width: o,
    height: r,
    x: s,
    y: i
  };
}
const ep = 25;
function tp(e, t, n) {
  n === void 0 && (n = "viewport");
  const o = n === "layoutViewport", r = Ye(e), s = St(e), i = r.visualViewport;
  let a = s.clientWidth, l = s.clientHeight, c = 0, p = 0;
  if (i) {
    const u = !Ro() || t === "fixed";
    o ? u || (c = -i.offsetLeft, p = -i.offsetTop) : (a = i.width, l = i.height, u && (c = i.offsetLeft, p = i.offsetTop));
  }
  if ($o(s) <= 0) {
    const u = s.ownerDocument, d = u.body, m = getComputedStyle(d), h = u.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, v = Math.abs(s.clientWidth - d.clientWidth - h), y = getComputedStyle(s).scrollbarGutter === "stable both-edges" ? v / 2 : v;
    y <= ep && (a -= y);
  }
  return {
    width: a,
    height: l,
    x: c,
    y: p
  };
}
function np(e, t) {
  const n = jt(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, s = dn(e), i = e.clientWidth * s.x, a = e.clientHeight * s.y, l = r * s.x, c = o * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function gi(e, t, n) {
  let o;
  if (t === "viewport" || t === "layoutViewport")
    o = tp(e, n, t);
  else if (t === "document")
    o = Qf(St(e));
  else if (ye(t))
    o = np(t, n);
  else {
    const r = Ia(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Nt(o);
}
function op(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = bt(e, [], !1).filter((a) => ye(a) && yn(a) !== "body"), r = null;
  const s = ot(e).position === "fixed";
  let i = s ? Lt(e) : e;
  for (; ye(i) && !Tt(i); ) {
    const a = ot(i), l = is(i), c = r ? r.position : s ? "fixed" : "";
    !l && (c === "fixed" || c === "absolute" && a.position === "static") ? o = o.filter((f) => f !== i) : r = a, i = Lt(i);
  }
  return t.set(e, o), o;
}
function rp(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? So(t) ? [] : op(t, this._c) : [].concat(n), o], a = gi(t, i[0], r);
  let l = a.top, c = a.right, p = a.bottom, f = a.left;
  for (let u = 1; u < i.length; u++) {
    const d = gi(t, i[u], r);
    l = Je(d.top, l), c = rt(d.right, c), p = rt(d.bottom, p), f = Je(d.left, f);
  }
  return {
    width: c - f,
    height: p - l,
    x: f,
    y: l
  };
}
function sp(e) {
  const {
    width: t,
    height: n
  } = Aa(e);
  return {
    width: t,
    height: n
  };
}
function ip(e, t, n) {
  const o = at(t), r = St(t), s = n === "fixed", i = jt(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = wt(0);
  if ((o || !s) && ((yn(t) !== "body" || xo(r)) && (a = Do(t)), o)) {
    const u = jt(t, !0, s, t);
    l.x = u.x + t.clientLeft, l.y = u.y + t.clientTop;
  }
  !o && r && (l.x = $o(r));
  const c = r && !o && !s ? Ya(r, a) : wt(0), p = i.left + a.scrollLeft - l.x - c.x, f = i.top + a.scrollTop - l.y - c.y;
  return {
    x: p,
    y: f,
    width: i.width,
    height: i.height
  };
}
function vr(e) {
  return ot(e).position === "static";
}
function vi(e, t) {
  if (!at(e) || ot(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return St(e) === n && (n = n.ownerDocument.body), n;
}
function Fa(e, t) {
  const n = Ye(e);
  if (So(e))
    return n;
  if (!at(e)) {
    let r = Lt(e);
    for (; r && !Tt(r); ) {
      if (ye(r) && !vr(r))
        return r;
      r = Lt(r);
    }
    return n;
  }
  let o = vi(e, t);
  for (; o && af(o) && vr(o); )
    o = vi(o, t);
  return o && Tt(o) && vr(o) && !is(o) ? n : o || uf(e) || n;
}
const ap = async function(e) {
  const t = this.getOffsetParent || Fa, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: ip(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function lp(e) {
  return ot(e).direction === "rtl";
}
const cp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zf,
  getDocumentElement: St,
  getClippingRect: rp,
  getOffsetParent: Fa,
  getElementRects: ap,
  getClientRects: Jf,
  getDimensions: sp,
  getScale: dn,
  isElement: ye,
  isRTL: lp
};
function Wa(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function up(e, t, n) {
  let o = null, r;
  const s = St(e);
  function i() {
    var p;
    clearTimeout(r), (p = o) == null || p.disconnect(), o = null;
  }
  function a(p, f) {
    p === void 0 && (p = !1), f === void 0 && (f = 1), i();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: m,
      width: h,
      height: v
    } = u;
    if (p || t(), !h || !v)
      return;
    const y = Un(m), _ = Un(s.clientWidth - (d + h)), w = Un(s.clientHeight - (m + v)), x = Un(d), $ = {
      rootMargin: -y + "px " + -_ + "px " + -w + "px " + -x + "px",
      threshold: Je(0, rt(1, f)) || 1
    };
    let M = !0;
    function N(I) {
      const E = I[0].intersectionRatio;
      if (!Wa(u, e.getBoundingClientRect()))
        return a();
      if (E !== f) {
        if (!M)
          return a();
        E ? a(!1, E) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      M = !1;
    }
    try {
      o = new IntersectionObserver(N, {
        ...$,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(N, $);
    }
    o.observe(e);
  }
  const l = Ye(e), c = () => a(n);
  return l.addEventListener("resize", c), a(!0), () => {
    l.removeEventListener("resize", c), i();
  };
}
function Yr(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = ds(e), p = r || s ? [...c ? bt(c) : [], ...t ? bt(t) : []] : [];
  p.forEach((y) => {
    r && y.addEventListener("scroll", n), s && y.addEventListener("resize", n);
  });
  const f = c && a ? up(c, n, s) : null;
  let u = -1, d = null;
  i && (d = new ResizeObserver((y) => {
    let [_] = y;
    _ && _.target === c && d && t && (d.unobserve(t), cancelAnimationFrame(u), u = requestAnimationFrame(() => {
      var w;
      (w = d) == null || w.observe(t);
    })), n();
  }), c && !l && d.observe(c), t && d.observe(t));
  let m, h = l ? jt(e) : null;
  l && v();
  function v() {
    const y = jt(e);
    h && !Wa(h, y) && n(), h = y, m = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    p.forEach((_) => {
      r && _.removeEventListener("scroll", n), s && _.removeEventListener("resize", n);
    }), f?.(), (y = d) == null || y.disconnect(), d = null, l && cancelAnimationFrame(m);
  };
}
const dp = jf, fp = Gf, pp = Wf, mp = Uf, hp = Bf, yi = Ff, gp = Hf, vp = Kf, yp = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = n ?? {}, s = {
    ...cp,
    ...r.platform,
    _c: o
  };
  return Yf(e, t, {
    ...r,
    platform: s
  });
};
var bp = typeof document < "u", wp = function() {
}, Qn = bp ? mo : wp;
function uo(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!uo(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && e.$$typeof) && !uo(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ba(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function bi(e, t) {
  const n = Ba(e);
  return Math.round(t * n) / n;
}
function yr(e) {
  const t = j.useRef(e);
  return Qn(() => {
    t.current = e;
  }), t;
}
function Cp(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [p, f] = j.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [u, d] = j.useState(o);
  uo(u, o) || d(o);
  const [m, h] = j.useState(null), [v, y] = j.useState(null), _ = j.useCallback((b) => {
    b !== $.current && ($.current = b, h(b));
  }, []), w = j.useCallback((b) => {
    b !== M.current && (M.current = b, y(b));
  }, []), x = s || m, C = i || v, $ = j.useRef(null), M = j.useRef(null), N = j.useRef(p), I = l != null, E = yr(l), O = yr(r), B = yr(c), A = j.useCallback(() => {
    if (!$.current || !M.current)
      return;
    const b = {
      placement: t,
      strategy: n,
      middleware: u
    };
    O.current && (b.platform = O.current), yp($.current, M.current, b).then((T) => {
      const P = {
        ...T,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      S.current && !uo(N.current, P) && (N.current = P, iu.flushSync(() => {
        f(P);
      }));
    });
  }, [u, t, n, O, B]);
  Qn(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, f((b) => ({
      ...b,
      isPositioned: !1
    })));
  }, [c]);
  const S = j.useRef(!1);
  Qn(() => (S.current = !0, () => {
    S.current = !1;
  }), []), Qn(() => {
    if (x && ($.current = x), C && (M.current = C), x && C) {
      if (E.current)
        return E.current(x, C, A);
      A();
    }
  }, [x, C, A, E, I]);
  const k = j.useMemo(() => ({
    reference: $,
    floating: M,
    setReference: _,
    setFloating: w
  }), [_, w]), R = j.useMemo(() => ({
    reference: x,
    floating: C
  }), [x, C]), D = j.useMemo(() => {
    const b = {
      position: n,
      left: 0,
      top: 0
    };
    if (!R.floating)
      return b;
    const T = bi(R.floating, p.x), P = bi(R.floating, p.y);
    return a ? {
      ...b,
      transform: "translate(" + T + "px, " + P + "px)",
      ...Ba(R.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: T,
      top: P
    };
  }, [n, a, R.floating, p.x, p.y]);
  return j.useMemo(() => ({
    ...p,
    update: A,
    refs: k,
    elements: R,
    floatingStyles: D
  }), [p, A, k, R, D]);
}
const _p = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? yi({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? yi({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, za = (e, t) => {
  const n = dp(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, fs = (e, t) => {
  const n = fp(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, xp = (e, t) => ({
  fn: vp(e).fn,
  options: [e, t]
}), Fr = (e, t) => {
  const n = pp(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Sp = (e, t) => {
  const n = mp(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Rp = (e, t) => {
  const n = hp(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Pn = (e, t) => {
  const n = gp(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ha = (e, t) => {
  const n = _p(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
function Va(e) {
  const t = j.useRef(void 0), n = j.useCallback((o) => {
    const r = e.map((s) => {
      if (s != null) {
        if (typeof s == "function") {
          const i = s, a = i(o);
          return typeof a == "function" ? a : () => {
            i(null);
          };
        }
        return s.current = o, () => {
          s.current = null;
        };
      }
    });
    return () => {
      r.forEach((s) => s?.());
    };
  }, e);
  return j.useMemo(() => e.every((o) => o == null) ? null : (o) => {
    t.current && (t.current(), t.current = void 0), o != null && (t.current = n(o));
  }, e);
}
const Dp = "data-floating-ui-focusable", wi = "active", Ci = "selected", $p = {
  ...j
};
let _i = !1, Pp = 0;
const xi = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Pp++
);
function Mp() {
  const [e, t] = j.useState(() => _i ? xi() : void 0);
  return dt(() => {
    e == null && t(xi());
  }, []), j.useEffect(() => {
    _i = !0;
  }, []), e;
}
const Tp = $p.useId, ja = Tp || Mp;
let Wr;
process.env.NODE_ENV !== "production" && (Wr = /* @__PURE__ */ new Set());
function Np() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = Wr) != null && e.has(r))) {
    var s;
    (s = Wr) == null || s.add(r), console.error(r);
  }
}
function kp() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var o;
      (o = e.get(t)) == null || o.forEach((r) => r(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var o;
      (o = e.get(t)) == null || o.delete(n);
    }
  };
}
const Lp = /* @__PURE__ */ j.createContext(null), Ep = /* @__PURE__ */ j.createContext(null), ps = () => {
  var e;
  return ((e = j.useContext(Lp)) == null ? void 0 : e.id) || null;
}, ms = () => j.useContext(Ep);
function hs(e) {
  return "data-floating-ui-" + e;
}
function ze(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
const Si = /* @__PURE__ */ hs("safe-polygon");
function eo(e, t, n) {
  if (n && !Ir(n))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const o = e();
    return typeof o == "number" ? o : o?.[t];
  }
  return e?.[t];
}
function br(e) {
  return typeof e == "function" ? e() : e;
}
function Op(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    events: s,
    elements: i
  } = e, {
    enabled: a = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: p = !1,
    restMs: f = 0,
    move: u = !0
  } = t, d = ms(), m = ps(), h = Xn(c), v = Xn(l), y = Xn(n), _ = Xn(f), w = j.useRef(), x = j.useRef(-1), C = j.useRef(), $ = j.useRef(-1), M = j.useRef(!0), N = j.useRef(!1), I = j.useRef(() => {
  }), E = j.useRef(!1), O = ut(() => {
    var D;
    const b = (D = r.current.openEvent) == null ? void 0 : D.type;
    return b?.includes("mouse") && b !== "mousedown";
  });
  j.useEffect(() => {
    if (!a) return;
    function D(b) {
      let {
        open: T
      } = b;
      T || (ze(x), ze($), M.current = !0, E.current = !1);
    }
    return s.on("openchange", D), () => {
      s.off("openchange", D);
    };
  }, [a, s]), j.useEffect(() => {
    if (!a || !h.current || !n) return;
    function D(T) {
      O() && o(!1, T, "hover");
    }
    const b = Ht(i.floating).documentElement;
    return b.addEventListener("mouseleave", D), () => {
      b.removeEventListener("mouseleave", D);
    };
  }, [i.floating, n, o, a, h, O]);
  const B = j.useCallback(function(D, b, T) {
    b === void 0 && (b = !0), T === void 0 && (T = "hover");
    const P = eo(v.current, "close", w.current);
    P && !C.current ? (ze(x), x.current = window.setTimeout(() => o(!1, D, T), P)) : b && (ze(x), o(!1, D, T));
  }, [v, o]), A = ut(() => {
    I.current(), C.current = void 0;
  }), S = ut(() => {
    if (N.current) {
      const D = Ht(i.floating).body;
      D.style.pointerEvents = "", D.removeAttribute(Si), N.current = !1;
    }
  }), k = ut(() => r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1);
  j.useEffect(() => {
    if (!a) return;
    function D(L) {
      if (ze(x), M.current = !1, p && !Ir(w.current) || br(_.current) > 0 && !eo(v.current, "open"))
        return;
      const Y = eo(v.current, "open", w.current);
      Y ? x.current = window.setTimeout(() => {
        y.current || o(!0, L, "hover");
      }, Y) : n || o(!0, L, "hover");
    }
    function b(L) {
      if (k()) {
        S();
        return;
      }
      I.current();
      const Y = Ht(i.floating);
      if (ze($), E.current = !1, h.current && r.current.floatingContext) {
        n || ze(x), C.current = h.current({
          ...r.current.floatingContext,
          tree: d,
          x: L.clientX,
          y: L.clientY,
          onClose() {
            S(), A(), k() || B(L, !0, "safe-polygon");
          }
        });
        const V = C.current;
        Y.addEventListener("mousemove", V), I.current = () => {
          Y.removeEventListener("mousemove", V);
        };
        return;
      }
      (w.current !== "touch" || !kn(i.floating, L.relatedTarget)) && B(L);
    }
    function T(L) {
      k() || r.current.floatingContext && (h.current == null || h.current({
        ...r.current.floatingContext,
        tree: d,
        x: L.clientX,
        y: L.clientY,
        onClose() {
          S(), A(), k() || B(L);
        }
      })(L));
    }
    function P() {
      ze(x);
    }
    function F(L) {
      k() || B(L, !1);
    }
    if (ye(i.domReference)) {
      const L = i.domReference, Y = i.floating;
      return n && L.addEventListener("mouseleave", T), u && L.addEventListener("mousemove", D, {
        once: !0
      }), L.addEventListener("mouseenter", D), L.addEventListener("mouseleave", b), Y && (Y.addEventListener("mouseleave", T), Y.addEventListener("mouseenter", P), Y.addEventListener("mouseleave", F)), () => {
        n && L.removeEventListener("mouseleave", T), u && L.removeEventListener("mousemove", D), L.removeEventListener("mouseenter", D), L.removeEventListener("mouseleave", b), Y && (Y.removeEventListener("mouseleave", T), Y.removeEventListener("mouseenter", P), Y.removeEventListener("mouseleave", F));
      };
    }
  }, [i, a, e, p, u, B, A, S, o, n, y, d, v, h, r, k, _]), dt(() => {
    var D;
    if (a && n && (D = h.current) != null && (D = D.__options) != null && D.blockPointerEvents && O()) {
      N.current = !0;
      const T = i.floating;
      if (ye(i.domReference) && T) {
        var b;
        const P = Ht(i.floating).body;
        P.setAttribute(Si, "");
        const F = i.domReference, L = d == null || (b = d.nodesRef.current.find((Y) => Y.id === m)) == null || (b = b.context) == null ? void 0 : b.elements.floating;
        return L && (L.style.pointerEvents = ""), P.style.pointerEvents = "none", F.style.pointerEvents = "auto", T.style.pointerEvents = "auto", () => {
          P.style.pointerEvents = "", F.style.pointerEvents = "", T.style.pointerEvents = "";
        };
      }
    }
  }, [a, n, m, i, d, h, O]), dt(() => {
    n || (w.current = void 0, E.current = !1, A(), S());
  }, [n, A, S]), j.useEffect(() => () => {
    A(), ze(x), ze($), S();
  }, [a, i.domReference, A, S]);
  const R = j.useMemo(() => {
    function D(b) {
      w.current = b.pointerType;
    }
    return {
      onPointerDown: D,
      onPointerEnter: D,
      onMouseMove(b) {
        const {
          nativeEvent: T
        } = b;
        function P() {
          !M.current && !y.current && o(!0, T, "hover");
        }
        p && !Ir(w.current) || n || br(_.current) === 0 || E.current && b.movementX ** 2 + b.movementY ** 2 < 2 || (ze($), w.current === "touch" ? P() : (E.current = !0, $.current = window.setTimeout(P, br(_.current))));
      }
    };
  }, [p, o, n, y, _]);
  return j.useMemo(() => a ? {
    reference: R
  } : {}, [a, R]);
}
const Br = () => {
}, Ga = /* @__PURE__ */ j.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: Br,
  setState: Br,
  isInstantPhase: !1
}), Ap = () => j.useContext(Ga);
function Ip(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: o = 0
  } = e, [r, s] = j.useReducer((l, c) => ({
    ...l,
    ...c
  }), {
    delay: n,
    timeoutMs: o,
    initialDelay: n,
    currentId: null,
    isInstantPhase: !1
  }), i = j.useRef(null), a = j.useCallback((l) => {
    s({
      currentId: l
    });
  }, []);
  return dt(() => {
    r.currentId ? i.current === null ? i.current = r.currentId : r.isInstantPhase || s({
      isInstantPhase: !0
    }) : (r.isInstantPhase && s({
      isInstantPhase: !1
    }), i.current = null);
  }, [r.currentId, r.isInstantPhase]), /* @__PURE__ */ g(Ga.Provider, {
    value: j.useMemo(() => ({
      ...r,
      setState: s,
      setCurrentId: a
    }), [r, a]),
    children: t
  });
}
function Yp(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    floatingId: r
  } = e, {
    id: s,
    enabled: i = !0
  } = t, a = s ?? r, l = Ap(), {
    currentId: c,
    setCurrentId: p,
    initialDelay: f,
    setState: u,
    timeoutMs: d
  } = l;
  return dt(() => {
    i && c && (u({
      delay: {
        open: 1,
        close: eo(f, "close")
      }
    }), c !== a && o(!1));
  }, [i, a, o, u, c, f]), dt(() => {
    function m() {
      o(!1), u({
        delay: f,
        currentId: null
      });
    }
    if (i && c && !n && c === a) {
      if (d) {
        const h = window.setTimeout(m, d);
        return () => {
          clearTimeout(h);
        };
      }
      m();
    }
  }, [i, n, u, c, a, o, f, d]), dt(() => {
    i && (p === Br || !n || p(a));
  }, [i, n, p, a]), l;
}
function wr(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ao(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Fp(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Wp = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, Bp = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Ri = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e?.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e?.outsidePress) != null ? n : !0
  };
};
function zp(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    elements: r,
    dataRef: s
  } = e, {
    enabled: i = !0,
    escapeKey: a = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: p = !1,
    referencePressEvent: f = "pointerdown",
    ancestorScroll: u = !1,
    bubbles: d,
    capture: m
  } = t, h = ms(), v = ut(typeof l == "function" ? l : () => !1), y = typeof l == "function" ? v : l, _ = j.useRef(!1), {
    escapeKey: w,
    outsidePress: x
  } = Ri(d), {
    escapeKey: C,
    outsidePress: $
  } = Ri(m), M = j.useRef(!1), N = ut((S) => {
    var k;
    if (!n || !i || !a || S.key !== "Escape" || M.current)
      return;
    const R = (k = s.current.floatingContext) == null ? void 0 : k.nodeId, D = h ? Jn(h.nodesRef.current, R) : [];
    if (!w && (S.stopPropagation(), D.length > 0)) {
      let b = !0;
      if (D.forEach((T) => {
        var P;
        if ((P = T.context) != null && P.open && !T.context.dataRef.current.__escapeKeyBubbles) {
          b = !1;
          return;
        }
      }), !b)
        return;
    }
    o(!1, Tf(S) ? S.nativeEvent : S, "escape-key");
  }), I = ut((S) => {
    var k;
    const R = () => {
      var D;
      N(S), (D = cn(S)) == null || D.removeEventListener("keydown", R);
    };
    (k = cn(S)) == null || k.addEventListener("keydown", R);
  }), E = ut((S) => {
    var k;
    const R = s.current.insideReactTree;
    s.current.insideReactTree = !1;
    const D = _.current;
    if (_.current = !1, c === "click" && D || R || typeof y == "function" && !y(S))
      return;
    const b = cn(S), T = "[" + hs("inert") + "]", P = Ht(r.floating).querySelectorAll(T);
    let F = ye(b) ? b : null;
    for (; F && !Tt(F); ) {
      const V = Lt(F);
      if (Tt(V) || !ye(V))
        break;
      F = V;
    }
    if (P.length && ye(b) && !Df(b) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !kn(b, r.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(P).every((V) => !kn(F, V)))
      return;
    if (at(b) && A) {
      const V = Tt(b), U = ot(b), ee = /auto|scroll/, X = V || ee.test(U.overflowX), G = V || ee.test(U.overflowY), J = X && b.clientWidth > 0 && b.scrollWidth > b.clientWidth, ie = G && b.clientHeight > 0 && b.scrollHeight > b.clientHeight, ae = U.direction === "rtl", ne = ie && (ae ? S.offsetX <= b.offsetWidth - b.clientWidth : S.offsetX > b.clientWidth), ue = J && S.offsetY > b.clientHeight;
      if (ne || ue)
        return;
    }
    const L = (k = s.current.floatingContext) == null ? void 0 : k.nodeId, Y = h && Jn(h.nodesRef.current, L).some((V) => {
      var U;
      return gr(S, (U = V.context) == null ? void 0 : U.elements.floating);
    });
    if (gr(S, r.floating) || gr(S, r.domReference) || Y)
      return;
    const z = h ? Jn(h.nodesRef.current, L) : [];
    if (z.length > 0) {
      let V = !0;
      if (z.forEach((U) => {
        var ee;
        if ((ee = U.context) != null && ee.open && !U.context.dataRef.current.__outsidePressBubbles) {
          V = !1;
          return;
        }
      }), !V)
        return;
    }
    o(!1, S, "outside-press");
  }), O = ut((S) => {
    var k;
    const R = () => {
      var D;
      E(S), (D = cn(S)) == null || D.removeEventListener(c, R);
    };
    (k = cn(S)) == null || k.addEventListener(c, R);
  });
  j.useEffect(() => {
    if (!n || !i)
      return;
    s.current.__escapeKeyBubbles = w, s.current.__outsidePressBubbles = x;
    let S = -1;
    function k(P) {
      o(!1, P, "ancestor-scroll");
    }
    function R() {
      window.clearTimeout(S), M.current = !0;
    }
    function D() {
      S = window.setTimeout(
        () => {
          M.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Ro() ? 5 : 0
      );
    }
    const b = Ht(r.floating);
    a && (b.addEventListener("keydown", C ? I : N, C), b.addEventListener("compositionstart", R), b.addEventListener("compositionend", D)), y && b.addEventListener(c, $ ? O : E, $);
    let T = [];
    return u && (ye(r.domReference) && (T = bt(r.domReference)), ye(r.floating) && (T = T.concat(bt(r.floating))), !ye(r.reference) && r.reference && r.reference.contextElement && (T = T.concat(bt(r.reference.contextElement)))), T = T.filter((P) => {
      var F;
      return P !== ((F = b.defaultView) == null ? void 0 : F.visualViewport);
    }), T.forEach((P) => {
      P.addEventListener("scroll", k);
    }), () => {
      a && (b.removeEventListener("keydown", C ? I : N, C), b.removeEventListener("compositionstart", R), b.removeEventListener("compositionend", D)), y && b.removeEventListener(c, $ ? O : E, $), T.forEach((P) => {
        P.removeEventListener("scroll", k);
      }), window.clearTimeout(S);
    };
  }, [s, r, a, y, c, n, o, u, i, w, x, N, C, I, E, $, O]), j.useEffect(() => {
    s.current.insideReactTree = !1;
  }, [s, y, c]);
  const B = j.useMemo(() => ({
    onKeyDown: N,
    ...p && {
      [Wp[f]]: (S) => {
        o(!1, S.nativeEvent, "reference-press");
      },
      ...f !== "click" && {
        onClick(S) {
          o(!1, S.nativeEvent, "reference-press");
        }
      }
    }
  }), [N, o, p, f]), A = j.useMemo(() => {
    function S(k) {
      k.button === 0 && (_.current = !0);
    }
    return {
      onKeyDown: N,
      onMouseDown: S,
      onMouseUp: S,
      [Bp[c]]: () => {
        s.current.insideReactTree = !0;
      }
    };
  }, [N, c, s]);
  return j.useMemo(() => i ? {
    reference: B,
    floating: A
  } : {}, [i, B, A]);
}
function Hp(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: o
  } = e, r = ja(), s = j.useRef({}), [i] = j.useState(() => kp()), a = ps() != null;
  if (process.env.NODE_ENV !== "production") {
    const d = o.reference;
    d && !ye(d) && Np("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = j.useState(o.reference), p = ut((d, m, h) => {
    s.current.openEvent = d ? m : void 0, i.emit("openchange", {
      open: d,
      event: m,
      reason: h,
      nested: a
    }), n?.(d, m, h);
  }), f = j.useMemo(() => ({
    setPositionReference: c
  }), []), u = j.useMemo(() => ({
    reference: l || o.reference || null,
    floating: o.floating || null,
    domReference: o.reference
  }), [l, o.reference, o.floating]);
  return j.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: p,
    elements: u,
    events: i,
    floatingId: r,
    refs: f
  }), [t, p, u, i, r, f]);
}
function gs(e) {
  var t, n;
  let {
    elements: o,
    ...r
  } = e === void 0 ? {} : e;
  const {
    nodeId: s
  } = r, i = Hp({
    ...r,
    elements: {
      reference: (t = o?.reference) != null ? t : null,
      floating: (n = o?.floating) != null ? n : null
    }
  }), a = r.rootContext || i, l = a.elements, [c, p] = j.useState(null), [f, u] = j.useState(null), m = l?.domReference || c, h = j.useRef(null), v = ms();
  dt(() => {
    m && (h.current = m);
  }, [m]);
  const y = Cp({
    ...r,
    elements: {
      ...l,
      ...f && {
        reference: f
      }
    }
  }), _ = j.useCallback((M) => {
    const N = ye(M) ? {
      getBoundingClientRect: () => M.getBoundingClientRect(),
      getClientRects: () => M.getClientRects(),
      contextElement: M
    } : M;
    u(N), y.refs.setReference(N);
  }, [y.refs]), w = j.useCallback((M) => {
    (ye(M) || M === null) && (h.current = M, p(M)), (ye(y.refs.reference.current) || y.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    M !== null && !ye(M)) && y.refs.setReference(M);
  }, [y.refs]), x = j.useMemo(() => ({
    ...y.refs,
    setReference: w,
    setPositionReference: _,
    domReference: h
  }), [y.refs, w, _]), C = j.useMemo(() => ({
    ...y.elements,
    domReference: m
  }), [y.elements, m]), $ = j.useMemo(() => ({
    ...y,
    ...a,
    refs: x,
    elements: C,
    nodeId: s
  }), [y, x, C, s, a]);
  return dt(() => {
    a.dataRef.current.floatingContext = $;
    const M = v?.nodesRef.current.find((N) => N.id === s);
    M && (M.context = $);
  }), j.useMemo(() => ({
    ...y,
    context: $,
    refs: x,
    elements: C
  }), [y, x, C, $]);
}
function Cr() {
  return xf() && _f();
}
function Vp(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    events: r,
    dataRef: s,
    elements: i
  } = e, {
    enabled: a = !0,
    visibleOnly: l = !0
  } = t, c = j.useRef(!1), p = j.useRef(-1), f = j.useRef(!0);
  j.useEffect(() => {
    if (!a) return;
    const d = Ye(i.domReference);
    function m() {
      !n && at(i.domReference) && i.domReference === fi(Ht(i.domReference)) && (c.current = !0);
    }
    function h() {
      f.current = !0;
    }
    function v() {
      f.current = !1;
    }
    return d.addEventListener("blur", m), Cr() && (d.addEventListener("keydown", h, !0), d.addEventListener("pointerdown", v, !0)), () => {
      d.removeEventListener("blur", m), Cr() && (d.removeEventListener("keydown", h, !0), d.removeEventListener("pointerdown", v, !0));
    };
  }, [i.domReference, n, a]), j.useEffect(() => {
    if (!a) return;
    function d(m) {
      let {
        reason: h
      } = m;
      (h === "reference-press" || h === "escape-key") && (c.current = !0);
    }
    return r.on("openchange", d), () => {
      r.off("openchange", d);
    };
  }, [r, a]), j.useEffect(() => () => {
    ze(p);
  }, []);
  const u = j.useMemo(() => ({
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(d) {
      if (c.current) return;
      const m = cn(d.nativeEvent);
      if (l && ye(m)) {
        if (Cr() && !d.relatedTarget) {
          if (!f.current && !$f(m))
            return;
        } else if (!Pf(m))
          return;
      }
      o(!0, d.nativeEvent, "focus");
    },
    onBlur(d) {
      c.current = !1;
      const m = d.relatedTarget, h = d.nativeEvent, v = ye(m) && m.hasAttribute(hs("focus-guard")) && m.getAttribute("data-type") === "outside";
      p.current = window.setTimeout(() => {
        var y;
        const _ = fi(i.domReference ? i.domReference.ownerDocument : document);
        !m && _ === i.domReference || kn((y = s.current.floatingContext) == null ? void 0 : y.refs.floating.current, _) || kn(i.domReference, _) || v || o(!1, h, "focus");
      });
    }
  }), [s, i.domReference, o, l]);
  return j.useMemo(() => a ? {
    reference: u
  } : {}, [a, u]);
}
function _r(e, t, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item";
  let s = e;
  if (r && e) {
    const {
      [wi]: i,
      [Ci]: a,
      ...l
    } = e;
    s = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Dp]: ""
    },
    ...s,
    ...t.map((i) => {
      const a = i ? i[n] : null;
      return typeof a == "function" ? e ? a(e) : null : a;
    }).concat(e).reduce((i, a) => (a && Object.entries(a).forEach((l) => {
      let [c, p] = l;
      if (!(r && [wi, Ci].includes(c)))
        if (c.indexOf("on") === 0) {
          if (o.has(c) || o.set(c, []), typeof p == "function") {
            var f;
            (f = o.get(c)) == null || f.push(p), i[c] = function() {
              for (var u, d = arguments.length, m = new Array(d), h = 0; h < d; h++)
                m[h] = arguments[h];
              return (u = o.get(c)) == null ? void 0 : u.map((v) => v(...m)).find((v) => v !== void 0);
            };
          }
        } else
          i[c] = p;
    }), i), {})
  };
}
function jp(e) {
  e === void 0 && (e = []);
  const t = e.map((a) => a?.reference), n = e.map((a) => a?.floating), o = e.map((a) => a?.item), r = j.useCallback(
    (a) => _r(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), s = j.useCallback(
    (a) => _r(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = j.useCallback(
    (a) => _r(a, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  );
  return j.useMemo(() => ({
    getReferenceProps: r,
    getFloatingProps: s,
    getItemProps: i
  }), [r, s, i]);
}
const Gp = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Kp(e, t) {
  var n, o;
  t === void 0 && (t = {});
  const {
    open: r,
    elements: s,
    floatingId: i
  } = e, {
    enabled: a = !0,
    role: l = "dialog"
  } = t, c = ja(), p = ((n = s.domReference) == null ? void 0 : n.id) || c, f = j.useMemo(() => {
    var _;
    return ((_ = Mf(s.floating)) == null ? void 0 : _.id) || i;
  }, [s.floating, i]), u = (o = Gp.get(l)) != null ? o : l, m = ps() != null, h = j.useMemo(() => u === "tooltip" || l === "label" ? {
    ["aria-" + (l === "label" ? "labelledby" : "describedby")]: r ? f : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": u === "alertdialog" ? "dialog" : u,
    "aria-controls": r ? f : void 0,
    ...u === "listbox" && {
      role: "combobox"
    },
    ...u === "menu" && {
      id: p
    },
    ...u === "menu" && m && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [u, f, m, r, p, l]), v = j.useMemo(() => {
    const _ = {
      id: f,
      ...u && {
        role: u
      }
    };
    return u === "tooltip" || l === "label" ? _ : {
      ..._,
      ...u === "menu" && {
        "aria-labelledby": p
      }
    };
  }, [u, f, p, l]), y = j.useCallback((_) => {
    let {
      active: w,
      selected: x
    } = _;
    const C = {
      role: "option",
      ...w && {
        id: f + "-fui-option"
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...C,
          "aria-selected": x
        };
    }
    return {};
  }, [f, l]);
  return j.useMemo(() => a ? {
    reference: h,
    floating: v,
    item: y
  } : {}, [a, h, v, y]);
}
function Ka(e, t, n) {
  return n === void 0 && (n = !0), e.filter((r) => {
    var s;
    return r.parentId === t && (!n || ((s = r.context) == null ? void 0 : s.open));
  }).flatMap((r) => [r, ...Ka(e, r.id, n)]);
}
function Di(e, t) {
  const [n, o] = e;
  let r = !1;
  const s = t.length;
  for (let i = 0, a = s - 1; i < s; a = i++) {
    const [l, c] = t[i] || [0, 0], [p, f] = t[a] || [0, 0];
    c >= o != f >= o && n <= (p - l) * (o - c) / (f - c) + l && (r = !r);
  }
  return r;
}
function Up(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function Xp(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: o = !0
  } = e, r = {
    current: -1
  };
  let s = !1, i = null, a = null, l = typeof performance < "u" ? performance.now() : 0;
  function c(f, u) {
    const d = performance.now(), m = d - l;
    if (i === null || a === null || m === 0)
      return i = f, a = u, l = d, null;
    const h = f - i, v = u - a, _ = Math.sqrt(h * h + v * v) / m;
    return i = f, a = u, l = d, _;
  }
  const p = (f) => {
    let {
      x: u,
      y: d,
      placement: m,
      elements: h,
      onClose: v,
      nodeId: y,
      tree: _
    } = f;
    return function(x) {
      function C() {
        ze(r), v();
      }
      if (ze(r), !h.domReference || !h.floating || m == null || u == null || d == null)
        return;
      const {
        clientX: $,
        clientY: M
      } = x, N = [$, M], I = Fp(x), E = x.type === "mouseleave", O = wr(h.floating, I), B = wr(h.domReference, I), A = h.domReference.getBoundingClientRect(), S = h.floating.getBoundingClientRect(), k = m.split("-")[0], R = u > S.right - S.width / 2, D = d > S.bottom - S.height / 2, b = Up(N, A), T = S.width > A.width, P = S.height > A.height, F = (T ? A : S).left, L = (T ? A : S).right, Y = (P ? A : S).top, z = (P ? A : S).bottom;
      if (O && (s = !0, !E))
        return;
      if (B && (s = !1), B && !E) {
        s = !0;
        return;
      }
      if (E && ye(x.relatedTarget) && wr(h.floating, x.relatedTarget) || _ && Ka(_.nodesRef.current, y).length)
        return;
      if (k === "top" && d >= A.bottom - 1 || k === "bottom" && d <= A.top + 1 || k === "left" && u >= A.right - 1 || k === "right" && u <= A.left + 1)
        return C();
      let V = [];
      switch (k) {
        case "top":
          V = [[F, A.top + 1], [F, S.bottom - 1], [L, S.bottom - 1], [L, A.top + 1]];
          break;
        case "bottom":
          V = [[F, S.top + 1], [F, A.bottom - 1], [L, A.bottom - 1], [L, S.top + 1]];
          break;
        case "left":
          V = [[S.right - 1, z], [S.right - 1, Y], [A.left + 1, Y], [A.left + 1, z]];
          break;
        case "right":
          V = [[A.right - 1, z], [A.right - 1, Y], [S.left + 1, Y], [S.left + 1, z]];
          break;
      }
      function U(ee) {
        let [X, G] = ee;
        switch (k) {
          case "top": {
            const J = [T ? X + t / 2 : R ? X + t * 4 : X - t * 4, G + t + 1], ie = [T ? X - t / 2 : R ? X + t * 4 : X - t * 4, G + t + 1], ae = [[S.left, R || T ? S.bottom - t : S.top], [S.right, R ? T ? S.bottom - t : S.top : S.bottom - t]];
            return [J, ie, ...ae];
          }
          case "bottom": {
            const J = [T ? X + t / 2 : R ? X + t * 4 : X - t * 4, G - t], ie = [T ? X - t / 2 : R ? X + t * 4 : X - t * 4, G - t], ae = [[S.left, R || T ? S.top + t : S.bottom], [S.right, R ? T ? S.top + t : S.bottom : S.top + t]];
            return [J, ie, ...ae];
          }
          case "left": {
            const J = [X + t + 1, P ? G + t / 2 : D ? G + t * 4 : G - t * 4], ie = [X + t + 1, P ? G - t / 2 : D ? G + t * 4 : G - t * 4];
            return [...[[D || P ? S.right - t : S.left, S.top], [D ? P ? S.right - t : S.left : S.right - t, S.bottom]], J, ie];
          }
          case "right": {
            const J = [X - t, P ? G + t / 2 : D ? G + t * 4 : G - t * 4], ie = [X - t, P ? G - t / 2 : D ? G + t * 4 : G - t * 4], ae = [[D || P ? S.left + t : S.right, S.top], [D ? P ? S.left + t : S.right : S.left + t, S.bottom]];
            return [J, ie, ...ae];
          }
        }
      }
      if (!Di([$, M], V)) {
        if (s && !b)
          return C();
        if (!E && o) {
          const ee = c(x.clientX, x.clientY);
          if (ee !== null && ee < 0.1)
            return C();
        }
        Di([$, M], U([u, d])) ? !s && o && (r.current = window.setTimeout(C, 40)) : C();
      }
    };
  };
  return p.__options = {
    blockPointerEvents: n
  }, p;
}
const Ua = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
}, Xa = (e, { scrollbarSize: t, overscrollBehavior: n, scrollbars: o }) => {
  let r = n;
  return n && o && (o === "x" ? r = `${n} auto` : o === "y" && (r = `auto ${n}`)), { root: {
    "--scrollarea-scrollbar-size": W(t),
    "--scrollarea-over-scroll-behavior": r
  } };
}, qt = te((e) => {
  const t = K("ScrollArea", Ua, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, scrollbarSize: a, vars: l, type: c, scrollHideDelay: p, viewportProps: f, viewportRef: u, onScrollPositionChange: d, children: m, offsetScrollbars: h, scrollbars: v, onBottomReached: y, onTopReached: _, onLeftReached: w, onRightReached: x, overscrollBehavior: C, startScrollPosition: $, verticalScrollbarPosition: M, attributes: N, ...I } = t, [E, O] = re(!1), [B, A] = re(!1), [S, k] = re(!1), R = Z(!0), D = Z(!1), b = Z(!0), T = Z(!1), P = se({
    name: "ScrollArea",
    props: t,
    classes: ss,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: N,
    vars: l,
    varsResolver: Xa
  }), F = Z(null), [L, Y] = re(null), z = de((U) => {
    Y((ee) => ee === U ? ee : U);
  }, []), V = Va([
    u,
    F,
    z
  ]);
  return kt(h === "present" ? L : null, () => {
    const U = F.current;
    U && (A(U.scrollHeight > U.clientHeight), k(U.scrollWidth > U.clientWidth));
  }), Ct(() => {
    $ && F.current && F.current.scrollTo({
      left: $.x ?? 0,
      top: $.y ?? 0
    });
  }, []), /* @__PURE__ */ oe(wa, {
    getStyles: P,
    type: c === "never" ? "always" : c,
    scrollHideDelay: p,
    scrollbars: v,
    ...P("root"),
    ...I,
    children: [
      /* @__PURE__ */ g(Ta, {
        ...f,
        ...P("viewport", { style: f?.style }),
        ref: V,
        "data-offset-scrollbars": h === !0 ? "xy" : h || void 0,
        "data-scrollbars": v || void 0,
        "data-vertical-scrollbar-position": M || void 0,
        "data-horizontal-hidden": h === "present" && !S ? "true" : void 0,
        "data-vertical-hidden": h === "present" && !B ? "true" : void 0,
        onScroll: (U) => {
          f?.onScroll?.(U), d?.({
            x: U.currentTarget.scrollLeft,
            y: U.currentTarget.scrollTop
          });
          const { scrollTop: ee, scrollHeight: X, clientHeight: G, scrollLeft: J, scrollWidth: ie, clientWidth: ae } = U.currentTarget, ne = ee - (X - G) >= -0.8, ue = ee === 0;
          ne && !D.current && y?.(), ue && !R.current && _?.(), D.current = ne, R.current = ue;
          const le = J - (ie - ae) >= -0.8, Q = J === 0;
          le && !T.current && x?.(), Q && !b.current && w?.(), T.current = le, b.current = Q;
        },
        children: m
      }),
      (v === "xy" || v === "x") && /* @__PURE__ */ g(Lr, {
        ...P("scrollbar"),
        orientation: "horizontal",
        "data-vertical-scrollbar-position": M || void 0,
        "data-hidden": c === "never" || h === "present" && !S ? !0 : void 0,
        forceMount: !0,
        onMouseEnter: () => O(!0),
        onMouseLeave: () => O(!1),
        children: /* @__PURE__ */ g(Er, { ...P("thumb") })
      }),
      (v === "xy" || v === "y") && /* @__PURE__ */ g(Lr, {
        ...P("scrollbar"),
        orientation: "vertical",
        "data-vertical-scrollbar-position": M || void 0,
        "data-hidden": c === "never" || h === "present" && !B ? !0 : void 0,
        forceMount: !0,
        onMouseEnter: () => O(!0),
        onMouseLeave: () => O(!1),
        children: /* @__PURE__ */ g(Er, { ...P("thumb") })
      }),
      /* @__PURE__ */ g(Qd, {
        ...P("corner"),
        "data-vertical-scrollbar-position": M || void 0,
        "data-hovered": E || void 0,
        "data-hidden": c === "never" || void 0
      })
    ]
  });
});
qt.displayName = "@mantine/core/ScrollArea";
const vs = te((e) => {
  const { children: t, classNames: n, styles: o, scrollbarSize: r, scrollHideDelay: s, type: i, dir: a, offsetScrollbars: l, overscrollBehavior: c, viewportRef: p, onScrollPositionChange: f, unstyled: u, variant: d, viewportProps: m, scrollbars: h, style: v, vars: y, onBottomReached: _, onTopReached: w, startScrollPosition: x, verticalScrollbarPosition: C, onOverflowChange: $, ...M } = K("ScrollAreaAutosize", Ua, e), N = Z(null), [I, E] = re(null), O = de((R) => {
    E((D) => D === R ? D : R);
  }, []), B = Va([
    p,
    N,
    O
  ]), A = Z(!1), S = Z(!1), k = po(() => {
    const R = N.current;
    if (!R || !$) return;
    const D = R.scrollHeight > R.clientHeight;
    D !== A.current && (S.current ? $(D) : (S.current = !0, D && $(!0)), A.current = D);
  });
  return kt($ ? I : null, k), /* @__PURE__ */ g(q, {
    ...M,
    variant: d,
    style: [{
      display: "flex",
      overflow: "hidden"
    }, v],
    children: /* @__PURE__ */ g(q, {
      style: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
        ...h === "y" && { minWidth: 0 },
        ...h === "x" && { minHeight: 0 },
        ...h === "xy" && {
          minWidth: 0,
          minHeight: 0
        },
        ...h === !1 && {
          minWidth: 0,
          minHeight: 0
        }
      },
      children: /* @__PURE__ */ g(qt, {
        classNames: n,
        styles: o,
        scrollHideDelay: s,
        scrollbarSize: r,
        type: i,
        dir: a,
        offsetScrollbars: l,
        overscrollBehavior: c,
        viewportRef: B,
        onScrollPositionChange: f,
        unstyled: u,
        variant: d,
        viewportProps: m,
        vars: y,
        scrollbars: h,
        onBottomReached: _,
        onTopReached: w,
        startScrollPosition: x,
        verticalScrollbarPosition: C,
        "data-autosize": "true",
        children: t
      })
    })
  });
});
qt.classes = ss;
qt.varsResolver = Xa;
vs.displayName = "@mantine/core/ScrollAreaAutosize";
vs.classes = ss;
qt.Autosize = vs;
var qa = { root: "m_87cf2631" };
const qp = { __staticSelector: "UnstyledButton" }, nt = it((e) => {
  const t = K("UnstyledButton", qp, e), { className: n, component: o = "button", __staticSelector: r, unstyled: s, classNames: i, styles: a, style: l, attributes: c, ...p } = t, f = se({
    name: r,
    props: t,
    classes: qa,
    className: n,
    style: l,
    classNames: i,
    styles: a,
    unstyled: s,
    attributes: c
  });
  return /* @__PURE__ */ g(q, {
    ...f("root", { focusable: !0 }),
    component: o,
    type: o === "button" ? "button" : void 0,
    ...p
  });
});
nt.classes = qa;
nt.displayName = "@mantine/core/UnstyledButton";
var Za = { root: "m_515a97f8" };
const ys = te((e) => {
  const t = K("VisuallyHidden", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, attributes: l, ...c } = t, p = se({
    name: "VisuallyHidden",
    classes: Za,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: l
  });
  return /* @__PURE__ */ g(q, {
    component: "span",
    ...p("root"),
    ...c
  });
});
ys.classes = Za;
ys.displayName = "@mantine/core/VisuallyHidden";
var Ja = { root: "m_1b7284a3" };
const Qa = (e, { radius: t, shadow: n }) => ({ root: {
  "--paper-radius": t === void 0 ? void 0 : Ve(t),
  "--paper-shadow": Ji(n)
} }), At = it((e) => {
  const t = K("Paper", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, withBorder: a, vars: l, radius: c, shadow: p, variant: f, mod: u, attributes: d, ...m } = t, h = se({
    name: "Paper",
    props: t,
    classes: Ja,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: d,
    vars: l,
    varsResolver: Qa
  });
  return /* @__PURE__ */ g(q, {
    mod: [{ withBorder: a }, u],
    ...h("root"),
    variant: f,
    ...m
  });
});
At.classes = Ja;
At.varsResolver = Qa;
At.displayName = "@mantine/core/Paper";
function $i(e, t, n, o) {
  return e === "center" || o === "center" ? { top: t } : e === "end" ? { bottom: n } : e === "start" ? { top: n } : {};
}
function Pi(e, t, n, o, r) {
  return e === "center" || o === "center" ? { left: t } : e === "end" ? { [r === "ltr" ? "right" : "left"]: n } : e === "start" ? { [r === "ltr" ? "left" : "right"]: n } : {};
}
const Zp = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function Jp({ position: e, arrowSize: t, dir: n }) {
  const [o, r] = e.split("-");
  if (!r) return;
  const s = {
    width: t,
    height: t,
    position: "absolute"
  };
  if (o === "bottom") {
    const i = r === "start", a = i ? n === "ltr" ? "left" : "right" : n === "ltr" ? "right" : "left";
    return {
      ...s,
      top: -t,
      [a]: 0,
      clipPath: i !== (n === "rtl") ? "polygon(0% 0%, 0% 100%, 100% 100%)" : "polygon(100% 0%, 0% 100%, 100% 100%)"
    };
  }
  if (o === "top") {
    const i = r === "start", a = i ? n === "ltr" ? "left" : "right" : n === "ltr" ? "right" : "left";
    return {
      ...s,
      bottom: -t,
      [a]: 0,
      clipPath: i !== (n === "rtl") ? "polygon(0% 0%, 100% 0%, 0% 100%)" : "polygon(0% 0%, 100% 0%, 100% 100%)"
    };
  }
  if (o === "left") return {
    ...s,
    right: -t,
    [r === "start" ? "top" : "bottom"]: 0,
    clipPath: r === "start" ? "polygon(0% 0%, 100% 0%, 0% 100%)" : "polygon(0% 0%, 0% 100%, 100% 100%)"
  };
  if (o === "right") return {
    ...s,
    left: -t,
    [r === "start" ? "top" : "bottom"]: 0,
    clipPath: r === "start" ? "polygon(0% 0%, 100% 0%, 100% 100%)" : "polygon(100% 0%, 0% 100%, 100% 100%)"
  };
}
function Qp({ position: e, arrowSize: t, arrowOffset: n, arrowRadius: o, arrowPosition: r, arrowX: s, arrowY: i, dir: a }) {
  if (r === "merge") {
    const u = Jp({
      position: e,
      arrowSize: t,
      dir: a
    });
    if (u) return u;
  }
  const [l, c = "center"] = e.split("-"), p = {
    width: t,
    height: t,
    transform: "rotate(45deg)",
    position: "absolute",
    [Zp[l]]: o
  }, f = -t / 2;
  return l === "left" ? {
    ...p,
    ...$i(c, i, n, r),
    right: f,
    borderLeftColor: "transparent",
    borderBottomColor: "transparent",
    clipPath: "polygon(100% 0, 0 0, 100% 100%)"
  } : l === "right" ? {
    ...p,
    ...$i(c, i, n, r),
    left: f,
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    clipPath: "polygon(0 100%, 0 0, 100% 100%)"
  } : l === "top" ? {
    ...p,
    ...Pi(c, s, n, r, a),
    bottom: f,
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    clipPath: "polygon(0 100%, 100% 100%, 100% 0)"
  } : l === "bottom" ? {
    ...p,
    ...Pi(c, s, n, r, a),
    top: f,
    borderBottomColor: "transparent",
    borderRightColor: "transparent",
    clipPath: "polygon(0 100%, 0 0, 100% 0)"
  } : {};
}
function el({ position: e, dir: t }) {
  const [n, o] = e.split("-");
  if (!o) return;
  const r = o === "start" && t === "ltr" || o === "end" && t === "rtl";
  if (n === "bottom") return r ? { borderTopLeftRadius: 0 } : { borderTopRightRadius: 0 };
  if (n === "top") return r ? { borderBottomLeftRadius: 0 } : { borderBottomRightRadius: 0 };
  if (n === "left") return o === "start" ? { borderTopRightRadius: 0 } : { borderBottomRightRadius: 0 };
  if (n === "right") return o === "start" ? { borderTopLeftRadius: 0 } : { borderBottomLeftRadius: 0 };
}
function fo({ position: e, arrowSize: t, arrowOffset: n, arrowRadius: o, arrowPosition: r, visible: s, arrowX: i, arrowY: a, style: l, ...c }) {
  const { dir: p } = An();
  return s ? /* @__PURE__ */ g("div", {
    role: "presentation",
    ...c,
    style: {
      ...l,
      ...Qp({
        position: e,
        arrowSize: t,
        arrowOffset: n,
        arrowRadius: o,
        arrowPosition: r,
        dir: p,
        arrowX: i,
        arrowY: a
      })
    }
  }) : null;
}
fo.displayName = "@mantine/core/FloatingArrow";
function tl(e, t) {
  if (e === "rtl" && (t.includes("right") || t.includes("left"))) {
    const [n, o] = t.split("-"), r = n === "right" ? "left" : "right";
    return o === void 0 ? r : `${r}-${o}`;
  }
  return t;
}
var nl = { root: "m_9814e45f" };
const em = { zIndex: go("modal") }, ol = (e, { gradient: t, color: n, backgroundOpacity: o, blur: r, radius: s, zIndex: i }) => ({ root: {
  "--overlay-bg": t || (n !== void 0 || o !== void 0) && Pt(n || "#000", o ?? 0.6) || void 0,
  "--overlay-filter": r ? `blur(${W(r)})` : void 0,
  "--overlay-radius": s === void 0 ? void 0 : Ve(s),
  "--overlay-z-index": i?.toString()
} }), Po = it((e) => {
  const t = K("Overlay", em, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, fixed: l, center: c, children: p, radius: f, zIndex: u, gradient: d, blur: m, color: h, backgroundOpacity: v, mod: y, attributes: _, ...w } = t, x = se({
    name: "Overlay",
    props: t,
    classes: nl,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: _,
    vars: a,
    varsResolver: ol
  });
  return /* @__PURE__ */ g(q, {
    ...x("root"),
    mod: [{
      center: c,
      fixed: l
    }, y],
    ...w,
    children: p
  });
});
Po.classes = nl;
Po.varsResolver = ol;
Po.displayName = "@mantine/core/Overlay";
function xr(e) {
  const t = document.createElement("div");
  return t.setAttribute("data-portal", "true"), typeof e.className == "string" && t.classList.add(...e.className.split(" ").filter(Boolean)), typeof e.style == "object" && Object.assign(t.style, e.style), typeof e.id == "string" && t.setAttribute("id", e.id), t;
}
function tm({ target: e, reuseTargetNode: t, ...n }) {
  if (e)
    return typeof e == "string" ? document.querySelector(e) || xr(n) : e;
  if (t) {
    const o = document.querySelector("[data-mantine-shared-portal-node]");
    if (o) return o;
    const r = xr(n);
    return r.setAttribute("data-mantine-shared-portal-node", "true"), document.body.appendChild(r), r;
  }
  return xr(n);
}
const nm = { reuseTargetNode: !0 }, rl = te((e) => {
  const { children: t, target: n, reuseTargetNode: o, ref: r, ...s } = K("Portal", nm, e), [i, a] = re(!1), l = Z(null);
  return Ct(() => (a(!0), l.current = tm({
    target: n,
    reuseTargetNode: o,
    ...s
  }), Pr(r, l.current), !n && !o && l.current && document.body.appendChild(l.current), () => {
    !n && !o && l.current && document.body.removeChild(l.current);
  }), [n]), !i || !l.current ? null : lu(/* @__PURE__ */ g(Pe, { children: t }), l.current);
});
rl.displayName = "@mantine/core/Portal";
const pn = te(({ withinPortal: e = !0, children: t, ...n }) => Jr() === "test" || !e ? /* @__PURE__ */ g(Pe, { children: t }) : /* @__PURE__ */ g(rl, {
  ...n,
  children: t
}));
pn.displayName = "@mantine/core/OptionalPortal";
const Rn = (e) => ({
  in: {
    opacity: 1,
    transform: "scale(1)"
  },
  out: {
    opacity: 0,
    transform: `scale(.9) translateY(${e === "bottom" ? 10 : -10}px)`
  },
  transitionProperty: "transform, opacity"
}), qn = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  "fade-up": {
    in: {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(30px)"
    },
    transitionProperty: "opacity, transform"
  },
  "fade-down": {
    in: {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(-30px)"
    },
    transitionProperty: "opacity, transform"
  },
  "fade-left": {
    in: {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(30px)"
    },
    transitionProperty: "opacity, transform"
  },
  "fade-right": {
    in: {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(-30px)"
    },
    transitionProperty: "opacity, transform"
  },
  scale: {
    in: {
      opacity: 1,
      transform: "scale(1)"
    },
    out: {
      opacity: 0,
      transform: "scale(0)"
    },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: {
      opacity: 1,
      transform: "scaleY(1)"
    },
    out: {
      opacity: 0,
      transform: "scaleY(0)"
    },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: {
      opacity: 1,
      transform: "scaleX(1)"
    },
    out: {
      opacity: 0,
      transform: "scaleX(0)"
    },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: {
      opacity: 1,
      transform: "translateY(0) skew(0deg, 0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(-20px) skew(-10deg, -5deg)"
    },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: {
      opacity: 1,
      transform: "translateY(0) skew(0deg, 0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(20px) skew(-10deg, -5deg)"
    },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: {
      opacity: 1,
      transform: "translateY(0) rotate(0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(20px) rotate(-5deg)"
    },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: {
      opacity: 1,
      transform: "translateY(0) rotate(0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(20px) rotate(5deg)"
    },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(-100%)"
    },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(100%)"
    },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(100%)"
    },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(-100%)"
    },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: {
    ...Rn("bottom"),
    common: { transformOrigin: "center center" }
  },
  "pop-bottom-left": {
    ...Rn("bottom"),
    common: { transformOrigin: "bottom left" }
  },
  "pop-bottom-right": {
    ...Rn("bottom"),
    common: { transformOrigin: "bottom right" }
  },
  "pop-top-left": {
    ...Rn("top"),
    common: { transformOrigin: "top left" }
  },
  "pop-top-right": {
    ...Rn("top"),
    common: { transformOrigin: "top right" }
  }
}, Mi = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function Ti({ transition: e, state: t, duration: n, timingFunction: o }) {
  const r = {
    WebkitBackfaceVisibility: "hidden",
    transitionDuration: `${n}ms`,
    transitionTimingFunction: o
  };
  return typeof e == "string" ? e in qn ? {
    transitionProperty: qn[e].transitionProperty,
    ...r,
    ...qn[e].common,
    ...qn[e][Mi[t]]
  } : {} : {
    transitionProperty: e.transitionProperty,
    ...r,
    ...e.common,
    ...e[Mi[t]]
  };
}
function om({ duration: e, exitDuration: t, timingFunction: n, mounted: o, onEnter: r, onExit: s, onEntered: i, onExited: a, enterDelay: l, exitDelay: c }) {
  const p = Xe(), f = oa(), u = p.respectReducedMotion ? f : !1, [d, m] = re(u ? 0 : e), [h, v] = re(o ? "entered" : "exited"), y = Z(-1), _ = Z(-1), w = Z(-1);
  function x() {
    window.clearTimeout(y.current), window.clearTimeout(_.current), cancelAnimationFrame(w.current);
  }
  const C = (M) => {
    x();
    const N = M ? r : s, I = M ? i : a, E = u ? 0 : M ? e : t;
    m(E), E === 0 ? (typeof N == "function" && N(), typeof I == "function" && I(), v(M ? "entered" : "exited")) : w.current = requestAnimationFrame(() => {
      au.flushSync(() => {
        v(M ? "pre-entering" : "pre-exiting");
      }), w.current = requestAnimationFrame(() => {
        typeof N == "function" && N(), v(M ? "entering" : "exiting"), y.current = window.setTimeout(() => {
          typeof I == "function" && I(), v(M ? "entered" : "exited");
        }, E);
      });
    });
  }, $ = (M) => {
    if (x(), typeof (M ? l : c) != "number") {
      C(M);
      return;
    }
    _.current = window.setTimeout(() => {
      C(M);
    }, M ? l : c);
  };
  return Ur(() => {
    $(o);
  }, [o]), ce(() => () => {
    x();
  }, []), {
    transitionDuration: d,
    transitionStatus: h,
    transitionTimingFunction: n || "ease"
  };
}
function mn({ keepMounted: e, keepMountedMode: t = "activity", transition: n = "fade", duration: o = 250, exitDuration: r = o, mounted: s, children: i, timingFunction: a = "ease", onExit: l, onEntered: c, onEnter: p, onExited: f, enterDelay: u, exitDelay: d }) {
  const m = Jr(), { transitionDuration: h, transitionStatus: v, transitionTimingFunction: y } = om({
    mounted: s,
    exitDuration: r,
    duration: o,
    timingFunction: a,
    onExit: l,
    onEntered: c,
    onEnter: p,
    onExited: f,
    enterDelay: u,
    exitDelay: d
  });
  if (m === "test") return s ? /* @__PURE__ */ g(Pe, { children: i({}) }) : e ? i({ display: "none" }) : null;
  if (h === 0)
    return e ? t === "display-none" ? s ? /* @__PURE__ */ g(Pe, { children: i({}) }) : i({ display: "none" }) : /* @__PURE__ */ g(Us, {
      mode: s ? "visible" : "hidden",
      children: i({})
    }) : s ? /* @__PURE__ */ g(Pe, { children: i({}) }) : null;
  const _ = v === "exited";
  if (e) {
    const w = i(_ ? t === "display-none" ? { display: "none" } : {} : Ti({
      transition: n,
      duration: h,
      state: v,
      timingFunction: y
    }));
    return t === "display-none" ? w : /* @__PURE__ */ g(Us, {
      mode: _ ? "hidden" : "visible",
      children: w
    });
  }
  return _ ? null : /* @__PURE__ */ g(Pe, { children: i(Ti({
    transition: n,
    duration: h,
    state: v,
    timingFunction: y
  })) });
}
mn.displayName = "@mantine/core/Transition";
const rm = {
  duration: 100,
  transition: "fade"
};
function Ni(e, t) {
  return {
    ...rm,
    ...t,
    ...e
  };
}
const [sm, bs] = hn("Popover component was not found in the tree");
function im({ childProps: e, disabled: t, opened: n, longPressDelay: o = 500, setReference: r, open: s }) {
  const i = Z(!1), a = Z(!1), l = Z(null), c = Z(t);
  c.current = t;
  const p = (m, h, v) => {
    r({
      getBoundingClientRect: () => ({
        x: m,
        y: h,
        width: 0,
        height: 0,
        top: h,
        left: m,
        right: m,
        bottom: h,
        toJSON: () => {
        }
      }),
      contextElement: v
    }), s();
  }, f = an(e.onMouseDown, (m) => {
    t || m.button === 2 && m.stopPropagation();
  }), u = an(e.onContextMenu, (m) => {
    t || m.defaultPrevented || (m.preventDefault(), !a.current && (p(m.clientX, m.clientY, m.currentTarget), i.current && (a.current = !0)));
  }), d = Fu((m) => {
    if (c.current || a.current) return;
    const h = m, v = h.touches[0] ?? h.changedTouches[0];
    v && (p(v.clientX, v.clientY, l.current), a.current = !0);
  }, {
    threshold: o,
    events: ["touch"],
    cancelOnMove: !0,
    onStart: (m) => {
      i.current = !0, a.current = !1, l.current = m.currentTarget;
    },
    onFinish: (m) => {
      i.current = !1, a.current = !1, c.current || m.preventDefault();
    },
    onCancel: () => {
      i.current = !1, a.current = !1;
    }
  });
  return {
    onContextMenu: u,
    onMouseDown: f,
    onTouchStart: an(e.onTouchStart, d.onTouchStart),
    onTouchEnd: an(e.onTouchEnd, d.onTouchEnd),
    onTouchCancel: an(e.onTouchCancel, d.onTouchCancel),
    onTouchMove: an(e.onTouchMove, d.onTouchMove),
    style: t ? e.style : {
      ...e.style,
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      userSelect: "none"
    },
    "data-expanded": n ? !0 : void 0
  };
}
function sl(e) {
  const { children: t, disabled: n, longPressDelay: o } = K("PopoverContextMenu", null, e), r = Ut(t);
  if (!r) throw new Error("Popover.ContextMenu component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  const s = bs(), i = im({
    childProps: r.props,
    disabled: n || s.disabled,
    opened: s.opened,
    longPressDelay: o,
    setReference: s.reference,
    open: () => {
      s.opened || s.onToggle();
    }
  });
  return Kt(r, i);
}
sl.displayName = "@mantine/core/PopoverContextMenu";
function ws({ children: e, active: t = !0, refProp: n = "ref", innerRef: o }) {
  const r = Pu(t), s = Me(r, o), i = Ut(e);
  return i ? Kt(i, { [n]: s }) : e;
}
function il(e) {
  return /* @__PURE__ */ g(ys, {
    tabIndex: -1,
    "data-autofocus": !0,
    ...e
  });
}
ws.displayName = "@mantine/core/FocusTrap";
il.displayName = "@mantine/core/FocusTrapInitialFocus";
ws.InitialFocus = il;
var al = {
  dropdown: "m_38a85659",
  arrow: "m_a31dc6c1",
  overlay: "m_3d7bc908"
};
const Cs = te((e) => {
  const t = K("PopoverDropdown", null, e), { className: n, style: o, vars: r, children: s, onKeyDownCapture: i, variant: a, classNames: l, styles: c, ref: p, ...f } = t, u = bs(), { dir: d } = An(), m = u.arrowPosition === "merge" && u.withArrow ? el({
    position: u.placement,
    dir: d
  }) : void 0, h = _u({
    opened: u.opened,
    shouldReturnFocus: u.returnFocus
  }), v = u.withRoles ? {
    "aria-labelledby": u.getTargetId(),
    id: u.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {}, y = Me(p, u.floating);
  return u.disabled ? null : /* @__PURE__ */ g(pn, {
    ...u.portalProps,
    withinPortal: u.withinPortal,
    children: /* @__PURE__ */ g(mn, {
      mounted: u.opened,
      ...u.transitionProps,
      transition: u.transitionProps?.transition || "fade",
      duration: u.transitionProps?.duration ?? 150,
      keepMounted: u.keepMounted,
      keepMountedMode: u.keepMountedMode,
      exitDuration: typeof u.transitionProps?.exitDuration == "number" ? u.transitionProps.exitDuration : u.transitionProps?.duration,
      children: (_) => /* @__PURE__ */ g(ws, {
        active: u.trapFocus && u.opened,
        innerRef: y,
        children: /* @__PURE__ */ oe(q, {
          ...v,
          ...f,
          variant: a,
          onKeyDownCapture: mu(() => {
            u.onClose?.(), u.onDismiss?.();
          }, {
            active: u.closeOnEscape,
            onTrigger: h,
            onKeyDown: i
          }),
          "data-position": u.placement,
          "data-fixed": u.floatingStrategy === "fixed" || void 0,
          ...u.getStyles("dropdown", {
            className: n,
            props: t,
            classNames: l,
            styles: c,
            style: [
              {
                ..._,
                ...m,
                zIndex: u.zIndex,
                top: u.y ?? 0,
                left: u.x ?? 0,
                width: u.width === "target" ? void 0 : W(u.width),
                ...u.referenceHidden ? { display: "none" } : null
              },
              u.resolvedStyles?.dropdown,
              c?.dropdown,
              o
            ]
          }),
          children: [s, /* @__PURE__ */ g(fo, {
            ref: u.arrowRef,
            arrowX: u.arrowX,
            arrowY: u.arrowY,
            visible: u.withArrow,
            position: u.placement,
            arrowSize: u.arrowSize,
            arrowRadius: u.arrowRadius,
            arrowOffset: u.arrowOffset,
            arrowPosition: u.arrowPosition,
            ...u.getStyles("arrow", {
              props: t,
              classNames: l,
              styles: c
            })
          })]
        })
      })
    })
  });
});
Cs.classes = al;
Cs.displayName = "@mantine/core/PopoverDropdown";
const am = {
  refProp: "ref",
  popupType: "dialog"
}, ll = te((e) => {
  const { children: t, refProp: n, popupType: o, ref: r, ...s } = K("PopoverTarget", am, e), i = Ut(t);
  if (!i) throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  const a = s, l = bs(), c = Me(l.reference, yo(i), r), p = l.withRoles ? {
    "aria-haspopup": o,
    "aria-expanded": l.opened,
    "aria-controls": l.opened ? l.getDropdownId() : void 0,
    id: l.getTargetId()
  } : {}, f = i.props;
  return Kt(i, {
    ...a,
    ...p,
    ...l.targetProps,
    className: st(l.targetProps.className, a.className, f.className),
    [n]: c,
    ...l.controlled ? null : { onClick: (u) => {
      l.onToggle(), f.onClick?.(u);
    } }
  });
});
ll.displayName = "@mantine/core/PopoverTarget";
function lm(e) {
  if (e === void 0) return {
    shift: !0,
    flip: !0
  };
  const t = { ...e };
  return e.shift === void 0 && (t.shift = !0), e.flip === void 0 && (t.flip = !0), t;
}
function cm(e, t, n, o) {
  const r = lm(e.middlewares), s = [za(e.offset), Rp()];
  if (r.flip && !n) {
    const i = typeof r.flip == "boolean" ? {} : r.flip, a = o ? {
      fallbackStrategy: "initialPlacement",
      ...i
    } : i;
    s.push(Fr(a));
  }
  if (r.shift) {
    const i = typeof r.shift == "boolean" ? {} : r.shift;
    s.push(fs((a) => {
      const l = a.placement.startsWith("top") || a.placement.startsWith("bottom");
      return {
        limiter: xp(),
        padding: 5,
        ...e.width === "target" && l ? { mainAxis: !1 } : null,
        ...i
      };
    }));
  }
  return r.inline && s.push(typeof r.inline == "boolean" ? Pn() : Pn(r.inline)), s.push(Ha({
    element: e.arrowRef,
    padding: e.arrowOffset
  })), (r.size || e.width === "target") && s.push(Sp({
    ...typeof r.size == "boolean" ? {} : r.size,
    apply({ rects: i, availableWidth: a, availableHeight: l, ...c }) {
      const p = t().refs.floating.current?.style ?? {};
      r.size && (typeof r.size == "object" && r.size.apply ? r.size.apply({
        rects: i,
        availableWidth: a,
        availableHeight: l,
        ...c
      }) : Object.assign(p, {
        maxWidth: `${a}px`,
        maxHeight: `${l}px`
      })), e.width === "target" && Object.assign(p, { width: `${i.reference.width}px` });
    }
  })), s;
}
function um(e) {
  const [t, n] = _t({
    value: e.opened,
    defaultValue: e.defaultOpened,
    finalValue: !1,
    onChange: e.onChange
  }), o = Z(t), [r, s] = re(null), i = e.preventPositionChangeWhenVisible !== !1, a = Z(t);
  t !== a.current && (a.current = t, t && r !== null && s(null));
  const l = de(() => s(null), []), c = () => {
    t && !e.disabled && n(!1);
  }, p = () => {
    e.disabled || n(!t);
  }, f = gs({
    open: t,
    strategy: e.strategy,
    placement: i ? r ?? e.position : e.position,
    middleware: cm(e, () => f, i && r !== null, i),
    whileElementsMounted: e.keepMounted ? void 0 : Yr
  });
  ce(() => {
    if (!e.keepMounted) return;
    const m = f.refs.reference.current, h = f.refs.floating.current;
    if (t && m && h) return Yr(m, h, f.update);
  }, [
    e.keepMounted,
    t,
    f.update,
    f.elements.reference,
    f.elements.floating
  ]);
  const u = Z(!1);
  Ct(() => {
    if (!t) {
      u.current = !1;
      return;
    }
    if (!i || r !== null) return;
    const m = f.refs.floating.current;
    if (!(!m || m.offsetHeight === 0 || m.offsetWidth === 0)) {
      if (!u.current) {
        u.current = !0, f.update();
        return;
      }
      f.isPositioned && s(f.placement);
    }
  }, [
    i,
    t,
    f.isPositioned,
    f.placement,
    r,
    f.update
  ]);
  const d = Z(f.placement);
  return Ct(() => {
    d.current !== f.placement && (d.current = f.placement, e.onPositionChange?.(f.placement));
  }, [f.placement]), Ur(() => {
    t !== o.current && (t ? e.onOpen?.() : e.onClose?.()), o.current = t;
  }, [
    t,
    e.onClose,
    e.onOpen
  ]), {
    floating: f,
    controlled: typeof e.opened == "boolean",
    opened: t,
    onClose: c,
    onToggle: p,
    resetLockedPlacement: l
  };
}
const dm = {
  position: "bottom",
  offset: 8,
  transitionProps: {
    transition: "fade",
    duration: 150
  },
  middlewares: {
    flip: !0,
    shift: !0,
    inline: !1
  },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: !0,
  withinPortal: !0,
  closeOnEscape: !0,
  trapFocus: !1,
  withRoles: !0,
  returnFocus: !1,
  withOverlay: !1,
  hideDetached: !0,
  preventPositionChangeWhenVisible: !0,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: go("popover"),
  __staticSelector: "Popover",
  width: "max-content"
}, cl = (e, { radius: t, shadow: n }) => ({ dropdown: {
  "--popover-radius": t === void 0 ? void 0 : Ve(t),
  "--popover-shadow": Ji(n)
} });
function He(e) {
  const t = K("Popover", dm, e), { children: n, position: o, offset: r, onPositionChange: s, opened: i, transitionProps: a, onExitTransitionEnd: l, onEnterTransitionEnd: c, width: p, middlewares: f, withArrow: u, arrowSize: d, arrowOffset: m, arrowRadius: h, arrowPosition: v, unstyled: y, classNames: _, styles: w, closeOnClickOutside: x, withinPortal: C, portalProps: $, closeOnEscape: M, clickOutsideEvents: N, trapFocus: I, onClose: E, onDismiss: O, onOpen: B, onChange: A, zIndex: S, radius: k, shadow: R, id: D, defaultOpened: b, __staticSelector: T, withRoles: P, disabled: F, returnFocus: L, variant: Y, keepMounted: z, keepMountedMode: V, vars: U, floatingStrategy: ee, withOverlay: X, overlayProps: G, hideDetached: J, attributes: ie, preventPositionChangeWhenVisible: ae, ...ne } = t, ue = se({
    name: T,
    props: t,
    classes: al,
    classNames: _,
    styles: w,
    unstyled: y,
    attributes: ie,
    rootSelector: "dropdown",
    vars: U,
    varsResolver: cl
  }), { resolvedStyles: le } = gn({
    classNames: _,
    styles: w,
    props: t
  }), Q = Z(null), [me, be] = re(null), [Re, Ne] = re(null), { dir: We } = An(), ke = Jr(), Ge = Ot(D), ge = um({
    middlewares: f,
    width: p,
    position: tl(We, o),
    offset: typeof r == "number" ? r + (u ? d / 2 : 0) : r,
    arrowRef: Q,
    arrowOffset: m,
    onPositionChange: s,
    opened: i,
    defaultOpened: b,
    onChange: A,
    onOpen: B,
    onClose: E,
    onDismiss: O,
    strategy: ee,
    disabled: F,
    preventPositionChangeWhenVisible: ae,
    keepMounted: z
  });
  Qi(() => {
    x && (ge.onClose(), O?.());
  }, N, [me, Re]);
  const Dt = de((Be) => {
    be(Be), ge.floating.refs.setReference(Be);
  }, [ge.floating.refs.setReference]), De = de((Be) => {
    Ne(Be), ge.floating.refs.setFloating(Be);
  }, [ge.floating.refs.setFloating]), nn = de(() => {
    a?.onExited?.(), l?.(), ge.resetLockedPlacement();
  }, [
    a?.onExited,
    l,
    ge.resetLockedPlacement
  ]), fe = de(() => {
    a?.onEntered?.(), c?.();
  }, [a?.onEntered, c]);
  return /* @__PURE__ */ oe(sm, {
    value: {
      returnFocus: L,
      disabled: F,
      controlled: ge.controlled,
      reference: Dt,
      floating: De,
      x: ge.floating.x,
      y: ge.floating.y,
      arrowX: ge.floating?.middlewareData?.arrow?.x,
      arrowY: ge.floating?.middlewareData?.arrow?.y,
      opened: ge.opened,
      arrowRef: Q,
      transitionProps: {
        ...a,
        onExited: nn,
        onEntered: fe
      },
      width: p,
      withArrow: u,
      arrowSize: d,
      arrowOffset: m,
      arrowRadius: h,
      arrowPosition: v,
      placement: ge.floating.placement,
      trapFocus: I,
      withinPortal: C,
      portalProps: $,
      zIndex: S,
      radius: k,
      shadow: R,
      closeOnEscape: M,
      onDismiss: O,
      onClose: ge.onClose,
      onToggle: ge.onToggle,
      getTargetId: () => Ge,
      getDropdownId: () => `${Ge}-dropdown`,
      withRoles: P,
      targetProps: ne,
      __staticSelector: T,
      classNames: _,
      styles: w,
      unstyled: y,
      variant: Y,
      keepMounted: z,
      keepMountedMode: V,
      getStyles: ue,
      resolvedStyles: le,
      floatingStrategy: ee,
      referenceHidden: J && ke !== "test" ? ge.floating.middlewareData.hide?.referenceHidden : !1
    },
    children: [n, X && /* @__PURE__ */ g(mn, {
      transition: "fade",
      mounted: ge.opened,
      duration: a?.duration || 250,
      exitDuration: a?.exitDuration || 250,
      children: (Be) => /* @__PURE__ */ g(pn, {
        withinPortal: C,
        children: /* @__PURE__ */ g(Po, {
          ...G,
          ...ue("overlay", {
            className: G?.className,
            style: [Be, G?.style]
          })
        })
      })
    })]
  });
}
He.Target = ll;
He.Dropdown = Cs;
He.ContextMenu = sl;
He.varsResolver = cl;
He.displayName = "@mantine/core/Popover";
He.extend = (e) => e;
He.withProps = (e) => {
  const t = (n) => /* @__PURE__ */ g(He, {
    ...e,
    ...n
  });
  return t.extend = He.extend, t.displayName = `WithProps(${He.displayName})`, t;
};
var tt = {
  root: "m_5ae2e3c",
  barsLoader: "m_7a2bd4cd",
  bar: "m_870bb79",
  "bars-loader-animation": "m_5d2b3b9d",
  dotsLoader: "m_4e3f22d7",
  dot: "m_870c4af",
  "loader-dots-animation": "m_aac34a1",
  ovalLoader: "m_b34414df",
  "oval-loader-animation": "m_f8e89c4b"
};
const ul = ({ className: e, ...t }) => /* @__PURE__ */ oe(q, {
  component: "span",
  className: st(tt.barsLoader, e),
  ...t,
  children: [
    /* @__PURE__ */ g("span", { className: tt.bar }),
    /* @__PURE__ */ g("span", { className: tt.bar }),
    /* @__PURE__ */ g("span", { className: tt.bar })
  ]
});
ul.displayName = "@mantine/core/Bars";
const dl = ({ className: e, ...t }) => /* @__PURE__ */ oe(q, {
  component: "span",
  className: st(tt.dotsLoader, e),
  ...t,
  children: [
    /* @__PURE__ */ g("span", { className: tt.dot }),
    /* @__PURE__ */ g("span", { className: tt.dot }),
    /* @__PURE__ */ g("span", { className: tt.dot })
  ]
});
dl.displayName = "@mantine/core/Dots";
const fl = ({ className: e, ...t }) => /* @__PURE__ */ g(q, {
  component: "span",
  className: st(tt.ovalLoader, e),
  ...t
});
fl.displayName = "@mantine/core/Oval";
const pl = {
  bars: ul,
  oval: fl,
  dots: dl
}, fm = {
  loaders: pl,
  type: "oval"
}, ml = (e, { size: t, color: n }) => ({ root: {
  "--loader-size": he(t, "loader-size"),
  "--loader-color": n ? Ie(n, e) : void 0
} }), wn = te((e) => {
  const t = K("Loader", fm, e), { size: n, color: o, type: r, vars: s, className: i, style: a, classNames: l, styles: c, unstyled: p, loaders: f, variant: u, children: d, attributes: m, ...h } = t, v = se({
    name: "Loader",
    props: t,
    classes: tt,
    className: i,
    style: a,
    classNames: l,
    styles: c,
    unstyled: p,
    attributes: m,
    vars: s,
    varsResolver: ml
  });
  return d ? /* @__PURE__ */ g(q, {
    ...v("root"),
    ...h,
    children: d
  }) : /* @__PURE__ */ g(q, {
    ...v("root"),
    component: f[r],
    variant: u,
    size: n,
    ...h
  });
});
wn.defaultLoaders = pl;
wn.classes = tt;
wn.varsResolver = ml;
wn.displayName = "@mantine/core/Loader";
function hl({ size: e = "var(--cb-icon-size, 70%)", style: t, ...n }) {
  return /* @__PURE__ */ g("svg", {
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      ...t,
      width: e,
      height: e
    },
    ...n,
    children: /* @__PURE__ */ g("path", {
      d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    })
  });
}
hl.displayName = "@mantine/core/CloseIcon";
var gl = {
  root: "m_86a44da5",
  "root--subtle": "m_220c80f2"
};
const pm = { variant: "subtle" }, vl = (e, { size: t, radius: n, iconSize: o }) => ({ root: {
  "--cb-size": he(t, "cb-size"),
  "--cb-radius": n === void 0 ? void 0 : Ve(n),
  "--cb-icon-size": W(o)
} }), Mo = it((e) => {
  const t = K("CloseButton", pm, e), { iconSize: n, children: o, vars: r, radius: s, className: i, classNames: a, style: l, styles: c, unstyled: p, "data-disabled": f, disabled: u, variant: d, icon: m, mod: h, attributes: v, __staticSelector: y, ..._ } = t, w = se({
    name: y || "CloseButton",
    props: t,
    className: i,
    style: l,
    classes: gl,
    classNames: a,
    styles: c,
    unstyled: p,
    attributes: v,
    vars: r,
    varsResolver: vl
  });
  return /* @__PURE__ */ oe(nt, {
    ..._,
    unstyled: p,
    variant: d,
    disabled: u,
    mod: [{ disabled: u || f }, h],
    ...w("root", {
      variant: d,
      active: !u && !f
    }),
    children: [m || /* @__PURE__ */ g(hl, {}), o]
  });
});
Mo.classes = gl;
Mo.varsResolver = vl;
Mo.displayName = "@mantine/core/CloseButton";
function mm(e) {
  return Ui.toArray(e).filter(Boolean);
}
var yl = { root: "m_4081bf90" };
const hm = {
  preventGrowOverflow: !0,
  gap: "md",
  align: "center",
  justify: "flex-start",
  wrap: "wrap"
}, bl = (e, { grow: t, preventGrowOverflow: n, gap: o, align: r, justify: s, wrap: i }, { childWidth: a }) => ({ root: {
  "--group-child-width": t && n ? a : void 0,
  "--group-gap": _e(o),
  "--group-align": r,
  "--group-justify": s,
  "--group-wrap": i
} }), In = te((e) => {
  const t = K("Group", hm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, children: a, gap: l, align: c, justify: p, wrap: f, grow: u, preventGrowOverflow: d, vars: m, variant: h, __size: v, mod: y, attributes: _, ...w } = t, x = mm(a), C = x.length, $ = _e(l ?? "md"), M = { childWidth: `calc(${100 / C}% - (${$} - ${$} / ${C}))` }, N = se({
    name: "Group",
    props: t,
    stylesCtx: M,
    className: o,
    style: r,
    classes: yl,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: _,
    vars: m,
    varsResolver: bl
  });
  return /* @__PURE__ */ g(q, {
    ...N("root"),
    variant: h,
    mod: [{ grow: u }, y],
    size: v,
    ...w,
    children: x
  });
});
In.classes = yl;
In.varsResolver = bl;
In.displayName = "@mantine/core/Group";
const wl = mt({ size: "sm" }), Cl = te((e) => {
  const t = K("InputClearButton", null, e), { size: n, variant: o, vars: r, classNames: s, styles: i, ...a } = t, l = Te(wl), { resolvedClassNames: c, resolvedStyles: p } = gn({
    classNames: s,
    styles: i,
    props: t
  });
  return /* @__PURE__ */ g(Mo, {
    variant: o || "transparent",
    size: n || l?.size || "sm",
    classNames: c,
    styles: p,
    __staticSelector: "InputClearButton",
    style: {
      pointerEvents: "all",
      background: "var(--input-bg)",
      ...a.style
    },
    ...a
  });
});
Cl.displayName = "@mantine/core/InputClearButton";
const gm = {
  xs: 7,
  sm: 8,
  md: 10,
  lg: 12,
  xl: 15
};
function vm({ __clearable: e, __clearSection: t, rightSection: n, __defaultRightSection: o, size: r = "sm", __clearSectionMode: s = "both" }) {
  const i = e && t;
  return s === "rightSection" ? n === null ? null : n || o : s === "clear" ? n === null ? null : i || o : i && (n || o) ? /* @__PURE__ */ oe("div", {
    "data-combined-clear-section": !0,
    style: {
      display: "flex",
      gap: 2,
      alignItems: "center",
      paddingInlineEnd: gm[r]
    },
    children: [i, n || o]
  }) : n === null ? null : n || i || o;
}
const Zt = mt({
  offsetBottom: !1,
  offsetTop: !1,
  describedBy: void 0,
  getStyles: null,
  inputId: void 0,
  labelId: void 0
});
var je = {
  wrapper: "m_6c018570",
  input: "m_8fb7ebe7",
  bottomSection: "m_93f4ed57",
  section: "m_82577fc2",
  placeholder: "m_88bacfd0",
  root: "m_46b77525",
  label: "m_8fdc1311",
  required: "m_78a94662",
  error: "m_8f816625",
  success: "m_9d9d40e0",
  description: "m_fe47ce59"
};
const _l = (e, { size: t }) => ({ description: { "--input-description-size": t === void 0 ? void 0 : `calc(${we(t)} - ${W(2)})` } }), Yn = te((e) => {
  const t = K("InputDescription", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, __staticSelector: l, __inheritStyles: c = !0, attributes: p, ...f } = K("InputDescription", null, t), u = Te(Zt), d = se({
    name: ["InputWrapper", l],
    props: t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: p,
    rootSelector: "description",
    vars: a,
    varsResolver: _l
  }), m = c && u?.getStyles || d;
  return /* @__PURE__ */ g(q, {
    component: "p",
    ...m("description", u?.getStyles ? {
      className: o,
      style: r
    } : void 0),
    ...f
  });
});
Yn.classes = je;
Yn.varsResolver = _l;
Yn.displayName = "@mantine/core/InputDescription";
const xl = (e, { size: t }) => ({ error: { "--input-error-size": t === void 0 ? void 0 : `calc(${we(t)} - ${W(2)})` } }), Fn = te((e) => {
  const t = K("InputError", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, attributes: l, __staticSelector: c, __inheritStyles: p = !0, ...f } = t, u = se({
    name: ["InputWrapper", c],
    props: t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: l,
    rootSelector: "error",
    vars: a,
    varsResolver: xl
  }), d = Te(Zt), m = p && d?.getStyles || u;
  return /* @__PURE__ */ g(q, {
    component: "p",
    ...m("error", d?.getStyles ? {
      className: o,
      style: r
    } : void 0),
    ...f
  });
});
Fn.classes = je;
Fn.varsResolver = xl;
Fn.displayName = "@mantine/core/InputError";
const ym = { labelElement: "label" }, Sl = (e, { size: t }) => ({ label: {
  "--input-label-size": we(t),
  "--input-asterisk-color": void 0
} }), Wn = te((e) => {
  const t = K("InputLabel", ym, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, labelElement: l, required: c, htmlFor: p, onMouseDown: f, children: u, __staticSelector: d, mod: m, attributes: h, ...v } = t, y = se({
    name: ["InputWrapper", d],
    props: t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: h,
    rootSelector: "label",
    vars: a,
    varsResolver: Sl
  }), _ = Te(Zt), w = _?.getStyles || y, x = v.component || l, C = typeof x != "string" || x === "label";
  return /* @__PURE__ */ oe(q, {
    ...w("label", _?.getStyles ? {
      className: o,
      style: r
    } : void 0),
    component: l,
    htmlFor: C ? p : void 0,
    mod: [{ required: c }, m],
    onMouseDown: ($) => {
      f?.($), !$.defaultPrevented && $.detail > 1 && $.preventDefault();
    },
    ...v,
    children: [u, c && /* @__PURE__ */ g("span", {
      ...w("required"),
      "aria-hidden": !0,
      children: " *"
    })]
  });
});
Wn.classes = je;
Wn.varsResolver = Sl;
Wn.displayName = "@mantine/core/InputLabel";
const _s = te((e) => {
  const t = K("InputPlaceholder", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, __staticSelector: l, error: c, mod: p, attributes: f, ...u } = t, d = se({
    name: ["InputPlaceholder", l],
    props: t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: f,
    rootSelector: "placeholder"
  });
  return /* @__PURE__ */ g(q, {
    ...d("placeholder"),
    mod: [{ error: !!c }, p],
    component: "span",
    ...u
  });
});
_s.classes = je;
_s.displayName = "@mantine/core/InputPlaceholder";
const Rl = (e, { size: t }) => ({ success: { "--input-success-size": t === void 0 ? void 0 : `calc(${we(t)} - ${W(2)})` } }), Bn = te((e) => {
  const t = K("InputSuccess", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, attributes: l, __staticSelector: c, __inheritStyles: p = !0, ...f } = t, u = se({
    name: ["InputWrapper", c],
    props: t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: l,
    rootSelector: "success",
    vars: a,
    varsResolver: Rl
  }), d = Te(Zt), m = p && d?.getStyles || u;
  return /* @__PURE__ */ g(q, {
    component: "p",
    ...m("success", d?.getStyles ? {
      className: o,
      style: r
    } : void 0),
    ...f
  });
});
Bn.classes = je;
Bn.varsResolver = Rl;
Bn.displayName = "@mantine/core/InputSuccess";
function bm(e, { hasDescription: t, hasError: n }) {
  const o = e.findIndex((a) => a === "input"), r = e.slice(0, o), s = e.slice(o + 1), i = t && r.includes("description") || n && r.includes("error");
  return {
    offsetBottom: t && s.includes("description") || n && s.includes("error"),
    offsetTop: i
  };
}
const wm = {
  labelElement: "label",
  inputContainer: (e) => e,
  inputWrapperOrder: [
    "label",
    "description",
    "input",
    "error"
  ]
}, Dl = (e, { size: t }) => ({
  label: {
    "--input-label-size": we(t),
    "--input-asterisk-color": void 0
  },
  error: { "--input-error-size": t === void 0 ? void 0 : `calc(${we(t)} - ${W(2)})` },
  success: { "--input-success-size": t === void 0 ? void 0 : `calc(${we(t)} - ${W(2)})` },
  description: { "--input-description-size": t === void 0 ? void 0 : `calc(${we(t)} - ${W(2)})` }
}), To = te((e) => {
  const t = K("InputWrapper", wm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, size: l, variant: c, __staticSelector: p, inputContainer: f, inputWrapperOrder: u, label: d, error: m, success: h, description: v, labelProps: y, descriptionProps: _, errorProps: w, successProps: x, labelElement: C, children: $, withAsterisk: M, id: N, required: I, __stylesApiProps: E, mod: O, attributes: B, ...A } = t, S = se({
    name: ["InputWrapper", p],
    props: E || t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: B,
    vars: a,
    varsResolver: Dl
  }), k = {
    size: l,
    variant: c,
    __staticSelector: p
  }, R = Ot(N), D = typeof M == "boolean" ? M : I, b = w?.id || `${R}-error`, T = x?.id || `${R}-success`, P = _?.id || `${R}-description`, F = R, L = !!m && typeof m != "boolean", Y = !!h && typeof h != "boolean" && !m, z = !!v, V = L && u.includes("error"), U = Y && u.includes("error"), ee = z && u.includes("description"), X = `${V ? b : ""} ${U ? T : ""} ${ee ? P : ""}`, G = X.trim().length > 0 ? X.trim() : void 0, J = y?.id || `${R}-label`, ie = d && /* @__PURE__ */ g(Wn, {
    labelElement: C,
    id: J,
    htmlFor: F,
    required: D,
    ...k,
    ...y,
    children: d
  }, "label"), ae = z && /* @__PURE__ */ g(Yn, {
    ..._,
    ...k,
    size: _?.size || k.size,
    id: _?.id || P,
    children: v
  }, "description"), ne = /* @__PURE__ */ g(Ki, { children: f($) }, "input"), ue = L && /* @__PURE__ */ yt(Fn, {
    ...w,
    ...k,
    size: w?.size || k.size,
    key: "error",
    id: w?.id || b
  }, m), le = Y && /* @__PURE__ */ yt(Bn, {
    ...x,
    ...k,
    size: x?.size || k.size,
    key: "success",
    id: x?.id || T
  }, h), Q = u.map((me) => {
    switch (me) {
      case "label":
        return ie;
      case "input":
        return ne;
      case "description":
        return ae;
      case "error":
        return ue || le;
      default:
        return null;
    }
  });
  return /* @__PURE__ */ g(Zt, {
    value: {
      getStyles: S,
      describedBy: G,
      inputId: F,
      labelId: J,
      ...bm(u, {
        hasDescription: z,
        hasError: L || Y
      })
    },
    children: /* @__PURE__ */ g(q, {
      variant: c,
      size: l,
      mod: [{
        error: !!m,
        success: !!h && !m
      }, O],
      id: C === "label" ? void 0 : N,
      ...S("root"),
      ...A,
      children: Q
    })
  });
});
To.classes = je;
To.varsResolver = Dl;
To.displayName = "@mantine/core/InputWrapper";
const Cm = {
  variant: "default",
  leftSectionPointerEvents: "none",
  rightSectionPointerEvents: "none",
  withAria: !0,
  withErrorStyles: !0,
  withSuccessStyles: !0,
  size: "sm",
  loading: !1,
  loadingPosition: "right"
}, $l = (e, t, n) => ({ wrapper: {
  "--input-margin-top": n.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
  "--input-margin-bottom": n.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
  "--input-height": he(t.size, "input-height"),
  "--input-fz": we(t.size),
  "--input-radius": t.radius === void 0 ? void 0 : Ve(t.radius),
  "--input-left-section-width": t.leftSectionWidth !== void 0 ? W(t.leftSectionWidth) : void 0,
  "--input-right-section-width": t.rightSectionWidth !== void 0 ? W(t.rightSectionWidth) : void 0,
  "--input-padding-y": t.multiline ? he(t.size, "input-padding-y") : void 0,
  "--input-left-section-pointer-events": t.leftSectionPointerEvents,
  "--input-right-section-pointer-events": t.rightSectionPointerEvents
} }), Se = it((e) => {
  const t = K("Input", Cm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, required: a, __staticSelector: l, __stylesApiProps: c, size: p, wrapperProps: f, error: u, success: d, disabled: m, leftSection: h, leftSectionProps: v, leftSectionWidth: y, rightSection: _, rightSectionProps: w, rightSectionWidth: x, rightSectionPointerEvents: C, leftSectionPointerEvents: $, variant: M, vars: N, pointer: I, multiline: E, radius: O, id: B, withAria: A, withErrorStyles: S, withSuccessStyles: k, mod: R, inputSize: D, attributes: b, __clearSection: T, __clearable: P, __clearSectionMode: F, __defaultRightSection: L, loading: Y, loadingPosition: z, __bottomSection: V, __bottomSectionProps: U, rootRef: ee, dir: X, ...G } = t, { styleProps: J, rest: ie } = bo(G), ae = Te(Zt), ne = {
    offsetBottom: ae?.offsetBottom,
    offsetTop: ae?.offsetTop
  }, ue = se({
    name: ["Input", l],
    props: c || t,
    classes: je,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: b,
    stylesCtx: ne,
    rootSelector: "wrapper",
    vars: N,
    varsResolver: $l
  }), le = A ? {
    required: a,
    disabled: m,
    "aria-invalid": u ? !0 : void 0,
    "aria-describedby": ae?.describedBy,
    id: ae?.inputId || B
  } : {}, Q = Y ? /* @__PURE__ */ g(wn, { size: z === "left" ? "calc(var(--input-left-section-size) / 2)" : "calc(var(--input-right-section-size) / 2)" }) : null, me = Y && z === "left" ? Q : h, be = vm({
    __clearable: P,
    __clearSection: T,
    rightSection: Y && z === "right" ? Q : _,
    __defaultRightSection: L,
    size: p,
    __clearSectionMode: F
  });
  return /* @__PURE__ */ g(wl, {
    value: { size: p || "sm" },
    children: /* @__PURE__ */ oe(q, {
      ref: ee,
      dir: X,
      ...ue("wrapper"),
      ...J,
      ...f,
      mod: [{
        error: !!u && S,
        success: !!d && !u && k,
        pointer: I,
        disabled: m,
        multiline: E,
        withRightSection: !!be,
        withLeftSection: !!me,
        withBottomSection: !!V
      }, R],
      variant: M,
      size: p,
      children: [
        me && /* @__PURE__ */ g("div", {
          ...v,
          "data-position": "left",
          ...ue("section", {
            className: v?.className,
            style: v?.style
          }),
          children: me
        }),
        /* @__PURE__ */ g(q, {
          component: "input",
          ...ie,
          ...le,
          required: a,
          mod: {
            disabled: m,
            error: !!u && S,
            success: !!d && !u && k
          },
          variant: M,
          __size: D,
          ...ue("input")
        }),
        V && /* @__PURE__ */ g("div", {
          ...U,
          ...ue("bottomSection", {
            className: U?.className,
            style: U?.style
          }),
          children: V
        }),
        be && /* @__PURE__ */ g("div", {
          ...w,
          "data-position": "right",
          ...ue("section", {
            className: w?.className,
            style: w?.style
          }),
          children: be
        })
      ]
    })
  });
});
Se.classes = je;
Se.varsResolver = $l;
Se.Wrapper = To;
Se.Label = Wn;
Se.Error = Fn;
Se.Success = Bn;
Se.Description = Yn;
Se.Placeholder = _s;
Se.ClearButton = Cl;
Se.displayName = "@mantine/core/Input";
function _m(e, t, n) {
  const o = K([
    "Input",
    "InputWrapper",
    e
  ], t, n), { label: r, description: s, error: i, success: a, required: l, classNames: c, styles: p, className: f, unstyled: u, __staticSelector: d, __stylesApiProps: m, errorProps: h, successProps: v, labelProps: y, descriptionProps: _, wrapperProps: w, id: x, size: C, style: $, inputContainer: M, inputWrapperOrder: N, withAsterisk: I, variant: E, vars: O, mod: B, attributes: A, ...S } = o, { styleProps: k, rest: R } = bo(S), D = {
    label: r,
    description: s,
    error: i,
    success: a,
    required: l,
    classNames: c,
    className: f,
    __staticSelector: d,
    __stylesApiProps: m || o,
    errorProps: h,
    successProps: v,
    labelProps: y,
    descriptionProps: _,
    unstyled: u,
    styles: p,
    size: C,
    style: $,
    inputContainer: M,
    inputWrapperOrder: N,
    withAsterisk: I,
    variant: E,
    id: x,
    mod: B,
    attributes: A,
    ...w
  };
  return {
    ...R,
    classNames: c,
    styles: p,
    unstyled: u,
    wrapperProps: {
      ...D,
      ...k
    },
    inputProps: {
      required: l,
      classNames: c,
      styles: p,
      unstyled: u,
      size: C,
      __staticSelector: d,
      __stylesApiProps: m || o,
      error: i,
      success: a,
      variant: E,
      id: x,
      attributes: A
    }
  };
}
const xm = {
  __staticSelector: "InputBase",
  withAria: !0,
  size: "sm"
}, Cn = it((e) => {
  const { inputProps: t, wrapperProps: n, ...o } = _m("InputBase", xm, e);
  return /* @__PURE__ */ g(Se.Wrapper, {
    ...n,
    children: /* @__PURE__ */ g(Se, {
      ...t,
      ...o
    })
  });
});
Cn.classes = {
  ...Se.classes,
  ...Se.Wrapper.classes
};
Cn.displayName = "@mantine/core/InputBase";
const Sm = {
  gap: {
    type: "spacing",
    property: "gap"
  },
  rowGap: {
    type: "spacing",
    property: "rowGap"
  },
  columnGap: {
    type: "spacing",
    property: "columnGap"
  },
  align: {
    type: "identity",
    property: "alignItems"
  },
  justify: {
    type: "identity",
    property: "justifyContent"
  },
  wrap: {
    type: "identity",
    property: "flexWrap"
  },
  direction: {
    type: "identity",
    property: "flexDirection"
  }
};
var Pl = { root: "m_8bffd616" };
const Ml = it((e) => {
  const t = K("Flex", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, gap: l, rowGap: c, columnGap: p, align: f, justify: u, wrap: d, direction: m, attributes: h, ...v } = t, y = se({
    name: "Flex",
    classes: Pl,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: h,
    vars: a
  }), _ = Xe(), w = On(), x = ma({
    styleProps: {
      gap: l,
      rowGap: c,
      columnGap: p,
      align: f,
      justify: u,
      wrap: d,
      direction: m
    },
    theme: _,
    data: Sm
  }), C = aa(), $ = C && x.hasResponsiveStyles ? pa(x.styles, x.media) : w;
  return /* @__PURE__ */ oe(Pe, { children: [x.hasResponsiveStyles && /* @__PURE__ */ g(vn, {
    selector: `.${$}`,
    styles: x.styles,
    media: x.media,
    deduplicate: C
  }), /* @__PURE__ */ g(q, {
    ...y("root", {
      className: $,
      style: Et(x.inlineStyles)
    }),
    ...v
  })] });
});
Ml.classes = Pl;
Ml.displayName = "@mantine/core/Flex";
function Rm(e, t) {
  if (!t || !e) return !1;
  let n = t.parentNode;
  for (; n != null; ) {
    if (n === e) return !0;
    n = n.parentNode;
  }
  return !1;
}
function Dm({ target: e, parent: t, ref: n, displayAfterTransitionEnd: o, onTransitionStart: r, onTransitionEnd: s }) {
  const i = Z(-1), a = Z(e), [l, c] = re(!1), [p, f] = re(typeof o == "boolean" ? o : !1), u = () => {
    if (!e || !t || !n.current) return;
    const v = e.getBoundingClientRect(), y = t.getBoundingClientRect(), _ = t.offsetWidth === 0 ? 1 : y.width / t.offsetWidth, w = t.offsetHeight === 0 ? 1 : y.height / t.offsetHeight, x = window.getComputedStyle(e), C = window.getComputedStyle(t), $ = Mt(x.borderTopWidth) + Mt(C.borderTopWidth), M = Mt(x.borderLeftWidth) + Mt(C.borderLeftWidth), N = {
      top: (v.top - y.top) / w - $,
      left: (v.left - y.left) / _ - M,
      width: v.width / _,
      height: v.height / w
    };
    n.current.style.transform = `translateY(${N.top}px) translateX(${N.left}px)`, n.current.style.width = `${N.width}px`, n.current.style.height = `${N.height}px`;
  }, d = () => {
    window.clearTimeout(i.current), n.current && (n.current.style.transitionDuration = "0ms"), u(), i.current = window.setTimeout(() => {
      n.current && (n.current.style.transitionDuration = "");
    }, 30);
  }, m = Z(null), h = Z(null);
  return ce(() => {
    if (l && a.current !== e && r && r(), a.current = e, u(), e)
      return m.current = new ResizeObserver(d), m.current.observe(e), t && (h.current = new ResizeObserver(d), h.current.observe(t)), () => {
        m.current?.disconnect(), h.current?.disconnect();
      };
  }, [t, e]), ce(() => {
    if (t) {
      const v = (y) => {
        Rm(y.target, t) && (d(), f(!1));
      };
      return t.addEventListener("transitionend", v), () => {
        t.removeEventListener("transitionend", v);
      };
    }
  }, [t]), ce(() => {
    if (n.current && s) {
      const v = (y) => {
        y.propertyName === "transform" && s();
      };
      return n.current.addEventListener("transitionend", v), () => {
        n.current?.removeEventListener("transitionend", v);
      };
    }
  }, [s]), Lu(() => {
    Wu() !== "test" && c(!0);
  }, 20, { autoInvoke: !0 }), Ou((v) => {
    v.forEach((y) => {
      y.type === "attributes" && y.attributeName === "dir" && d();
    });
  }, {
    attributes: !0,
    attributeFilter: ["dir"]
  }, () => document.documentElement), {
    initialized: l,
    hidden: p
  };
}
var Tl = { root: "m_96b553a6" };
const Nl = (e, { transitionDuration: t }, { shouldReduceMotion: n }) => ({ root: { "--transition-duration": e.respectReducedMotion && n ? "0ms" : typeof t == "number" ? `${t}ms` : t || "150ms" } }), No = te((e) => {
  const t = K("FloatingIndicator", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, target: l, parent: c, transitionDuration: p, mod: f, displayAfterTransitionEnd: u, onTransitionStart: d, onTransitionEnd: m, attributes: h, ref: v, ...y } = t, _ = oa(), w = se({
    name: "FloatingIndicator",
    classes: Tl,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: h,
    vars: a,
    varsResolver: Nl,
    stylesCtx: { shouldReduceMotion: _ }
  }), x = Z(null), { initialized: C, hidden: $ } = Dm({
    target: l,
    parent: c,
    ref: x,
    displayAfterTransitionEnd: u,
    onTransitionStart: d,
    onTransitionEnd: m
  }), M = Me(v, x);
  return !l || !c ? null : /* @__PURE__ */ g(q, {
    ref: M,
    mod: [{
      initialized: C,
      hidden: $
    }, f],
    ...w("root"),
    ...y
  });
});
No.displayName = "@mantine/core/FloatingIndicator";
No.classes = Tl;
No.varsResolver = Nl;
function zr({ style: e, size: t = 16, ...n }) {
  return /* @__PURE__ */ g("svg", {
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      ...e,
      width: W(t),
      height: W(t),
      display: "block"
    },
    ...n,
    children: /* @__PURE__ */ g("path", {
      d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    })
  });
}
zr.displayName = "@mantine/core/AccordionChevron";
var kl = { root: "m_b6d8b162" };
function $m(e) {
  if (e === "start") return "start";
  if (e === "end" || e) return "end";
}
const Pm = { inherit: !1 }, Ll = (e, { variant: t, lineClamp: n, gradient: o, size: r, textWrap: s }) => ({ root: {
  "--text-fz": we(r),
  "--text-lh": hu(r),
  "--text-gradient": t === "gradient" ? Tr(o, e) : void 0,
  "--text-line-clamp": typeof n == "number" ? n.toString() : void 0,
  "--text-text-wrap": s
} }), Gt = it((e) => {
  const t = K("Text", Pm, e), { lineClamp: n, truncate: o, inline: r, inherit: s, gradient: i, span: a, textWrap: l, __staticSelector: c, vars: p, className: f, style: u, classNames: d, styles: m, unstyled: h, variant: v, mod: y, size: _, attributes: w, ...x } = t, C = se({
    name: ["Text", c],
    props: t,
    classes: kl,
    className: f,
    style: u,
    classNames: d,
    styles: m,
    unstyled: h,
    attributes: w,
    vars: p,
    varsResolver: Ll
  });
  return /* @__PURE__ */ g(q, {
    ...C("root", { focusable: !0 }),
    component: a ? "span" : "p",
    variant: v,
    mod: [{
      truncate: $m(o),
      lineClamp: typeof n == "number",
      inline: r,
      inherit: s
    }, y],
    size: _,
    ...x
  });
});
Gt.classes = kl;
Gt.varsResolver = Ll;
Gt.displayName = "@mantine/core/Text";
function El(e) {
  return typeof e == "string" ? {
    value: e,
    label: e
  } : typeof e == "object" && "value" in e && !("label" in e) ? {
    value: e.value,
    label: `${e.value}`,
    disabled: e.disabled
  } : typeof e == "object" && "group" in e ? {
    group: e.group,
    items: e.items.map((t) => El(t))
  } : typeof e == "number" || typeof e == "bigint" || typeof e == "boolean" ? {
    value: e,
    label: `${e}`
  } : e;
}
function Mm(e) {
  return e ? e.map((t) => El(t)) : [];
}
function Ol(e) {
  return e.reduce((t, n) => "group" in n ? {
    ...t,
    ...Ol(n.items)
  } : (t[`${n.value}`] = n, t), {});
}
var Fe = {
  dropdown: "m_88b62a41",
  search: "m_985517d8",
  options: "m_b2821a6e",
  option: "m_92253aa5",
  empty: "m_2530cd1d",
  header: "m_858f94bd",
  footer: "m_82b967cb",
  group: "m_254f3e4f",
  groupLabel: "m_2bb2e9e5",
  chevron: "m_2943220b",
  optionsDropdownOption: "m_390b5f4",
  optionsDropdownCheckIcon: "m_8ee53fc2",
  optionsDropdownCheckPlaceholder: "m_a530ee0a"
};
const Tm = { error: null }, Al = (e, { size: t, color: n }) => ({ chevron: {
  "--combobox-chevron-size": he(t, "combobox-chevron-size"),
  "--combobox-chevron-color": n ? Ie(n, e) : void 0
} }), ko = te((e) => {
  const t = K("ComboboxChevron", Tm, e), { size: n, error: o, style: r, className: s, classNames: i, styles: a, unstyled: l, vars: c, attributes: p, mod: f, ...u } = t, d = se({
    name: "ComboboxChevron",
    classes: Fe,
    props: t,
    style: r,
    className: s,
    classNames: i,
    styles: a,
    unstyled: l,
    vars: c,
    varsResolver: Al,
    attributes: p,
    rootSelector: "chevron"
  });
  return /* @__PURE__ */ g(q, {
    component: "svg",
    ...u,
    ...d("chevron"),
    size: n,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    mod: [
      "combobox-chevron",
      { error: o },
      f
    ],
    children: /* @__PURE__ */ g("path", {
      d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    })
  });
});
ko.classes = Fe;
ko.varsResolver = Al;
ko.displayName = "@mantine/core/ComboboxChevron";
const [Nm, qe] = hn("Combobox component was not found in tree");
function Il({ onMouseDown: e, onClick: t, onClear: n, ...o }) {
  return /* @__PURE__ */ g(Se.ClearButton, {
    tabIndex: -1,
    "aria-hidden": !0,
    ...o,
    onMouseDown: (r) => {
      r.preventDefault(), e?.(r);
    },
    onClick: (r) => {
      n(), t?.(r);
    }
  });
}
Il.displayName = "@mantine/core/ComboboxClearButton";
const xs = te((e) => {
  const { classNames: t, styles: n, className: o, style: r, hidden: s, ...i } = K("ComboboxDropdown", null, e), a = qe();
  return /* @__PURE__ */ g(He.Dropdown, {
    ...i,
    role: "presentation",
    "data-hidden": s || void 0,
    "data-floating-height": a.floatingHeight || void 0,
    ...a.getStyles("dropdown", {
      className: o,
      style: r,
      classNames: t,
      styles: n
    })
  });
});
xs.classes = Fe;
xs.displayName = "@mantine/core/ComboboxDropdown";
const km = { refProp: "ref" }, Yl = te((e) => {
  const { children: t, refProp: n, ref: o } = K("ComboboxDropdownTarget", km, e);
  if (qe(), !Zi(t)) throw new Error("Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  return /* @__PURE__ */ g(He.Target, {
    ref: o,
    refProp: n,
    children: t
  });
});
Yl.displayName = "@mantine/core/ComboboxDropdownTarget";
const Ss = te((e) => {
  const { classNames: t, className: n, style: o, styles: r, vars: s, ...i } = K("ComboboxEmpty", null, e), a = qe();
  return /* @__PURE__ */ g(q, {
    ...a.getStyles("empty", {
      className: n,
      classNames: t,
      styles: r,
      style: o
    }),
    ...i
  });
});
Ss.classes = Fe;
Ss.displayName = "@mantine/core/ComboboxEmpty";
function Rs({ onKeyDown: e, onClick: t, withKeyboardNavigation: n, withAriaAttributes: o, withExpandedAttribute: r, targetType: s, autoComplete: i }) {
  const a = qe(), [l, c] = re(null), p = (d) => {
    if (e?.(d), !a.readOnly && n) {
      if (d.nativeEvent.isComposing) return;
      if (d.nativeEvent.code === "ArrowDown" && (d.preventDefault(), a.store.dropdownOpened ? c(a.store.selectNextOption()) : (a.store.openDropdown("keyboard"), c(a.store.selectActiveOption()), a.store.updateSelectedOptionIndex("selected", { scrollIntoView: !0 }))), d.nativeEvent.code === "ArrowUp" && (d.preventDefault(), a.store.dropdownOpened ? c(a.store.selectPreviousOption()) : (a.store.openDropdown("keyboard"), c(a.store.selectActiveOption()), a.store.updateSelectedOptionIndex("selected", { scrollIntoView: !0 }))), d.nativeEvent.code === "Enter" || d.nativeEvent.code === "NumpadEnter") {
        if (d.nativeEvent.keyCode === 229) return;
        const m = a.store.getSelectedOptionIndex();
        a.store.dropdownOpened && m !== -1 ? (d.preventDefault(), a.store.clickSelectedOption()) : s === "button" && (d.preventDefault(), a.store.openDropdown("keyboard"));
      }
      d.key === "Escape" && a.store.closeDropdown("keyboard"), d.nativeEvent.code === "Space" && s === "button" && (d.preventDefault(), a.store.toggleDropdown("keyboard"));
    }
  };
  return {
    ...o ? {
      ...r ? { role: "combobox" } : {},
      "aria-haspopup": "listbox",
      "aria-expanded": r ? !!(a.store.listId && a.store.dropdownOpened) : void 0,
      "aria-controls": a.store.dropdownOpened && a.store.listId ? a.store.listId : void 0,
      "aria-activedescendant": a.store.dropdownOpened && l || void 0,
      autoComplete: i,
      "data-expanded": a.store.dropdownOpened || void 0,
      "data-mantine-stop-propagation": a.store.dropdownOpened || void 0
    } : {},
    onKeyDown: p,
    onClick: (d) => {
      s === "button" && d.currentTarget.focus(), t?.(d);
    }
  };
}
const Lm = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: !0,
  withAriaAttributes: !0,
  withExpandedAttribute: !1,
  autoComplete: "off"
}, Fl = te((e) => {
  const { children: t, refProp: n, withKeyboardNavigation: o, withAriaAttributes: r, withExpandedAttribute: s, targetType: i, autoComplete: a, ref: l, ...c } = K("ComboboxEventsTarget", Lm, e), p = Ut(t);
  if (!p) throw new Error("Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  const f = qe(), u = Rs({
    targetType: i,
    withAriaAttributes: r,
    withKeyboardNavigation: o,
    withExpandedAttribute: s,
    onKeyDown: p.props.onKeyDown,
    onClick: p.props.onClick,
    autoComplete: a
  });
  return Kt(p, {
    ...u,
    ...c,
    [n]: Me(l, f.store.targetRef, yo(p))
  });
});
Fl.displayName = "@mantine/core/ComboboxEventsTarget";
const Ds = te((e) => {
  const { classNames: t, className: n, style: o, styles: r, vars: s, ...i } = K("ComboboxFooter", null, e), a = qe();
  return /* @__PURE__ */ g(q, {
    ...a.getStyles("footer", {
      className: n,
      classNames: t,
      style: o,
      styles: r
    }),
    ...i,
    onMouseDown: (l) => {
      l.preventDefault();
    }
  });
});
Ds.classes = Fe;
Ds.displayName = "@mantine/core/ComboboxFooter";
const $s = te((e) => {
  const { classNames: t, className: n, style: o, styles: r, vars: s, children: i, label: a, id: l, ...c } = K("ComboboxGroup", null, e), p = qe(), f = Ot(l), u = a != null && a !== !1 && a !== "";
  return /* @__PURE__ */ oe(q, {
    role: "group",
    "aria-labelledby": u ? f : void 0,
    ...p.getStyles("group", {
      className: n,
      classNames: t,
      style: o,
      styles: r
    }),
    ...c,
    children: [u && /* @__PURE__ */ g("div", {
      id: f,
      ...p.getStyles("groupLabel", {
        classNames: t,
        styles: r
      }),
      children: a
    }), i]
  });
});
$s.classes = Fe;
$s.displayName = "@mantine/core/ComboboxGroup";
const Ps = te((e) => {
  const { classNames: t, className: n, style: o, styles: r, vars: s, ...i } = K("ComboboxHeader", null, e), a = qe();
  return /* @__PURE__ */ g(q, {
    ...a.getStyles("header", {
      className: n,
      classNames: t,
      style: o,
      styles: r
    }),
    ...i,
    onMouseDown: (l) => {
      l.preventDefault();
    }
  });
});
Ps.classes = Fe;
Ps.displayName = "@mantine/core/ComboboxHeader";
function Wl({ value: e, valuesDivider: t = ",", ...n }) {
  return /* @__PURE__ */ g("input", {
    type: "hidden",
    value: Array.isArray(e) ? e.join(t) : e ? `${e}` : "",
    ...n
  });
}
Wl.displayName = "@mantine/core/ComboboxHiddenInput";
const Ms = te((e) => {
  const t = K("ComboboxOption", null, e), { classNames: n, className: o, style: r, styles: s, vars: i, onClick: a, id: l, active: c, onMouseDown: p, onMouseOver: f, disabled: u, selected: d, mod: m, ...h } = t, v = qe(), y = ho(), _ = l || y;
  return /* @__PURE__ */ g(q, {
    ...v.getStyles("option", {
      className: o,
      classNames: n,
      styles: s,
      style: r
    }),
    ...h,
    id: _,
    mod: [
      "combobox-option",
      {
        "combobox-active": c,
        "combobox-disabled": u,
        "combobox-selected": d
      },
      m
    ],
    role: "option",
    onClick: (w) => {
      u ? w.preventDefault() : (v.onOptionSubmit?.(t.value, t), a?.(w));
    },
    onMouseDown: (w) => {
      w.preventDefault(), p?.(w);
    },
    onMouseOver: (w) => {
      v.resetSelectionOnOptionHover && v.store.resetSelectedOption(), f?.(w);
    }
  });
});
Ms.classes = Fe;
Ms.displayName = "@mantine/core/ComboboxOption";
const Ts = te((e) => {
  const { classNames: t, className: n, style: o, styles: r, id: s, onMouseDown: i, labelledBy: a, ...l } = K("ComboboxOptions", null, e), c = qe(), p = Ot(s);
  return ce(() => {
    c.store.setListId(p);
  }, [p]), /* @__PURE__ */ g(q, {
    ...c.getStyles("options", {
      className: n,
      style: o,
      classNames: t,
      styles: r
    }),
    ...l,
    id: p,
    role: "listbox",
    "aria-labelledby": a,
    onMouseDown: (f) => {
      f.preventDefault(), i?.(f);
    }
  });
});
Ts.classes = Fe;
Ts.displayName = "@mantine/core/ComboboxOptions";
const Em = {
  withAriaAttributes: !0,
  withKeyboardNavigation: !0
}, Ns = te((e) => {
  const { classNames: t, styles: n, unstyled: o, vars: r, withAriaAttributes: s, onKeyDown: i, onClick: a, withKeyboardNavigation: l, size: c, ref: p, ...f } = K("ComboboxSearch", Em, e), u = qe(), d = u.getStyles("search"), m = Rs({
    targetType: "input",
    withAriaAttributes: s,
    withKeyboardNavigation: l,
    withExpandedAttribute: !1,
    onKeyDown: i,
    onClick: a,
    autoComplete: "off"
  });
  return /* @__PURE__ */ g(Se, {
    ref: Me(p, u.store.searchRef),
    classNames: [{ input: d.className }, t],
    styles: [{ input: d.style }, n],
    size: c || u.size,
    ...m,
    ...f,
    __staticSelector: "Combobox"
  });
});
Ns.classes = Fe;
Ns.displayName = "@mantine/core/ComboboxSearch";
const Om = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: !0,
  withAriaAttributes: !0,
  withExpandedAttribute: !1,
  autoComplete: "off"
}, Bl = te((e) => {
  const { children: t, refProp: n, withKeyboardNavigation: o, withAriaAttributes: r, withExpandedAttribute: s, targetType: i, autoComplete: a, ref: l, ...c } = K("ComboboxTarget", Om, e), p = Ut(t);
  if (!p) throw new Error("Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  const f = qe(), u = Rs({
    targetType: i,
    withAriaAttributes: r,
    withKeyboardNavigation: o,
    withExpandedAttribute: s,
    onKeyDown: p.props.onKeyDown,
    onClick: p.props.onClick,
    autoComplete: a
  }), d = Kt(p, {
    ...u,
    ...c
  });
  return /* @__PURE__ */ g(He.Target, {
    refProp: n,
    ref: Me(l, f.store.targetRef),
    children: d
  });
});
Bl.displayName = "@mantine/core/ComboboxTarget";
function Am(e, t, n) {
  for (let o = e - 1; o >= 0; o -= 1) if (!t[o].hasAttribute("data-combobox-disabled")) return o;
  if (n) {
    for (let o = t.length - 1; o > -1; o -= 1) if (!t[o].hasAttribute("data-combobox-disabled")) return o;
  }
  return e;
}
function Im(e, t, n) {
  for (let o = e + 1; o < t.length; o += 1) if (!t[o].hasAttribute("data-combobox-disabled")) return o;
  if (n) {
    for (let o = 0; o < t.length; o += 1) if (!t[o].hasAttribute("data-combobox-disabled")) return o;
  }
  return e;
}
function Ym(e) {
  for (let t = 0; t < e.length; t += 1) if (!e[t].hasAttribute("data-combobox-disabled")) return t;
  return -1;
}
function zl({ defaultOpened: e, opened: t, onOpenedChange: n, onDropdownClose: o, onDropdownOpen: r, loop: s = !0, scrollBehavior: i = "instant" } = {}) {
  const [a, l] = _t({
    value: t,
    defaultValue: e,
    finalValue: !1,
    onChange: n
  }), c = Z(null), p = Z(-1), f = Z(null), u = Z(null), d = Z(-1), m = Z(-1), h = Z(-1), v = de((R = "unknown") => {
    a || (l(!0), r?.(R));
  }, [
    l,
    r,
    a
  ]), y = de((R = "unknown") => {
    a && (l(!1), o?.(R));
  }, [
    l,
    o,
    a
  ]), _ = de((R = "unknown") => {
    a ? y(R) : v(R);
  }, [
    y,
    v,
    a
  ]), w = de(() => {
    const R = ct(u.current), D = Zn(`#${c.current} [data-combobox-selected]`, R);
    D?.removeAttribute("data-combobox-selected"), D?.removeAttribute("aria-selected");
  }, []), x = de((R) => {
    const D = ct(u.current), b = Zn(`#${c.current}`, D), T = b ? vt("[data-combobox-option]", b) : null;
    if (!T) return null;
    const P = R >= T.length ? 0 : R < 0 ? T.length - 1 : R;
    return p.current = P, T?.[P] && !T[P].hasAttribute("data-combobox-disabled") ? (w(), T[P].setAttribute("data-combobox-selected", "true"), T[P].setAttribute("aria-selected", "true"), T[P].scrollIntoView({
      block: "nearest",
      behavior: i
    }), T[P].id) : null;
  }, [i, w]), C = de(() => {
    const R = ct(u.current), D = Zn(`#${c.current} [data-combobox-active]`, R);
    if (D) {
      const b = vt(`#${c.current} [data-combobox-option]`, R).findIndex((T) => T === D);
      return x(b);
    }
    return x(0);
  }, [x]), $ = de(() => {
    const R = ct(u.current), D = vt(`#${c.current} [data-combobox-option]`, R);
    return x(Im(p.current, D, s));
  }, [x, s]), M = de(() => {
    const R = ct(u.current), D = vt(`#${c.current} [data-combobox-option]`, R);
    return x(Am(p.current, D, s));
  }, [x, s]), N = de(() => {
    const R = ct(u.current), D = vt(`#${c.current} [data-combobox-option]`, R);
    return x(Ym(D));
  }, [x]), I = de((R = "selected", D) => {
    if (typeof R == "number") {
      p.current = R;
      const b = ct(u.current), T = vt(`#${c.current} [data-combobox-option]`, b);
      D?.scrollIntoView && T[R]?.scrollIntoView({
        block: "nearest",
        behavior: i
      });
      return;
    }
    h.current = window.setTimeout(() => {
      const b = ct(u.current), T = vt(`#${c.current} [data-combobox-option]`, b), P = T.findIndex((F) => F.hasAttribute(`data-combobox-${R}`));
      p.current = P, D?.scrollIntoView && T[P]?.scrollIntoView({
        block: "nearest",
        behavior: i
      });
    }, 0);
  }, []), E = de(() => {
    p.current = -1, w();
  }, [w]), O = de(() => {
    const R = ct(u.current);
    vt(`#${c.current} [data-combobox-option]`, R)?.[p.current]?.click();
  }, []), B = de((R) => {
    c.current = R;
  }, []), A = de(() => {
    d.current = window.setTimeout(() => f.current?.focus(), 0);
  }, []), S = de(() => {
    m.current = window.setTimeout(() => u.current?.focus(), 0);
  }, []), k = de(() => p.current, []);
  return ce(() => () => {
    window.clearTimeout(d.current), window.clearTimeout(m.current), window.clearTimeout(h.current);
  }, []), {
    dropdownOpened: a,
    openDropdown: v,
    closeDropdown: y,
    toggleDropdown: _,
    selectedOptionIndex: p.current,
    getSelectedOptionIndex: k,
    selectOption: x,
    selectFirstOption: N,
    selectActiveOption: C,
    selectNextOption: $,
    selectPreviousOption: M,
    resetSelectedOption: E,
    updateSelectedOptionIndex: I,
    listId: c.current,
    setListId: B,
    clickSelectedOption: O,
    searchRef: f,
    focusSearchInput: A,
    targetRef: u,
    focusTarget: S
  };
}
const Fm = {
  keepMounted: !0,
  keepMountedMode: "display-none",
  withinPortal: !0,
  resetSelectionOnOptionHover: !1,
  width: "target",
  transitionProps: {
    transition: "fade",
    duration: 0
  },
  size: "sm"
}, Hl = (e, { size: t, dropdownPadding: n }) => ({
  options: {
    "--combobox-option-fz": we(t),
    "--combobox-option-padding": he(t, "combobox-option-padding")
  },
  dropdown: {
    "--combobox-padding": n === void 0 ? void 0 : W(n),
    "--combobox-option-fz": we(t),
    "--combobox-option-padding": he(t, "combobox-option-padding")
  }
}), pe = (e) => {
  const t = K("Combobox", Fm, e), { classNames: n, styles: o, unstyled: r, children: s, store: i, vars: a, onOptionSubmit: l, onClose: c, size: p, dropdownPadding: f, resetSelectionOnOptionHover: u, __staticSelector: d, readOnly: m, attributes: h, floatingHeight: v, middlewares: y, ..._ } = t, w = v === "viewport" ? {
    ...y,
    flip: !1,
    size: {
      ...typeof y?.size == "object" ? y.size : {},
      padding: typeof y?.size == "object" && y.size.padding !== void 0 ? y.size.padding : 10,
      apply: ({ availableHeight: N, availableWidth: I, elements: E, ...O }) => {
        E.floating.style.setProperty("--combobox-floating-max-height", `${N}px`);
        const B = y?.size;
        typeof B == "object" && B.apply ? B.apply({
          availableHeight: N,
          availableWidth: I,
          elements: E,
          ...O
        }) : B && Object.assign(E.floating.style, {
          maxWidth: `${I}px`,
          maxHeight: `${N}px`
        });
      }
    }
  } : y, x = zl(), C = i || x, $ = se({
    name: d || "Combobox",
    classes: Fe,
    props: t,
    classNames: n,
    styles: o,
    unstyled: r,
    attributes: h,
    vars: a,
    varsResolver: Hl
  }), M = () => {
    c?.(), C.closeDropdown();
  };
  return /* @__PURE__ */ g(Nm, {
    value: {
      getStyles: $,
      store: C,
      onOptionSubmit: l,
      size: p,
      resetSelectionOnOptionHover: u,
      readOnly: m,
      floatingHeight: v
    },
    children: /* @__PURE__ */ g(He, {
      opened: C.dropdownOpened,
      ..._,
      middlewares: w,
      onChange: (N) => !N && M(),
      withRoles: !1,
      unstyled: r,
      children: s
    })
  });
}, Wm = (e) => e;
pe.extend = Wm;
pe.classes = Fe;
pe.varsResolver = Hl;
pe.displayName = "@mantine/core/Combobox";
pe.Target = Bl;
pe.Dropdown = xs;
pe.Options = Ts;
pe.Option = Ms;
pe.Search = Ns;
pe.Empty = Ss;
pe.Chevron = ko;
pe.Footer = Ds;
pe.Header = Ps;
pe.EventsTarget = Fl;
pe.DropdownTarget = Yl;
pe.Group = $s;
pe.ClearButton = Il;
pe.HiddenInput = Wl;
function Bm({ children: e, role: t }) {
  const n = Te(Zt);
  return n ? /* @__PURE__ */ g("div", {
    role: t,
    "aria-labelledby": n.labelId,
    "aria-describedby": n.describedBy,
    children: e
  }) : /* @__PURE__ */ g(Pe, { children: e });
}
const ks = mt(null), zm = { hiddenInputValuesSeparator: "," }, Ls = os(((e) => {
  const { value: t, defaultValue: n, onChange: o, size: r, wrapperProps: s, children: i, readOnly: a, name: l, hiddenInputValuesSeparator: c, hiddenInputProps: p, maxSelectedValues: f, disabled: u, ...d } = K("CheckboxGroup", zm, e), [m, h] = _t({
    value: t,
    defaultValue: n,
    finalValue: [],
    onChange: o
  }), v = (w) => {
    const x = typeof w == "string" ? w : w.currentTarget.value;
    if (a) return;
    const C = m.includes(x);
    !C && f && m.length >= f || h(C ? m.filter(($) => $ !== x) : [...m, x]);
  }, y = (w) => {
    if (u) return !0;
    if (!f) return !1;
    const x = m.includes(w), C = m.length >= f;
    return !x && C;
  }, _ = m.join(c);
  return /* @__PURE__ */ g(ks, {
    value: {
      value: m,
      onChange: v,
      size: r,
      isDisabled: y
    },
    children: /* @__PURE__ */ oe(Se.Wrapper, {
      size: r,
      ...s,
      ...d,
      labelElement: "div",
      __staticSelector: "CheckboxGroup",
      children: [/* @__PURE__ */ g(Bm, {
        role: "group",
        children: i
      }), /* @__PURE__ */ g("input", {
        type: "hidden",
        name: l,
        value: _,
        ...p
      })]
    })
  });
}));
Ls.classes = Se.Wrapper.classes;
Ls.displayName = "@mantine/core/CheckboxGroup";
var Vl = { card: "m_26775b0a" };
const jl = mt(null), Hm = { withBorder: !0 }, Gl = (e, { radius: t }) => ({ card: { "--card-radius": Ve(t) } }), Lo = te((e) => {
  const t = K("CheckboxCard", Hm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, checked: l, mod: c, withBorder: p, value: f, onClick: u, defaultChecked: d, onChange: m, indeterminate: h, attributes: v, ...y } = t, _ = se({
    name: "CheckboxCard",
    classes: Vl,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: v,
    vars: a,
    varsResolver: Gl,
    rootSelector: "card"
  }), w = Te(ks), x = typeof l == "boolean" ? l : w ? w.value.includes(f || "") : void 0, [C, $] = _t({
    value: x,
    defaultValue: d,
    finalValue: !1,
    onChange: m
  });
  return /* @__PURE__ */ g(jl, {
    value: {
      checked: C,
      indeterminate: h
    },
    children: /* @__PURE__ */ g(nt, {
      mod: [{
        "with-border": p,
        checked: C,
        indeterminate: h
      }, c],
      ..._("card"),
      ...y,
      role: "checkbox",
      "aria-checked": h ? "mixed" : C,
      onClick: (M) => {
        u?.(M), w?.onChange(f || ""), $(!C);
      }
    })
  });
});
Lo.displayName = "@mantine/core/CheckboxCard";
Lo.classes = Vl;
Lo.varsResolver = Gl;
function Kl({ size: e, style: t, ...n }) {
  const o = e !== void 0 ? {
    width: W(e),
    height: W(e),
    ...t
  } : t;
  return /* @__PURE__ */ g("svg", {
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: o,
    "aria-hidden": !0,
    ...n,
    children: /* @__PURE__ */ g("path", {
      d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    })
  });
}
function Ul({ indeterminate: e, ...t }) {
  return e ? /* @__PURE__ */ g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 6",
    "aria-hidden": !0,
    ...t,
    children: /* @__PURE__ */ g("rect", {
      width: "32",
      height: "6",
      fill: "currentColor",
      rx: "3"
    })
  }) : /* @__PURE__ */ g(Kl, { ...t });
}
var Xl = {
  indicator: "m_5e5256ee",
  icon: "m_1b1c543a",
  "indicator--outline": "m_76e20374"
};
const Vm = {
  icon: Ul,
  variant: "filled",
  radius: "sm"
}, ql = (e, { radius: t, color: n, size: o, iconColor: r, variant: s, autoContrast: i }) => {
  const a = Xt({
    color: n || e.primaryColor,
    theme: e
  }), l = a.isThemeColor && a.shade === void 0 ? `var(--mantine-color-${a.color}-outline)` : a.color;
  return { indicator: {
    "--checkbox-size": he(o, "checkbox-size"),
    "--checkbox-radius": t === void 0 ? void 0 : Ve(t),
    "--checkbox-color": s === "outline" ? l : Ie(n, e),
    "--checkbox-icon-color": r ? Ie(r, e) : sa(i, e) ? En({
      color: n,
      theme: e,
      autoContrast: i
    }) : void 0
  } };
}, Eo = te((e) => {
  const t = K("CheckboxIndicator", Vm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, icon: l, indeterminate: c, radius: p, color: f, iconColor: u, autoContrast: d, checked: m, mod: h, variant: v, disabled: y, attributes: _, ...w } = t, x = se({
    name: "CheckboxIndicator",
    classes: Xl,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: _,
    vars: a,
    varsResolver: ql,
    rootSelector: "indicator"
  }), C = Te(jl), $ = typeof c == "boolean" ? c : C?.indeterminate, M = typeof m == "boolean" || typeof c == "boolean" ? m || c : C?.checked || C?.indeterminate || !1;
  return /* @__PURE__ */ g(q, {
    ...x("indicator", { variant: v }),
    variant: v,
    mod: [{
      checked: M,
      disabled: y
    }, h],
    ...w,
    children: /* @__PURE__ */ g(l, {
      indeterminate: $,
      ...x("icon")
    })
  });
});
Eo.displayName = "@mantine/core/CheckboxIndicator";
Eo.classes = Xl;
Eo.varsResolver = ql;
var Zl = {
  root: "m_5f75b09e",
  body: "m_5f6e695e",
  labelWrapper: "m_d3ea56bb",
  label: "m_8ee546b8",
  description: "m_328f68c0",
  error: "m_8e8a99cc"
};
const jm = Zl;
function Jl({ __staticSelector: e, __stylesApiProps: t, className: n, classNames: o, styles: r, unstyled: s, children: i, label: a, description: l, id: c, disabled: p, error: f, size: u, labelPosition: d = "left", bodyElement: m = "div", labelElement: h = "label", variant: v, style: y, vars: _, mod: w, attributes: x, ...C }) {
  const $ = se({
    name: e,
    props: t,
    className: n,
    style: y,
    classes: Zl,
    classNames: o,
    styles: r,
    unstyled: s,
    attributes: x
  }), M = l ? `${c}-description` : void 0, N = f && typeof f != "boolean" ? `${c}-error` : void 0;
  return /* @__PURE__ */ g(q, {
    ...$("root"),
    __vars: {
      "--label-fz": we(u),
      "--label-lh": he(u, "label-lh")
    },
    mod: [{ "label-position": d }, w],
    variant: v,
    size: u,
    ...C,
    children: /* @__PURE__ */ oe(q, {
      component: m,
      htmlFor: m === "label" ? c : void 0,
      ...$("body"),
      children: [i, /* @__PURE__ */ oe("div", {
        ...$("labelWrapper"),
        "data-disabled": p || void 0,
        children: [
          a && /* @__PURE__ */ g(q, {
            component: h,
            htmlFor: h === "label" ? c : void 0,
            ...$("label"),
            "data-disabled": p || void 0,
            children: a
          }),
          l && /* @__PURE__ */ g(Se.Description, {
            id: M,
            size: u,
            __inheritStyles: !1,
            ...$("description"),
            children: l
          }),
          f && typeof f != "boolean" && /* @__PURE__ */ g(Se.Error, {
            id: N,
            size: u,
            __inheritStyles: !1,
            ...$("error"),
            children: f
          })
        ]
      })]
    })
  });
}
Jl.displayName = "@mantine/core/InlineInput";
var Ql = {
  root: "m_bf2d988c",
  inner: "m_26062bec",
  input: "m_26063560",
  icon: "m_bf295423",
  "input--outline": "m_215c4542"
};
const Gm = {
  labelPosition: "right",
  icon: Ul,
  withErrorStyles: !0,
  variant: "filled",
  radius: "sm"
}, ec = (e, { radius: t, color: n, size: o, iconColor: r, variant: s, autoContrast: i }) => {
  const a = Xt({
    color: n || e.primaryColor,
    theme: e
  }), l = a.isThemeColor && a.shade === void 0 ? `var(--mantine-color-${a.color}-outline)` : a.color;
  return { root: {
    "--checkbox-size": he(o, "checkbox-size"),
    "--checkbox-radius": t === void 0 ? void 0 : Ve(t),
    "--checkbox-color": s === "outline" ? l : Ie(n, e),
    "--checkbox-icon-color": r ? Ie(r, e) : sa(i, e) ? En({
      color: n,
      theme: e,
      autoContrast: i
    }) : void 0
  } };
}, Jt = te((e) => {
  const t = K("Checkbox", Gm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, color: l, label: c, id: p, size: f, radius: u, wrapperProps: d, checked: m, labelPosition: h, description: v, error: y, disabled: _, variant: w, indeterminate: x, icon: C, rootRef: $, iconColor: M, onChange: N, autoContrast: I, mod: E, attributes: O, readOnly: B, onClick: A, withErrorStyles: S, ref: k, ...R } = t, D = Z(null), b = Te(ks), T = f || b?.size, P = se({
    name: "Checkbox",
    props: t,
    classes: Ql,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: O,
    vars: a,
    varsResolver: ec
  }), { styleProps: F, rest: L } = bo(R), Y = Ot(p), z = [
    v ? `${Y}-description` : void 0,
    y && typeof y != "boolean" ? `${Y}-error` : void 0,
    L["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, V = {
    checked: b?.value.includes(L.value) ?? m,
    onChange: (X) => {
      B || (b?.onChange(X), N?.(X));
    }
  }, U = b?.isDisabled?.(L.value) ?? !1, ee = _ || U;
  return ce(() => {
    D.current && (D.current.indeterminate = x || !1, x ? D.current.setAttribute("data-indeterminate", "true") : D.current.removeAttribute("data-indeterminate"));
  }, [x]), /* @__PURE__ */ g(Jl, {
    ...P("root"),
    __staticSelector: "Checkbox",
    __stylesApiProps: t,
    id: Y,
    size: T,
    labelPosition: h,
    label: c,
    description: v,
    error: y,
    disabled: ee,
    classNames: n,
    styles: s,
    unstyled: i,
    "data-checked": V.checked || m || void 0,
    variant: w,
    ref: $,
    mod: E,
    attributes: O,
    inert: L.inert,
    ...F,
    ...d,
    children: /* @__PURE__ */ oe(q, {
      ...P("inner"),
      mod: { labelPosition: h },
      children: [/* @__PURE__ */ g(q, {
        component: "input",
        id: Y,
        ref: Me(D, k),
        mod: {
          error: !!y,
          "with-error-styles": S
        },
        ...P("input", {
          focusable: !0,
          variant: w
        }),
        ...L,
        ...V,
        "aria-describedby": z,
        disabled: ee,
        inert: L.inert,
        type: "checkbox",
        onClick: (X) => {
          B && V.checked === void 0 && X.preventDefault(), A?.(X);
        }
      }), /* @__PURE__ */ g(C, {
        indeterminate: x,
        ...P("icon")
      })]
    })
  });
});
Jt.classes = {
  ...Ql,
  ...jm
};
Jt.varsResolver = ec;
Jt.displayName = "@mantine/core/Checkbox";
Jt.Group = Ls;
Jt.Indicator = Eo;
Jt.Card = Lo;
function Ln(e) {
  return "group" in e;
}
function tc({ options: e, search: t, limit: n }) {
  const o = t.trim().toLowerCase(), r = [];
  for (let s = 0; s < e.length; s += 1) {
    const i = e[s];
    if (r.length === n) return r;
    Ln(i) && r.push({
      group: i.group,
      items: tc({
        options: i.items,
        search: t,
        limit: n - r.length
      })
    }), Ln(i) || i.label.toLowerCase().includes(o) && r.push(i);
  }
  return r;
}
function Km(e) {
  if (e.length === 0) return !0;
  for (const t of e)
    if (!("group" in t) || t.items.length > 0) return !1;
  return !0;
}
function nc(e, t = /* @__PURE__ */ new Set()) {
  if (Array.isArray(e))
    for (const n of e) if (Ln(n)) nc(n.items, t);
    else {
      if (typeof n.value > "u") throw new Error("[@mantine/core] Each option must have value property");
      if (t.has(n.value)) throw new Error(`[@mantine/core] Duplicate options are not supported. Option with value "${n.value}" was provided more than once`);
      t.add(n.value);
    }
}
function Um(e, t) {
  return Array.isArray(e) ? e.includes(t) : e === t;
}
function oc({ data: e, withCheckIcon: t, withAlignedLabels: n, value: o, checkIconPosition: r, unstyled: s, renderOption: i }) {
  if (!Ln(e)) {
    const l = Um(o, e.value), c = t && (l ? /* @__PURE__ */ g(Kl, { className: Fe.optionsDropdownCheckIcon }) : n ? /* @__PURE__ */ g("div", { className: Fe.optionsDropdownCheckPlaceholder }) : null), p = /* @__PURE__ */ oe(Pe, { children: [
      r === "left" && c,
      /* @__PURE__ */ g("span", { children: e.label }),
      r === "right" && c
    ] });
    return /* @__PURE__ */ g(pe.Option, {
      value: e.value,
      disabled: e.disabled,
      className: st({ [Fe.optionsDropdownOption]: !s }),
      "data-reverse": r === "right" || void 0,
      "data-checked": l || void 0,
      "aria-selected": l,
      active: l,
      children: typeof i == "function" ? i({
        option: e,
        checked: l
      }) : p
    });
  }
  const a = e.items.map((l) => /* @__PURE__ */ g(oc, {
    data: l,
    value: o,
    unstyled: s,
    withCheckIcon: t,
    withAlignedLabels: n,
    checkIconPosition: r,
    renderOption: i
  }, `${l.value}`));
  return /* @__PURE__ */ g(pe.Group, {
    label: e.group,
    children: a
  });
}
function Xm({ data: e, hidden: t, hiddenWhenEmpty: n, filter: o, search: r, limit: s, maxDropdownHeight: i, floatingHeight: a, withScrollArea: l = !0, filterOptions: c = !0, withCheckIcon: p = !1, withAlignedLabels: f = !1, value: u, checkIconPosition: d, nothingFoundMessage: m, unstyled: h, labelId: v, renderOption: y, scrollAreaProps: _, "aria-label": w }) {
  const x = qe();
  nc(e);
  const C = typeof r == "string" ? (o || tc)({
    options: e,
    search: c ? r : "",
    limit: s ?? 1 / 0
  }) : e, $ = Km(C), M = C.map((N, I) => /* @__PURE__ */ g(oc, {
    data: N,
    withCheckIcon: p,
    withAlignedLabels: f,
    value: u,
    checkIconPosition: d,
    unstyled: h,
    renderOption: y
  }, Ln(N) ? `group-${typeof N.group == "string" ? N.group : I}` : `${N.value}`));
  return /* @__PURE__ */ g(pe.Dropdown, {
    hidden: t || n && $,
    "data-composed": !0,
    children: /* @__PURE__ */ oe(pe.Options, {
      labelledBy: v,
      "aria-label": w,
      children: [l ? /* @__PURE__ */ g(qt.Autosize, {
        mah: (a ?? x.floatingHeight) === "viewport" ? "var(--combobox-floating-options-max-height)" : i ?? 220,
        type: "scroll",
        scrollbarSize: "var(--combobox-padding)",
        offsetScrollbars: "y",
        ..._,
        children: M
      }) : M, $ && m && /* @__PURE__ */ g(pe.Empty, { children: m })]
    })
  });
}
var rc = {
  root: "m_347db0ec",
  "root--dot": "m_fbd81e3d",
  label: "m_5add502a",
  section: "m_91fdda9b"
};
const sc = (e, { radius: t, color: n, gradient: o, variant: r, size: s, autoContrast: i, circle: a }) => {
  const l = e.variantColorResolver({
    color: n || e.primaryColor,
    theme: e,
    gradient: o,
    variant: r || "filled",
    autoContrast: i
  });
  return { root: {
    "--badge-height": he(s, "badge-height"),
    "--badge-padding-x": he(s, "badge-padding-x"),
    "--badge-fz": he(s, "badge-fz"),
    "--badge-radius": a || t === void 0 ? void 0 : Ve(t),
    "--badge-bg": n || r ? l.background : void 0,
    "--badge-color": n || r ? l.color : void 0,
    "--badge-bd": n || r ? l.border : void 0,
    "--badge-dot-color": r === "dot" ? Ie(n, e) : void 0
  } };
}, zn = it((e) => {
  const t = K("Badge", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, radius: l, color: c, gradient: p, leftSection: f, rightSection: u, children: d, variant: m, fullWidth: h, autoContrast: v, circle: y, mod: _, attributes: w, ...x } = t, C = se({
    name: "Badge",
    props: t,
    classes: rc,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: w,
    vars: a,
    varsResolver: sc
  });
  return /* @__PURE__ */ oe(q, {
    variant: m,
    mod: [{
      block: h,
      circle: y,
      "with-right-section": !!u,
      "with-left-section": !!f
    }, _],
    ...C("root", { variant: m }),
    ...x,
    children: [
      f && /* @__PURE__ */ g("span", {
        ...C("section"),
        "data-position": "left",
        children: f
      }),
      /* @__PURE__ */ g("span", {
        ...C("label"),
        children: d
      }),
      u && /* @__PURE__ */ g("span", {
        ...C("section"),
        "data-position": "right",
        children: u
      })
    ]
  });
});
zn.classes = rc;
zn.varsResolver = sc;
zn.displayName = "@mantine/core/Badge";
var _n = {
  root: "m_77c9d27d",
  inner: "m_80f1301b",
  label: "m_811560b9",
  section: "m_a74036a",
  loader: "m_a25b86ee",
  group: "m_80d6d844",
  groupSection: "m_70be2a01"
};
const ki = { orientation: "horizontal" }, ic = (e, { borderWidth: t }) => ({ group: { "--button-border-width": W(t) } }), Oo = te((e) => {
  const t = K("ButtonGroup", ki, e), { className: n, style: o, classNames: r, styles: s, unstyled: i, orientation: a, vars: l, borderWidth: c, mod: p, attributes: f, ...u } = K("ButtonGroup", ki, e), d = se({
    name: "ButtonGroup",
    props: t,
    classes: _n,
    className: n,
    style: o,
    classNames: r,
    styles: s,
    unstyled: i,
    attributes: f,
    vars: l,
    varsResolver: ic,
    rootSelector: "group"
  });
  return /* @__PURE__ */ g(q, {
    ...d("group"),
    mod: [{ orientation: a }, p],
    role: "group",
    ...u
  });
});
Oo.classes = _n;
Oo.varsResolver = ic;
Oo.displayName = "@mantine/core/ButtonGroup";
const ac = (e, { radius: t, color: n, gradient: o, variant: r, autoContrast: s, size: i }) => {
  const a = e.variantColorResolver({
    color: n || e.primaryColor,
    theme: e,
    gradient: o,
    variant: r || "filled",
    autoContrast: s
  });
  return { groupSection: {
    "--section-height": he(i, "section-height"),
    "--section-padding-x": he(i, "section-padding-x"),
    "--section-fz": i?.includes("compact") ? we(i.replace("compact-", "")) : we(i),
    "--section-radius": t === void 0 ? void 0 : Ve(t),
    "--section-bg": n || r ? a.background : void 0,
    "--section-color": a.color,
    "--section-bd": n || r ? a.border : void 0
  } };
}, Ao = te((e) => {
  const t = K("ButtonGroupSection", null, e), { className: n, style: o, classNames: r, styles: s, unstyled: i, vars: a, gradient: l, radius: c, autoContrast: p, attributes: f, ...u } = t, d = se({
    name: "ButtonGroupSection",
    props: t,
    classes: _n,
    className: n,
    style: o,
    classNames: r,
    styles: s,
    unstyled: i,
    attributes: f,
    vars: a,
    varsResolver: ac,
    rootSelector: "groupSection"
  });
  return /* @__PURE__ */ g(q, {
    ...d("groupSection"),
    ...u
  });
});
Ao.classes = _n;
Ao.varsResolver = ac;
Ao.displayName = "@mantine/core/ButtonGroupSection";
const qm = {
  in: {
    opacity: 1,
    transform: `translate(-50%, calc(-50% + ${W(1)}))`
  },
  out: {
    opacity: 0,
    transform: "translate(-50%, -200%)"
  },
  common: { transformOrigin: "center" },
  transitionProperty: "transform, opacity"
}, lc = (e, { radius: t, color: n, gradient: o, variant: r, size: s, justify: i, autoContrast: a }) => {
  const l = e.variantColorResolver({
    color: n || e.primaryColor,
    theme: e,
    gradient: o,
    variant: r || "filled",
    autoContrast: a
  });
  return { root: {
    "--button-justify": i,
    "--button-height": he(s, "button-height"),
    "--button-padding-x": he(s, "button-padding-x"),
    "--button-fz": s?.includes("compact") ? we(s.replace("compact-", "")) : we(s),
    "--button-radius": t === void 0 ? void 0 : Ve(t),
    "--button-bg": n || r ? l.background : void 0,
    "--button-hover": n || r ? l.hover : void 0,
    "--button-color": l.color,
    "--button-bd": n || r ? l.border : void 0,
    "--button-hover-color": n || r ? l.hoverColor : void 0
  } };
}, Qt = it((e) => {
  const t = K("Button", null, e), { style: n, vars: o, className: r, color: s, disabled: i, children: a, leftSection: l, rightSection: c, fullWidth: p, variant: f, radius: u, loading: d, loaderProps: m, gradient: h, classNames: v, styles: y, unstyled: _, "data-disabled": w, autoContrast: x, mod: C, attributes: $, ...M } = t, N = se({
    name: "Button",
    props: t,
    classes: _n,
    className: r,
    style: n,
    classNames: v,
    styles: y,
    unstyled: _,
    attributes: $,
    vars: o,
    varsResolver: lc
  }), I = !!l, E = !!c;
  return /* @__PURE__ */ oe(nt, {
    ...N("root", { active: !i && !d && !w }),
    unstyled: _,
    variant: f,
    disabled: i || d,
    mod: [{
      disabled: i || w,
      loading: d,
      block: p,
      "with-left-section": I,
      "with-right-section": E
    }, C],
    ...M,
    children: [typeof d == "boolean" && /* @__PURE__ */ g(mn, {
      mounted: d,
      transition: qm,
      duration: 150,
      children: (O) => /* @__PURE__ */ g(q, {
        component: "span",
        ...N("loader", { style: O }),
        "aria-hidden": !0,
        children: /* @__PURE__ */ g(wn, {
          color: "var(--button-color)",
          size: "calc(var(--button-height) / 1.8)",
          ...m
        })
      })
    }), /* @__PURE__ */ oe("span", {
      ...N("inner"),
      children: [
        l && /* @__PURE__ */ g(q, {
          component: "span",
          ...N("section"),
          mod: { position: "left" },
          children: l
        }),
        /* @__PURE__ */ g(q, {
          component: "span",
          mod: { loading: d },
          ...N("label"),
          children: a
        }),
        c && /* @__PURE__ */ g(q, {
          component: "span",
          ...N("section"),
          mod: { position: "right" },
          children: c
        })
      ]
    })]
  });
});
Qt.classes = _n;
Qt.varsResolver = lc;
Qt.displayName = "@mantine/core/Button";
Qt.Group = Oo;
Qt.GroupSection = Ao;
function Zm(e) {
  const t = e.currentTarget;
  return ct(t).activeElement !== t;
}
var cc = { root: "m_4451eb3a" };
const uc = it((e) => {
  const t = K("Center", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, inline: l, mod: c, attributes: p, ...f } = t, u = se({
    name: "Center",
    props: t,
    classes: cc,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: p,
    vars: a
  });
  return /* @__PURE__ */ g(q, {
    mod: [{ inline: l }, c],
    ...u("root"),
    ...f
  });
});
uc.classes = cc;
uc.displayName = "@mantine/core/Center";
var dc = {
  root: "m_3eebeb36",
  label: "m_9e365f20"
};
const Jm = { orientation: "horizontal" }, fc = (e, { color: t, variant: n, size: o }) => ({ root: {
  "--divider-color": t ? Ie(t, e) : void 0,
  "--divider-border-style": n,
  "--divider-size": he(o, "divider-size")
} }), Io = te((e) => {
  const t = K("Divider", Jm, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, color: l, orientation: c, label: p, labelPosition: f, mod: u, attributes: d, ...m } = t, h = se({
    name: "Divider",
    classes: dc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: d,
    vars: a,
    varsResolver: fc
  });
  return /* @__PURE__ */ g(q, {
    mod: [{
      orientation: c,
      withLabel: !!p
    }, u],
    role: "separator",
    ...h("root"),
    ...m,
    children: p && /* @__PURE__ */ g(q, {
      component: "span",
      mod: { position: f },
      ...h("label"),
      children: p
    })
  });
});
Io.classes = dc;
Io.varsResolver = fc;
Io.displayName = "@mantine/core/Divider";
const [Li, pc] = hn("Grid component was not found in tree"), Hr = (e, t) => {
  if (e === "content") return "auto";
  if (e === "auto") return "0rem";
  if (e)
    return e === t ? "100%" : `calc(${100 * e / t}% - ${(t - e) / t} * var(--grid-column-gap))`;
}, Ei = (e, t, n) => n || e === "auto" ? "100%" : e === "content" ? "unset" : Hr(e, t), Oi = (e, t) => {
  if (e)
    return e === "auto" || t ? "1" : "auto";
}, Ai = (e, t) => {
  if (e === 0) return "0";
  if (e)
    return `calc(${100 * e / t}% + ${e / t} * var(--grid-column-gap))`;
};
function Qm({ span: e, order: t, offset: n, align: o, selector: r }) {
  const s = Xe(), i = pc(), a = i.breakpoints || s.breakpoints, l = Ue(e), c = l === void 0 ? 12 : l, p = Et({
    "--col-order": Ue(t)?.toString(),
    "--col-flex-grow": Oi(c, i.grow),
    "--col-flex-basis": Hr(c, i.columns),
    "--col-width": c === "content" ? "auto" : void 0,
    "--col-max-width": Ei(c, i.columns, i.grow),
    "--col-offset": Ai(Ue(n), i.columns),
    "--col-align-self": Ue(o)
  }), f = xe(a).reduce((d, m) => (d[m] || (d[m] = {}), typeof t == "object" && t[m] !== void 0 && (d[m]["--col-order"] = t[m]?.toString()), typeof e == "object" && e[m] !== void 0 && (d[m]["--col-flex-grow"] = Oi(e[m], i.grow), d[m]["--col-flex-basis"] = Hr(e[m], i.columns), d[m]["--col-width"] = e[m] === "content" ? "auto" : void 0, d[m]["--col-max-width"] = Ei(e[m], i.columns, i.grow)), typeof n == "object" && n[m] !== void 0 && (d[m]["--col-offset"] = Ai(n[m], i.columns)), typeof o == "object" && o[m] !== void 0 && (d[m]["--col-align-self"] = o[m]), d), {}), u = Kr(xe(f), a).filter((d) => xe(f[d.value]).length > 0).map((d) => ({
    query: i.type === "container" ? `mantine-grid (min-width: ${a[d.value]})` : `(min-width: ${a[d.value]})`,
    styles: f[d.value]
  }));
  return /* @__PURE__ */ g(vn, {
    styles: p,
    media: i.type === "container" ? void 0 : u,
    container: i.type === "container" ? u : void 0,
    selector: r
  });
}
var Es = {
  container: "m_8478a6da",
  root: "m_410352e9",
  inner: "m_dee7bd2f",
  col: "m_96bdd299"
};
const eh = { span: 12 }, Os = te((e) => {
  const { classNames: t, className: n, style: o, styles: r, vars: s, span: i, order: a, offset: l, align: c, ...p } = K("GridCol", eh, e), f = pc(), u = On();
  return /* @__PURE__ */ oe(Pe, { children: [/* @__PURE__ */ g(Qm, {
    selector: `.${u}`,
    span: i,
    order: a,
    offset: l,
    align: c
  }), /* @__PURE__ */ g(q, {
    ...f.getStyles("col", {
      className: st(n, u),
      style: o,
      classNames: t,
      styles: r
    }),
    ...p
  })] });
});
Os.classes = Es;
Os.displayName = "@mantine/core/GridCol";
function Ii({ gap: e, rowGap: t, columnGap: n, selector: o, breakpoints: r, type: s }) {
  const i = Xe(), a = r || i.breakpoints, l = Et({
    "--grid-gap": _e(Ue(e)),
    "--grid-row-gap": _e(Ue(t)),
    "--grid-column-gap": _e(Ue(n))
  }), c = xe(a).reduce((f, u) => (f[u] || (f[u] = {}), typeof e == "object" && e[u] !== void 0 && (f[u]["--grid-gap"] = _e(e[u])), typeof t == "object" && t[u] !== void 0 && (f[u]["--grid-row-gap"] = _e(t[u])), typeof n == "object" && n[u] !== void 0 && (f[u]["--grid-column-gap"] = _e(n[u])), f), {}), p = Kr(xe(c), a).filter((f) => xe(c[f.value]).length > 0).map((f) => ({
    query: s === "container" ? `mantine-grid (min-width: ${a[f.value]})` : `(min-width: ${a[f.value]})`,
    styles: c[f.value]
  }));
  return /* @__PURE__ */ g(vn, {
    styles: l,
    media: s === "container" ? void 0 : p,
    container: s === "container" ? p : void 0,
    selector: o
  });
}
const th = {
  gap: "md",
  columns: 12
}, mc = (e, { justify: t, align: n, overflow: o }) => ({ root: {
  "--grid-justify": t,
  "--grid-align": n,
  "--grid-overflow": o
} }), Yo = te((e) => {
  const t = K("Grid", th, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, grow: l, gap: c, rowGap: p, columnGap: f, columns: u, align: d, justify: m, children: h, breakpoints: v, type: y, attributes: _, ...w } = t, x = se({
    name: "Grid",
    classes: Es,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: _,
    vars: a,
    varsResolver: mc
  }), C = On();
  return y === "container" && v ? /* @__PURE__ */ oe(Li, {
    value: {
      getStyles: x,
      grow: l,
      columns: u,
      breakpoints: v,
      type: y
    },
    children: [/* @__PURE__ */ g(Ii, {
      selector: `.${C}`,
      ...t
    }), /* @__PURE__ */ g("div", {
      ...x("container"),
      children: /* @__PURE__ */ g(q, {
        ...x("root", { className: C }),
        ...w,
        children: /* @__PURE__ */ g("div", {
          ...x("inner"),
          children: h
        })
      })
    })]
  }) : /* @__PURE__ */ oe(Li, {
    value: {
      getStyles: x,
      grow: l,
      columns: u,
      breakpoints: v,
      type: y
    },
    children: [/* @__PURE__ */ g(Ii, {
      selector: `.${C}`,
      ...t
    }), /* @__PURE__ */ g(q, {
      ...x("root", { className: C }),
      ...w,
      children: /* @__PURE__ */ g("div", {
        ...x("inner"),
        children: h
      })
    })]
  });
});
Yo.classes = Es;
Yo.varsResolver = mc;
Yo.displayName = "@mantine/core/Grid";
Yo.Col = Os;
function nh(e, t) {
  const n = t.trim().toLowerCase();
  if (n === "") return;
  const o = Object.values(e).filter((r) => !r.disabled && r.label.trim().toLowerCase() === n);
  return o.length === 1 ? o[0] : void 0;
}
function oh({ offset: e, position: t, defaultOpened: n }) {
  const [o, r] = re(n), s = Z(null), { x: i, y: a, elements: l, refs: c, update: p, placement: f } = gs({
    placement: t,
    middleware: [fs({
      crossAxis: !0,
      padding: 5,
      rootBoundary: "document"
    })]
  }), u = f.includes("right") ? e : t.includes("left") ? e * -1 : 0, d = f.includes("bottom") ? e : t.includes("top") ? e * -1 : 0, m = de(({ clientX: h, clientY: v }) => {
    !Number.isFinite(h) || !Number.isFinite(v) || c.setPositionReference({ getBoundingClientRect() {
      return {
        width: 0,
        height: 0,
        x: h,
        y: v,
        left: h + u,
        top: v + d,
        right: h,
        bottom: v
      };
    } });
  }, [l.reference]);
  return ce(() => {
    if (c.floating.current) {
      const h = s.current;
      h.addEventListener("mousemove", m);
      const v = bt(c.floating.current);
      return v.forEach((y) => {
        y.addEventListener("scroll", p);
      }), () => {
        h.removeEventListener("mousemove", m), v.forEach((y) => {
          y.removeEventListener("scroll", p);
        });
      };
    }
  }, [
    l.reference,
    c.floating.current,
    p,
    m,
    o
  ]), {
    handleMouseMove: m,
    x: i,
    y: a,
    opened: o,
    setOpened: r,
    boundaryRef: s,
    floating: c.setFloating
  };
}
var Fo = {
  tooltip: "m_1b3c8819",
  arrow: "m_f898399f"
};
const rh = {
  refProp: "ref",
  withinPortal: !0,
  offset: 10,
  position: "right",
  zIndex: go("popover")
}, hc = (e, { radius: t, color: n }) => ({ tooltip: {
  "--tooltip-radius": t === void 0 ? void 0 : Ve(t),
  "--tooltip-bg": n ? Ie(n, e) : void 0,
  "--tooltip-color": n ? "var(--mantine-color-white)" : void 0
} }), Wo = te((e) => {
  const t = K("TooltipFloating", rh, e), { children: n, refProp: o, withinPortal: r, style: s, className: i, classNames: a, styles: l, unstyled: c, radius: p, color: f, label: u, offset: d, position: m, multiline: h, zIndex: v, disabled: y, defaultOpened: _, variant: w, vars: x, portalProps: C, attributes: $, ref: M, ...N } = t, I = Xe(), E = se({
    name: "TooltipFloating",
    props: t,
    classes: Fo,
    className: i,
    style: s,
    classNames: a,
    styles: l,
    unstyled: c,
    attributes: $,
    rootSelector: "tooltip",
    vars: x,
    varsResolver: hc
  }), { handleMouseMove: O, x: B, y: A, opened: S, boundaryRef: k, floating: R, setOpened: D } = oh({
    offset: d,
    position: m,
    defaultOpened: _
  }), b = Ut(n);
  if (!b) throw new Error("[@mantine/core] Tooltip.Floating component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
  const T = Me(k, yo(b), M), P = b.props, F = (Y) => {
    P.onMouseEnter?.(Y), O(Y), D(!0);
  }, L = (Y) => {
    P.onMouseLeave?.(Y), D(!1);
  };
  return /* @__PURE__ */ oe(Pe, { children: [/* @__PURE__ */ g(pn, {
    ...C,
    withinPortal: r,
    children: /* @__PURE__ */ g(q, {
      ...N,
      ...E("tooltip", { style: {
        ...ha(s, I),
        zIndex: v,
        display: !y && S ? "block" : "none",
        top: Number.isFinite(A) ? Math.round(A) : "",
        left: Number.isFinite(B) ? Math.round(B) : ""
      } }),
      variant: w,
      ref: R,
      mod: { multiline: h },
      children: u
    })
  }), Kt(b, {
    ...P,
    [o]: T,
    onMouseEnter: F,
    onMouseLeave: L
  })] });
});
Wo.classes = Fo;
Wo.varsResolver = hc;
Wo.displayName = "@mantine/core/TooltipFloating";
const gc = mt({ withinGroup: !1 }), sh = {
  openDelay: 0,
  closeDelay: 0
};
function As(e) {
  const { openDelay: t, closeDelay: n, children: o } = K("TooltipGroup", sh, e);
  return /* @__PURE__ */ g(gc, {
    value: { withinGroup: !0 },
    children: /* @__PURE__ */ g(Ip, {
      delay: {
        open: t,
        close: n
      },
      children: o
    })
  });
}
As.displayName = "@mantine/core/TooltipGroup";
As.extend = (e) => e;
function ih(e) {
  if (e === void 0) return {
    shift: !0,
    flip: !0
  };
  const t = { ...e };
  return e.shift === void 0 && (t.shift = !0), e.flip === void 0 && (t.flip = !0), t;
}
function ah(e) {
  const t = ih(e.middlewares), n = [za(e.offset)];
  return t.shift && n.push(fs(typeof t.shift == "boolean" ? { padding: 8 } : {
    padding: 8,
    ...t.shift
  })), t.flip && n.push(typeof t.flip == "boolean" ? Fr() : Fr(t.flip)), n.push(Ha({
    element: e.arrowRef,
    padding: e.arrowOffset
  })), t.inline ? n.push(typeof t.inline == "boolean" ? Pn() : Pn(t.inline)) : e.inline && n.push(Pn()), n;
}
function lh(e) {
  const [t, n] = re(e.defaultOpened), o = typeof e.opened == "boolean" ? e.opened : t, r = Te(gc).withinGroup, s = Ot(), i = de((C) => {
    n(C), C && v(s);
  }, [s]), { x: a, y: l, context: c, refs: p, placement: f, middlewareData: { arrow: { x: u, y: d } = {} } } = gs({
    strategy: e.strategy,
    placement: e.position,
    open: o,
    onOpenChange: i,
    middleware: ah(e),
    whileElementsMounted: Yr
  }), { delay: m, currentId: h, setCurrentId: v } = Yp(c, { id: s }), { getReferenceProps: y, getFloatingProps: _ } = jp([
    Op(c, {
      enabled: e.events?.hover,
      delay: r ? m : {
        open: e.openDelay,
        close: e.closeDelay
      },
      mouseOnly: !e.events?.touch,
      handleClose: e.interactive ? Xp() : null
    }),
    Vp(c, {
      enabled: e.events?.focus,
      visibleOnly: !0
    }),
    Kp(c, { role: "tooltip" }),
    zp(c, { enabled: typeof e.opened > "u" })
  ]), w = Z(f);
  Ct(() => {
    w.current !== f && (w.current = f, e.onPositionChange?.(f));
  }, [f]);
  const x = o && h && h !== s;
  return {
    x: a,
    y: l,
    arrowX: u,
    arrowY: d,
    reference: p.setReference,
    floating: p.setFloating,
    getFloatingProps: _,
    getReferenceProps: y,
    isGroupPhase: x,
    opened: o,
    placement: f
  };
}
const ch = {
  position: "top",
  refProp: "ref",
  withinPortal: !0,
  arrowSize: 4,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  offset: 5,
  transitionProps: {
    duration: 100,
    transition: "fade"
  },
  events: {
    hover: !0,
    focus: !1,
    touch: !1
  },
  zIndex: go("popover"),
  middlewares: {
    flip: !0,
    shift: !0,
    inline: !1
  }
}, vc = (e, { radius: t, color: n, variant: o, autoContrast: r }) => {
  const s = e.variantColorResolver({
    theme: e,
    color: n || e.primaryColor,
    autoContrast: r,
    variant: o || "filled"
  });
  return { tooltip: {
    "--tooltip-radius": t === void 0 ? void 0 : Ve(t),
    "--tooltip-bg": n ? s.background : void 0,
    "--tooltip-color": n ? s.color : void 0
  } };
}, xn = te((e) => {
  const t = K("Tooltip", ch, e), { children: n, position: o, refProp: r, label: s, openDelay: i, closeDelay: a, onPositionChange: l, opened: c, defaultOpened: p, withinPortal: f, radius: u, color: d, classNames: m, styles: h, unstyled: v, style: y, className: _, withArrow: w, arrowSize: x, arrowOffset: C, arrowRadius: $, arrowPosition: M, offset: N, transitionProps: I, multiline: E, events: O, interactive: B, zIndex: A, disabled: S, onClick: k, onMouseEnter: R, onMouseLeave: D, inline: b, variant: T, keepMounted: P, vars: F, portalProps: L, mod: Y, floatingStrategy: z, middlewares: V, autoContrast: U, attributes: ee, target: X, ref: G, ...J } = t, { dir: ie } = An(), ae = Z(null), ne = lh({
    position: tl(ie, o),
    closeDelay: a,
    openDelay: i,
    onPositionChange: l,
    opened: c,
    defaultOpened: p,
    events: O,
    interactive: B,
    arrowRef: ae,
    arrowOffset: C,
    offset: typeof N == "number" ? N + (w ? x / 2 : 0) : N,
    inline: b,
    strategy: z,
    middlewares: V
  });
  ce(() => {
    const ke = X instanceof HTMLElement ? X : typeof X == "string" ? document.querySelector(X) : X?.current || null;
    ke && ne.reference(ke);
  }, [X, ne]);
  const ue = se({
    name: "Tooltip",
    props: t,
    classes: Fo,
    className: _,
    style: y,
    classNames: m,
    styles: h,
    unstyled: v,
    attributes: ee,
    rootSelector: "tooltip",
    vars: F,
    varsResolver: vc
  }), le = Ut(n);
  if (!X && !le) throw new Error("[@mantine/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
  const Q = ue("tooltip"), me = B && !S && !!ne.opened, be = M === "merge" && w ? el({
    position: ne.placement,
    dir: ie
  }) : void 0;
  if (X) {
    const ke = Ni(I, {
      duration: 100,
      transition: "fade"
    });
    return /* @__PURE__ */ g(Pe, { children: /* @__PURE__ */ g(pn, {
      ...L,
      withinPortal: f,
      children: /* @__PURE__ */ g(mn, {
        ...ke,
        keepMounted: P,
        mounted: !S && !!ne.opened,
        duration: ne.isGroupPhase ? 10 : ke.duration,
        children: (Ge) => /* @__PURE__ */ oe(q, {
          ...J,
          "data-fixed": z === "fixed" || void 0,
          variant: T,
          mod: [{
            multiline: E,
            interactive: me
          }, Y],
          ...Q,
          ...ne.getFloatingProps({
            ref: ne.floating,
            className: Q.className,
            style: {
              ...Q.style,
              ...Ge,
              ...be,
              zIndex: A,
              top: ne.y ?? 0,
              left: ne.x ?? 0
            }
          }),
          children: [s, /* @__PURE__ */ g(fo, {
            ref: ae,
            arrowX: ne.arrowX,
            arrowY: ne.arrowY,
            visible: w,
            position: ne.placement,
            arrowSize: x,
            arrowOffset: C,
            arrowRadius: $,
            arrowPosition: M,
            ...ue("arrow")
          })]
        })
      })
    }) });
  }
  const Re = le.props, Ne = Me(ne.reference, yo(le), G), We = Ni(I, {
    duration: 100,
    transition: "fade"
  });
  return /* @__PURE__ */ oe(Pe, { children: [/* @__PURE__ */ g(pn, {
    ...L,
    withinPortal: f,
    children: /* @__PURE__ */ g(mn, {
      ...We,
      keepMounted: P,
      mounted: !S && !!ne.opened,
      duration: ne.isGroupPhase ? 10 : We.duration,
      children: (ke) => /* @__PURE__ */ oe(q, {
        ...J,
        "data-fixed": z === "fixed" || void 0,
        variant: T,
        mod: [{
          multiline: E,
          interactive: me
        }, Y],
        ...ne.getFloatingProps({
          ref: ne.floating,
          className: ue("tooltip").className,
          style: {
            ...ue("tooltip").style,
            ...ke,
            ...be,
            zIndex: A,
            top: ne.y ?? 0,
            left: ne.x ?? 0
          }
        }),
        children: [s, /* @__PURE__ */ g(fo, {
          ref: ae,
          arrowX: ne.arrowX,
          arrowY: ne.arrowY,
          visible: w,
          position: ne.placement,
          arrowSize: x,
          arrowOffset: C,
          arrowRadius: $,
          arrowPosition: M,
          ...ue("arrow")
        })]
      })
    })
  }), Kt(le, ne.getReferenceProps({
    onClick: k,
    onMouseEnter: R,
    onMouseLeave: D,
    onMouseMove: t.onMouseMove,
    onPointerDown: t.onPointerDown,
    onPointerEnter: t.onPointerEnter,
    ...Re,
    className: st(_, Re.className),
    [r]: Ne
  }))] });
});
xn.classes = Fo;
xn.varsResolver = vc;
xn.displayName = "@mantine/core/Tooltip";
xn.Floating = Wo;
xn.Group = As;
var yc = {
  root: "m_cf365364",
  indicator: "m_9e182ccd",
  label: "m_1738fcb2",
  input: "m_1714d588",
  control: "m_69686b9b",
  innerLabel: "m_78882f40"
};
const uh = { withItemsBorders: !0 }, bc = (e, { radius: t, color: n, transitionDuration: o, size: r, transitionTimingFunction: s }) => ({ root: {
  "--sc-radius": t === void 0 ? void 0 : Ve(t),
  "--sc-color": n ? Ie(n, e) : void 0,
  "--sc-shadow": n ? void 0 : "var(--mantine-shadow-xs)",
  "--sc-transition-duration": o === void 0 ? void 0 : `${o}ms`,
  "--sc-transition-timing-function": s,
  "--sc-padding": he(r, "sc-padding"),
  "--sc-font-size": we(r)
} }), Bo = os((e) => {
  const t = K("SegmentedControl", uh, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, data: l, value: c, defaultValue: p, onChange: f, size: u, name: d, disabled: m, readOnly: h, fullWidth: v, orientation: y, radius: _, color: w, transitionDuration: x, transitionTimingFunction: C, variant: $, autoContrast: M, withItemsBorders: N, mod: I, attributes: E, ref: O, ...B } = t, A = se({
    name: "SegmentedControl",
    props: t,
    classes: yc,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: E,
    vars: a,
    varsResolver: bc
  }), S = Xe(), k = l.map((G) => Bu(G) ? {
    label: `${G}`,
    value: G
  } : G), R = Au(), [D, b] = re(Dr()), [T, P] = re(null), [F, L] = re({}), Y = (G, J) => {
    F[J] = G, L(F);
  }, [z, V] = _t({
    value: c,
    defaultValue: p,
    finalValue: Array.isArray(l) ? k.find((G) => !G.disabled)?.value ?? l[0]?.value ?? null : null,
    onChange: f
  }), U = Ot(d), ee = k.map((G) => /* @__PURE__ */ yt(q, {
    ...A("control"),
    mod: {
      active: z === G.value,
      orientation: y
    },
    key: `${G.value}`
  }, /* @__PURE__ */ yt("input", {
    ...A("input"),
    disabled: m || G.disabled,
    type: "radio",
    name: U,
    value: `${G.value}`,
    id: `${U}-${G.value}`,
    checked: z === G.value,
    onChange: () => !h && V(G.value),
    "data-focus-ring": S.focusRing,
    key: `${G.value}-input`
  }), /* @__PURE__ */ yt(q, {
    component: "label",
    ...A("label"),
    mod: {
      active: z === G.value && !(m || G.disabled),
      disabled: m || G.disabled,
      "read-only": h
    },
    htmlFor: `${U}-${G.value}`,
    ref: (J) => Y(J, `${G.value}`),
    __vars: { "--sc-label-color": w !== void 0 ? En({
      color: w,
      theme: S,
      autoContrast: M
    }) : void 0 },
    key: `${G.value}-label`
  }, /* @__PURE__ */ g("span", {
    ...A("innerLabel"),
    children: G.label
  })))), X = Me(O, P);
  return ku(() => {
    b(Dr());
  }, [l.length]), l.length === 0 ? null : /* @__PURE__ */ oe(q, {
    ...A("root"),
    variant: $,
    size: u,
    ref: X,
    mod: [{
      "full-width": v,
      orientation: y,
      initialized: R,
      "with-items-borders": N
    }, I],
    ...B,
    role: "radiogroup",
    "data-disabled": m,
    children: [typeof z < "u" && /* @__PURE__ */ g(No, {
      target: F[`${z}`],
      parent: T,
      component: "span",
      transitionDuration: "var(--sc-transition-duration)",
      ...A("indicator")
    }, D), ee]
  });
});
Bo.classes = yc;
Bo.varsResolver = bc;
Bo.displayName = "@mantine/core/SegmentedControl";
const dh = {
  size: "sm",
  withCheckIcon: !0,
  allowDeselect: !0,
  checkIconPosition: "left",
  openOnFocus: !0
}, Is = os((e) => {
  const t = K([
    "Input",
    "InputWrapper",
    "Select"
  ], dh, e), { classNames: n, styles: o, unstyled: r, vars: s, dropdownOpened: i, defaultDropdownOpened: a, onDropdownClose: l, onDropdownOpen: c, onFocus: p, onBlur: f, onClick: u, onChange: d, data: m, value: h, defaultValue: v, selectFirstOptionOnChange: y, selectFirstOptionOnDropdownOpen: _, onOptionSubmit: w, comboboxProps: x, readOnly: C, disabled: $, filter: M, limit: N, withScrollArea: I, maxDropdownHeight: E, floatingHeight: O, size: B, searchable: A, rightSection: S, checkIconPosition: k, withCheckIcon: R, withAlignedLabels: D, nothingFoundMessage: b, name: T, form: P, searchValue: F, defaultSearchValue: L, onSearchChange: Y, allowDeselect: z, error: V, rightSectionPointerEvents: U, id: ee, clearable: X, clearSectionMode: G, clearButtonProps: J, hiddenInputProps: ie, renderOption: ae, onClear: ne, autoComplete: ue, scrollAreaProps: le, __defaultRightSection: Q, __clearSection: me, __clearable: be, chevronColor: Re, autoSelectOnBlur: Ne, openOnFocus: We, attributes: ke, ...Ge } = t, ge = fn(() => Mm(m), [m]), Dt = Z({}), De = fn(() => Ol(ge), [ge]), nn = Ot(ee), [fe, Be, on] = _t({
    value: h,
    defaultValue: v,
    finalValue: null,
    onChange: d
  }), Ze = fe != null ? `${fe}` in De ? De[`${fe}`] : Dt.current[`${fe}`] : void 0, Yt = Eu(Ze), [rn, tr, nr] = _t({
    value: F,
    defaultValue: L,
    finalValue: Ze ? Ze.label : "",
    onChange: Y
  }), Le = zl({
    opened: i,
    defaultOpened: a,
    onDropdownOpen: () => {
      c?.(), _ ? Le.selectFirstOption() : Le.updateSelectedOptionIndex("active", { scrollIntoView: !0 });
    },
    onDropdownClose: () => {
      l?.(), setTimeout(Le.resetSelectedOption, 0);
    }
  }), lt = ($e) => {
    tr($e), Le.resetSelectedOption();
  }, { resolvedClassNames: $t, resolvedStyles: ht } = gn({
    props: t,
    styles: o,
    classNames: n
  });
  ce(() => {
    y && Le.selectFirstOption();
  }, [y, rn]), ce(() => {
    h === null && lt(""), h != null && Ze && (Yt?.value !== Ze.value || Yt?.label !== Ze.label) && lt(Ze.label);
  }, [h, Ze]), ce(() => {
    !on && !nr && lt(fe != null ? `${fe}` in De ? De[`${fe}`]?.label : Dt.current[`${fe}`]?.label || "" : "");
  }, [De, fe]), ce(() => {
    fe && `${fe}` in De && (Dt.current[`${fe}`] = De[`${fe}`]);
  }, [De, fe]);
  const or = /* @__PURE__ */ g(pe.ClearButton, {
    ...J,
    onClear: () => {
      Be(null, null), lt(""), ne?.();
    }
  }), Ke = X && fe != null && !$ && !C;
  return /* @__PURE__ */ oe(Pe, { children: [/* @__PURE__ */ oe(pe, {
    store: Le,
    __staticSelector: "Select",
    classNames: $t,
    styles: ht,
    unstyled: r,
    readOnly: C,
    size: B,
    attributes: ke,
    floatingHeight: O,
    keepMounted: Ne,
    onOptionSubmit: ($e) => {
      w?.($e);
      const Ee = z && `${De[$e].value}` == `${fe}` ? null : De[$e], Ft = Ee ? Ee.value : null;
      Ft !== fe && Be(Ft, Ee), !on && lt(Ft != null && Ee?.label || ""), Le.closeDropdown();
    },
    ...x,
    children: [/* @__PURE__ */ g(pe.Target, {
      targetType: A ? "input" : "button",
      autoComplete: ue,
      withExpandedAttribute: !0,
      children: /* @__PURE__ */ g(Cn, {
        id: nn,
        __defaultRightSection: /* @__PURE__ */ g(pe.Chevron, {
          size: B,
          error: V,
          unstyled: r,
          color: Re
        }),
        __clearSection: or,
        __clearable: Ke,
        __clearSectionMode: G,
        rightSection: S,
        rightSectionPointerEvents: U || "none",
        ...Ge,
        size: B,
        __staticSelector: "Select",
        disabled: $,
        readOnly: C || !A,
        value: rn,
        onChange: ($e) => {
          if (Zm($e)) {
            if (!C) {
              const Ee = nh(De, $e.currentTarget.value);
              Ee && `${Ee.value}` != `${fe}` && (Be(Ee.value, Ee), !on && lt(Ee.label));
            }
            return;
          }
          lt($e.currentTarget.value), Le.openDropdown(), y && Le.selectFirstOption();
        },
        onFocus: ($e) => {
          We && A && Le.openDropdown(), p?.($e);
        },
        onBlur: ($e) => {
          Ne && Le.clickSelectedOption(), A && Le.closeDropdown();
          const Ee = fe != null && (`${fe}` in De ? De[`${fe}`] : Dt.current[`${fe}`]);
          lt(Ee && Ee.label || ""), f?.($e);
        },
        onClick: ($e) => {
          A ? Le.openDropdown() : Le.toggleDropdown(), u?.($e);
        },
        classNames: $t,
        styles: ht,
        unstyled: r,
        pointer: !A,
        error: V,
        attributes: ke
      })
    }), /* @__PURE__ */ g(Xm, {
      data: ge,
      hidden: C || $,
      filter: M,
      search: rn,
      limit: N,
      hiddenWhenEmpty: !b,
      withScrollArea: I,
      maxDropdownHeight: E,
      filterOptions: !!A && Ze?.label !== rn,
      value: fe,
      checkIconPosition: k,
      withCheckIcon: R,
      withAlignedLabels: D,
      nothingFoundMessage: b,
      unstyled: r,
      labelId: Ge.label ? `${nn}-label` : void 0,
      "aria-label": Ge.label ? void 0 : Ge["aria-label"],
      renderOption: ae,
      scrollAreaProps: le
    })]
  }), /* @__PURE__ */ g(pe.HiddenInput, {
    value: fe,
    name: T,
    form: P,
    disabled: $,
    ...ie
  })] });
});
Is.classes = {
  ...Cn.classes,
  ...pe.classes
};
Is.displayName = "@mantine/core/Select";
function wc(e) {
  if (e !== void 0)
    return typeof e == "number" ? W(e) : e;
}
function fh({ spacing: e, verticalSpacing: t, cols: n, minColWidth: o, autoRows: r, selector: s }) {
  const i = Xe(), a = t === void 0 ? e : t, l = o !== void 0, c = Et({
    "--sg-spacing-x": _e(Ue(e)),
    "--sg-spacing-y": _e(Ue(a)),
    "--sg-auto-rows": r,
    ...l ? { "--sg-min-col-width": wc(o) } : { "--sg-cols": Ue(n)?.toString() }
  }), p = xe(i.breakpoints).reduce((u, d) => (u[d] || (u[d] = {}), typeof e == "object" && e[d] !== void 0 && (u[d]["--sg-spacing-x"] = _e(e[d])), typeof a == "object" && a[d] !== void 0 && (u[d]["--sg-spacing-y"] = _e(a[d])), !l && typeof n == "object" && n[d] !== void 0 && (u[d]["--sg-cols"] = n[d]), u), {}), f = Kr(xe(p), i.breakpoints).filter((u) => xe(p[u.value]).length > 0).map((u) => ({
    query: `(min-width: ${i.breakpoints[u.value]})`,
    styles: p[u.value]
  }));
  return /* @__PURE__ */ g(vn, {
    styles: c,
    media: f,
    selector: s
  });
}
function Sr(e) {
  return typeof e == "object" && e !== null ? xe(e) : [];
}
function ph(e) {
  return e.sort((t, n) => Mn(t) - Mn(n));
}
function mh({ spacing: e, verticalSpacing: t, cols: n, minColWidth: o }) {
  return ph(Array.from(/* @__PURE__ */ new Set([
    ...Sr(e),
    ...Sr(t),
    ...o !== void 0 ? [] : Sr(n)
  ])));
}
function hh({ spacing: e, verticalSpacing: t, cols: n, minColWidth: o, autoRows: r, selector: s }) {
  const i = t === void 0 ? e : t, a = o !== void 0, l = Et({
    "--sg-spacing-x": _e(Ue(e)),
    "--sg-spacing-y": _e(Ue(i)),
    "--sg-auto-rows": r,
    ...a ? { "--sg-min-col-width": wc(o) } : { "--sg-cols": Ue(n)?.toString() }
  }), c = mh({
    spacing: e,
    verticalSpacing: t,
    cols: n,
    minColWidth: o
  }), p = c.reduce((u, d) => (u[d] || (u[d] = {}), typeof e == "object" && e[d] !== void 0 && (u[d]["--sg-spacing-x"] = _e(e[d])), typeof i == "object" && i[d] !== void 0 && (u[d]["--sg-spacing-y"] = _e(i[d])), !a && typeof n == "object" && n[d] !== void 0 && (u[d]["--sg-cols"] = n[d]), u), {}), f = c.map((u) => ({
    query: `simple-grid (min-width: ${u})`,
    styles: p[u]
  }));
  return /* @__PURE__ */ g(vn, {
    styles: l,
    container: f,
    selector: s
  });
}
var Cc = {
  container: "m_925c2d2c",
  root: "m_2415a157"
};
const gh = {
  cols: 1,
  spacing: "md",
  type: "media"
}, _c = te((e) => {
  const t = K("SimpleGrid", gh, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, cols: l, verticalSpacing: c, spacing: p, type: f, minColWidth: u, autoFlow: d, autoRows: m, attributes: h, ...v } = t, y = se({
    name: "SimpleGrid",
    classes: Cc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: h,
    vars: a
  }), _ = On(), w = u !== void 0 ? d || "auto-fill" : void 0;
  return f === "container" ? /* @__PURE__ */ oe(Pe, { children: [/* @__PURE__ */ g(hh, {
    ...t,
    selector: `.${_}`
  }), /* @__PURE__ */ g("div", {
    ...y("container"),
    children: /* @__PURE__ */ g(q, {
      ...y("root", { className: _ }),
      ...v,
      "data-auto-cols": w
    })
  })] }) : /* @__PURE__ */ oe(Pe, { children: [/* @__PURE__ */ g(fh, {
    ...t,
    selector: `.${_}`
  }), /* @__PURE__ */ g(q, {
    ...y("root", { className: _ }),
    ...v,
    "data-auto-cols": w
  })] });
});
_c.classes = Cc;
_c.displayName = "@mantine/core/SimpleGrid";
const vh = te((e) => {
  const { w: t, h: n, miw: o, mih: r, ...s } = K("Space", null, e);
  return /* @__PURE__ */ g(q, {
    ...s,
    w: t,
    miw: o ?? t,
    h: n,
    mih: r ?? n
  });
});
vh.displayName = "@mantine/core/Space";
var xc = { root: "m_6d731127" };
const yh = {
  gap: "md",
  align: "stretch",
  justify: "flex-start"
}, Sc = (e, { gap: t, align: n, justify: o }) => ({ root: {
  "--stack-gap": _e(t),
  "--stack-align": n,
  "--stack-justify": o
} }), Ys = te((e) => {
  const t = K("Stack", yh, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, align: l, justify: c, gap: p, variant: f, attributes: u, ...d } = t, m = se({
    name: "Stack",
    props: t,
    classes: xc,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: u,
    vars: a,
    varsResolver: Sc
  });
  return /* @__PURE__ */ g(q, {
    ...m("root"),
    variant: f,
    ...d
  });
});
Ys.classes = xc;
Ys.varsResolver = Sc;
Ys.displayName = "@mantine/core/Stack";
const [bh, wh] = hn("Table component was not found in the tree");
var Hn = {
  table: "m_b23fa0ef",
  th: "m_4e7aa4f3",
  tr: "m_4e7aa4fd",
  td: "m_4e7aa4ef",
  tbody: "m_b2404537",
  thead: "m_b242d975",
  caption: "m_9e5a3ac7",
  scrollContainer: "m_a100c15",
  scrollContainerInner: "m_62259741"
};
function Ch(e, t) {
  if (!t) return;
  const n = {};
  return t.columnBorder && e.withColumnBorders && (n["data-with-column-border"] = !0), t.rowBorder && e.withRowBorders && (n["data-with-row-border"] = !0), t.striped && e.striped && (n["data-striped"] = e.striped), t.highlightOnHover && e.highlightOnHover && (n["data-hover"] = !0), t.captionSide && e.captionSide && (n["data-side"] = e.captionSide), t.stickyHeader && e.stickyHeader && (n["data-sticky"] = !0), n;
}
function en(e, t) {
  const n = `Table${e.charAt(0).toUpperCase()}${e.slice(1)}`, o = te((r) => {
    const s = K(n, {}, r), { classNames: i, className: a, style: l, styles: c, ...p } = s, f = wh();
    return /* @__PURE__ */ g(q, {
      component: e,
      ...Ch(f, t),
      ...f.getStyles(e, {
        className: a,
        classNames: i,
        style: l,
        styles: c,
        props: s
      }),
      ...p
    });
  });
  return o.displayName = `@mantine/core/${n}`, o.classes = Hn, o;
}
const Vr = en("th", { columnBorder: !0 }), Rc = en("td", { columnBorder: !0 }), to = en("tr", {
  rowBorder: !0,
  striped: !0,
  highlightOnHover: !0
}), Dc = en("thead", { stickyHeader: !0 }), $c = en("tbody"), Pc = en("tfoot"), Mc = en("caption", { captionSide: !0 }), _h = { type: "scrollarea" }, Tc = (e, { minWidth: t, maxHeight: n, type: o }) => ({ scrollContainer: {
  "--table-min-width": W(t),
  "--table-max-height": W(n),
  "--table-overflow": o === "native" ? "auto" : void 0
} }), zo = te((e) => {
  const t = K("TableScrollContainer", _h, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, children: l, minWidth: c, maxHeight: p, type: f, scrollAreaProps: u, attributes: d, ...m } = t, h = se({
    name: "TableScrollContainer",
    classes: Hn,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: d,
    vars: a,
    varsResolver: Tc,
    rootSelector: "scrollContainer"
  });
  return /* @__PURE__ */ g(q, {
    component: f === "scrollarea" ? qt : "div",
    ...f === "scrollarea" ? p ? {
      offsetScrollbars: "xy",
      ...u
    } : {
      offsetScrollbars: "x",
      ...u
    } : {},
    ...h("scrollContainer"),
    ...m,
    children: /* @__PURE__ */ g("div", {
      ...h("scrollContainerInner"),
      children: l
    })
  });
});
zo.classes = Hn;
zo.varsResolver = Tc;
zo.displayName = "@mantine/core/TableScrollContainer";
function Fs({ data: e }) {
  return /* @__PURE__ */ oe(Pe, { children: [
    e.caption && /* @__PURE__ */ g(Mc, { children: e.caption }),
    e.head && /* @__PURE__ */ g(Dc, { children: /* @__PURE__ */ g(to, { children: e.head.map((t, n) => /* @__PURE__ */ g(Vr, { children: t }, n)) }) }),
    e.body && /* @__PURE__ */ g($c, { children: e.body.map((t, n) => /* @__PURE__ */ g(to, { children: t.map((o, r) => /* @__PURE__ */ g(Rc, { children: o }, r)) }, n)) }),
    e.foot && /* @__PURE__ */ g(Pc, { children: /* @__PURE__ */ g(to, { children: e.foot.map((t, n) => /* @__PURE__ */ g(Vr, { children: t }, n)) }) })
  ] });
}
Fs.displayName = "@mantine/core/TableDataRenderer";
const xh = {
  withRowBorders: !0,
  verticalSpacing: 7
}, Nc = (e, { layout: t, captionSide: n, horizontalSpacing: o, verticalSpacing: r, borderColor: s, stripedColor: i, highlightOnHoverColor: a, striped: l, highlightOnHover: c, stickyHeaderOffset: p, stickyHeader: f }) => ({ table: {
  "--table-layout": t,
  "--table-caption-side": n,
  "--table-horizontal-spacing": _e(o),
  "--table-vertical-spacing": _e(r),
  "--table-border-color": s ? Ie(s, e) : void 0,
  "--table-striped-color": l && i ? Ie(i, e) : void 0,
  "--table-highlight-on-hover-color": c && a ? Ie(a, e) : void 0,
  "--table-sticky-header-offset": f ? W(p) : void 0
} }), Ce = te((e) => {
  const t = K("Table", xh, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, horizontalSpacing: l, verticalSpacing: c, captionSide: p, stripedColor: f, highlightOnHoverColor: u, striped: d, highlightOnHover: m, withColumnBorders: h, withRowBorders: v, withTableBorder: y, borderColor: _, layout: w, data: x, children: C, stickyHeader: $, stickyHeaderOffset: M, mod: N, tabularNums: I, attributes: E, ...O } = t, B = se({
    name: "Table",
    props: t,
    className: o,
    style: r,
    classes: Hn,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: E,
    rootSelector: "table",
    vars: a,
    varsResolver: Nc
  });
  return /* @__PURE__ */ g(bh, {
    value: {
      getStyles: B,
      stickyHeader: $,
      striped: d === !0 ? "odd" : d || void 0,
      highlightOnHover: m,
      withColumnBorders: h,
      withRowBorders: v,
      captionSide: p || "bottom"
    },
    children: /* @__PURE__ */ g(q, {
      component: "table",
      mod: [{
        withTableBorder: y,
        tabularNums: I
      }, N],
      ...B("table"),
      ...O,
      children: C || !!x && /* @__PURE__ */ g(Fs, { data: x })
    })
  });
});
Ce.classes = Hn;
Ce.varsResolver = Nc;
Ce.displayName = "@mantine/core/Table";
Ce.Td = Rc;
Ce.Th = Vr;
Ce.Tr = to;
Ce.Thead = Dc;
Ce.Tbody = $c;
Ce.Tfoot = Pc;
Ce.Caption = Mc;
Ce.ScrollContainer = zo;
Ce.DataRenderer = Fs;
const Ws = te((e) => {
  const t = K([
    "Input",
    "InputWrapper",
    "TextInput"
  ], null, e);
  return /* @__PURE__ */ g(Cn, {
    component: "input",
    ...t,
    __staticSelector: "TextInput"
  });
});
Ws.classes = Cn.classes;
Ws.displayName = "@mantine/core/TextInput";
const Sh = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6"
], Rh = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
];
function Dh(e, t) {
  const n = t !== void 0 ? t : `h${e}`;
  return Sh.includes(n) ? {
    fontSize: `var(--mantine-${n}-font-size)`,
    fontWeight: `var(--mantine-${n}-font-weight)`,
    lineHeight: `var(--mantine-${n}-line-height)`
  } : Rh.includes(n) ? {
    fontSize: `var(--mantine-font-size-${n})`,
    fontWeight: `var(--mantine-h${e}-font-weight)`,
    lineHeight: `var(--mantine-h${e}-line-height)`
  } : {
    fontSize: W(n),
    fontWeight: `var(--mantine-h${e}-font-weight)`,
    lineHeight: `var(--mantine-h${e}-line-height)`
  };
}
var kc = { root: "m_8a5d1357" };
const $h = { order: 1 }, Lc = (e, { order: t, size: n, lineClamp: o, textWrap: r }) => {
  const s = Dh(t || 1, n);
  return { root: {
    "--title-fw": s.fontWeight,
    "--title-lh": s.lineHeight,
    "--title-fz": s.fontSize,
    "--title-line-clamp": typeof o == "number" ? o.toString() : void 0,
    "--title-text-wrap": r
  } };
}, Bs = te((e) => {
  const t = K("Title", $h, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, order: a, vars: l, size: c, variant: p, lineClamp: f, textWrap: u, mod: d, attributes: m, ...h } = t, v = se({
    name: "Title",
    props: t,
    classes: kc,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: m,
    vars: l,
    varsResolver: Lc
  });
  return [
    1,
    2,
    3,
    4,
    5,
    6
  ].includes(a) ? /* @__PURE__ */ g(q, {
    ...v("root"),
    component: `h${a}`,
    variant: p,
    mod: [{
      order: a,
      lineClamp: typeof f == "number"
    }, d],
    size: c,
    ...h
  }) : null;
});
Bs.classes = kc;
Bs.varsResolver = Lc;
Bs.displayName = "@mantine/core/Title";
const Ph = [
  "#f2f6fa",
  "#d9e5f3",
  "#b8d0ed",
  "#91b8ea",
  "#65a0ea",
  "#3486ed",
  "#0b6ce6",
  "#0e59b7",
  "#0f468b",
  "#0e3361"
], Mh = [
  "#f6f6f7",
  "#e2e3e6",
  "#caccd1",
  "#afb2bc",
  "#9398a5",
  "#757b8f",
  "#4b5563",
  "#4b505d",
  "#3b3f48",
  "#111827"
], Th = [
  "#f3faf7",
  "#d1eee5",
  "#a6e3d1",
  "#73dbbc",
  "#39d6a7",
  "#1db285",
  "#0f7d5c",
  "#10694e",
  "#105541",
  "#0f4333"
], Nh = [
  "#f9f3f3",
  "#f0dddd",
  "#e7c1c1",
  "#dfa0a0",
  "#d97c7c",
  "#d45353",
  "#cf2b2b",
  "#a62727",
  "#7e2222",
  "#581b1b"
], kh = [
  "#faf7f2",
  "#f1e6d2",
  "#e9d1a8",
  "#e4bc77",
  "#e3a640",
  "#d38c15",
  "#a26909",
  "#82560b",
  "#64430c",
  "#47300b"
], Lh = [
  "#c9ccd4",
  "#b0b4bf",
  "#9296a3",
  "#6d7280",
  "#4d515e",
  "#3a3e49",
  "#2f323c",
  "#242730",
  "#1b1e25",
  "#14161c"
], Eh = { brand: Ph, ink: Mh, good: Th, bad: Nh, warn: kh, dark: Lh }, Oh = {
  colors: Eh,
  primaryColor: "brand",
  primaryShade: { light: 6, dark: 8 },
  white: "#ffffff",
  black: "#111827",
  fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
  headings: {
    fontFamily: "Inter, system-ui, sans-serif",
    fontWeight: "700",
    sizes: {
      h1: { fontSize: "30px", lineHeight: "1.15" },
      h2: { fontSize: "24px", lineHeight: "1.2" },
      h3: { fontSize: "20px", lineHeight: "1.25" },
      h4: { fontSize: "16px", lineHeight: "1.3" },
      h5: { fontSize: "13.5px", lineHeight: "1.4" },
      h6: { fontSize: "11px", lineHeight: "1.4" }
    }
  },
  fontSizes: {
    xs: "11px",
    sm: "12.5px",
    md: "13.5px",
    lg: "15px",
    xl: "20px"
  },
  lineHeights: { xs: "1.4", sm: "1.45", md: "1.5", lg: "1.6", xl: "1.6" },
  spacing: { xs: "4px", sm: "8px", md: "12px", lg: "16px", xl: "24px" },
  radius: { xs: "4px", sm: "6px", md: "8px", lg: "12px", xl: "999px" },
  defaultRadius: "md",
  shadows: {
    xs: "none",
    sm: "none",
    md: "0 4px 16px rgba(17, 24, 39, 0.08)",
    lg: "0 12px 32px rgba(17, 24, 39, 0.12)",
    xl: "0 24px 56px rgba(17, 24, 39, 0.16)"
  },
  cursorType: "pointer",
  focusRing: "auto"
};
function Fg({ children: e, colorScheme: t = "light" }) {
  return /* @__PURE__ */ g(fa, { theme: Oh, defaultColorScheme: t, forceColorScheme: t === "auto" ? void 0 : t, children: e });
}
function Wg({ variant: e = "filled", size: t = "sm", ...n }) {
  return /* @__PURE__ */ g(Qt, { variant: e, size: t, ...n });
}
function Bg({ variant: e = "filled", size: t = "sm", ...n }) {
  return /* @__PURE__ */ g(Qt, { component: "a", variant: e, size: t, ...n });
}
function zg({ size: e = "sm", ...t }) {
  return /* @__PURE__ */ g(Ws, { size: e, ...t });
}
function Hg({ size: e = "sm", ...t }) {
  return /* @__PURE__ */ g(Is, { size: e, ...t });
}
function Vg({ size: e = "sm", color: t = "brand", ...n }) {
  return /* @__PURE__ */ g(Bo, { size: e, color: t, ...n });
}
function Ec(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var no = { exports: {} }, Ah = no.exports, Yi;
function zs() {
  return Yi || (Yi = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(Ah, (function() {
      var n = 1e3, o = 6e4, r = 36e5, s = "millisecond", i = "second", a = "minute", l = "hour", c = "day", p = "week", f = "month", u = "quarter", d = "year", m = "date", h = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, _ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(S) {
        var k = ["th", "st", "nd", "rd"], R = S % 100;
        return "[" + S + (k[(R - 20) % 10] || k[R] || k[0]) + "]";
      } }, w = function(S, k, R) {
        var D = String(S);
        return !D || D.length >= k ? S : "" + Array(k + 1 - D.length).join(R) + S;
      }, x = { s: w, z: function(S) {
        var k = -S.utcOffset(), R = Math.abs(k), D = Math.floor(R / 60), b = R % 60;
        return (k <= 0 ? "+" : "-") + w(D, 2, "0") + ":" + w(b, 2, "0");
      }, m: function S(k, R) {
        if (k.date() < R.date()) return -S(R, k);
        var D = 12 * (R.year() - k.year()) + (R.month() - k.month()), b = k.clone().add(D, f), T = R - b < 0, P = k.clone().add(D + (T ? -1 : 1), f);
        return +(-(D + (R - b) / (T ? b - P : P - b)) || 0);
      }, a: function(S) {
        return S < 0 ? Math.ceil(S) || 0 : Math.floor(S);
      }, p: function(S) {
        return { M: f, y: d, w: p, d: c, D: m, h: l, m: a, s: i, ms: s, Q: u }[S] || String(S || "").toLowerCase().replace(/s$/, "");
      }, u: function(S) {
        return S === void 0;
      } }, C = "en", $ = {};
      $[C] = _;
      var M = "$isDayjsObject", N = function(S) {
        return S instanceof B || !(!S || !S[M]);
      }, I = function S(k, R, D) {
        var b;
        if (!k) return C;
        if (typeof k == "string") {
          var T = k.toLowerCase();
          $[T] && (b = T), R && ($[T] = R, b = T);
          var P = k.split("-");
          if (!b && P.length > 1) return S(P[0]);
        } else {
          var F = k.name;
          $[F] = k, b = F;
        }
        return !D && b && (C = b), b || !D && C;
      }, E = function(S, k) {
        if (N(S)) return S.clone();
        var R = typeof k == "object" ? k : {};
        return R.date = S, R.args = arguments, new B(R);
      }, O = x;
      O.l = I, O.i = N, O.w = function(S, k) {
        return E(S, { locale: k.$L, utc: k.$u, x: k.$x, $offset: k.$offset });
      };
      var B = (function() {
        function S(R) {
          this.$L = I(R.locale, null, !0), this.parse(R), this.$x = this.$x || R.x || {}, this[M] = !0;
        }
        var k = S.prototype;
        return k.parse = function(R) {
          this.$d = (function(D) {
            var b = D.date, T = D.utc;
            if (b === null) return /* @__PURE__ */ new Date(NaN);
            if (O.u(b)) return /* @__PURE__ */ new Date();
            if (b instanceof Date) return new Date(b);
            if (typeof b == "string" && !/Z$/i.test(b)) {
              var P = b.match(v);
              if (P) {
                var F = P[2] - 1 || 0, L = (P[7] || "0").substring(0, 3);
                return T ? new Date(Date.UTC(P[1], F, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, L)) : new Date(P[1], F, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, L);
              }
            }
            return new Date(b);
          })(R), this.init();
        }, k.init = function() {
          var R = this.$d;
          this.$y = R.getFullYear(), this.$M = R.getMonth(), this.$D = R.getDate(), this.$W = R.getDay(), this.$H = R.getHours(), this.$m = R.getMinutes(), this.$s = R.getSeconds(), this.$ms = R.getMilliseconds();
        }, k.$utils = function() {
          return O;
        }, k.isValid = function() {
          return this.$d.toString() !== h;
        }, k.isSame = function(R, D) {
          var b = E(R);
          return this.startOf(D) <= b && b <= this.endOf(D);
        }, k.isAfter = function(R, D) {
          return E(R) < this.startOf(D);
        }, k.isBefore = function(R, D) {
          return this.endOf(D) < E(R);
        }, k.$g = function(R, D, b) {
          return O.u(R) ? this[D] : this.set(b, R);
        }, k.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, k.valueOf = function() {
          return this.$d.getTime();
        }, k.startOf = function(R, D) {
          var b = this, T = !!O.u(D) || D, P = O.p(R), F = function(G, J) {
            var ie = O.w(b.$u ? Date.UTC(b.$y, J, G) : new Date(b.$y, J, G), b);
            return T ? ie : ie.endOf(c);
          }, L = function(G, J) {
            return O.w(b.toDate()[G].apply(b.toDate("s"), (T ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(J)), b);
          }, Y = this.$W, z = this.$M, V = this.$D, U = "set" + (this.$u ? "UTC" : "");
          switch (P) {
            case d:
              return T ? F(1, 0) : F(31, 11);
            case f:
              return T ? F(1, z) : F(0, z + 1);
            case p:
              var ee = this.$locale().weekStart || 0, X = (Y < ee ? Y + 7 : Y) - ee;
              return F(T ? V - X : V + (6 - X), z);
            case c:
            case m:
              return L(U + "Hours", 0);
            case l:
              return L(U + "Minutes", 1);
            case a:
              return L(U + "Seconds", 2);
            case i:
              return L(U + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, k.endOf = function(R) {
          return this.startOf(R, !1);
        }, k.$set = function(R, D) {
          var b, T = O.p(R), P = "set" + (this.$u ? "UTC" : ""), F = (b = {}, b[c] = P + "Date", b[m] = P + "Date", b[f] = P + "Month", b[d] = P + "FullYear", b[l] = P + "Hours", b[a] = P + "Minutes", b[i] = P + "Seconds", b[s] = P + "Milliseconds", b)[T], L = T === c ? this.$D + (D - this.$W) : D;
          if (T === f || T === d) {
            var Y = this.clone().set(m, 1);
            Y.$d[F](L), Y.init(), this.$d = Y.set(m, Math.min(this.$D, Y.daysInMonth())).$d;
          } else F && this.$d[F](L);
          return this.init(), this;
        }, k.set = function(R, D) {
          return this.clone().$set(R, D);
        }, k.get = function(R) {
          return this[O.p(R)]();
        }, k.add = function(R, D) {
          var b, T = this;
          R = Number(R);
          var P = O.p(D), F = function(z) {
            var V = E(T);
            return O.w(V.date(V.date() + Math.round(z * R)), T);
          };
          if (P === f) return this.set(f, this.$M + R);
          if (P === d) return this.set(d, this.$y + R);
          if (P === c) return F(1);
          if (P === p) return F(7);
          var L = (b = {}, b[a] = o, b[l] = r, b[i] = n, b)[P] || 1, Y = this.$d.getTime() + R * L;
          return O.w(Y, this);
        }, k.subtract = function(R, D) {
          return this.add(-1 * R, D);
        }, k.format = function(R) {
          var D = this, b = this.$locale();
          if (!this.isValid()) return b.invalidDate || h;
          var T = R || "YYYY-MM-DDTHH:mm:ssZ", P = O.z(this), F = this.$H, L = this.$m, Y = this.$M, z = b.weekdays, V = b.months, U = b.meridiem, ee = function(J, ie, ae, ne) {
            return J && (J[ie] || J(D, T)) || ae[ie].slice(0, ne);
          }, X = function(J) {
            return O.s(F % 12 || 12, J, "0");
          }, G = U || function(J, ie, ae) {
            var ne = J < 12 ? "AM" : "PM";
            return ae ? ne.toLowerCase() : ne;
          };
          return T.replace(y, (function(J, ie) {
            return ie || (function(ae) {
              switch (ae) {
                case "YY":
                  return String(D.$y).slice(-2);
                case "YYYY":
                  return O.s(D.$y, 4, "0");
                case "M":
                  return Y + 1;
                case "MM":
                  return O.s(Y + 1, 2, "0");
                case "MMM":
                  return ee(b.monthsShort, Y, V, 3);
                case "MMMM":
                  return ee(V, Y);
                case "D":
                  return D.$D;
                case "DD":
                  return O.s(D.$D, 2, "0");
                case "d":
                  return String(D.$W);
                case "dd":
                  return ee(b.weekdaysMin, D.$W, z, 2);
                case "ddd":
                  return ee(b.weekdaysShort, D.$W, z, 3);
                case "dddd":
                  return z[D.$W];
                case "H":
                  return String(F);
                case "HH":
                  return O.s(F, 2, "0");
                case "h":
                  return X(1);
                case "hh":
                  return X(2);
                case "a":
                  return G(F, L, !0);
                case "A":
                  return G(F, L, !1);
                case "m":
                  return String(L);
                case "mm":
                  return O.s(L, 2, "0");
                case "s":
                  return String(D.$s);
                case "ss":
                  return O.s(D.$s, 2, "0");
                case "SSS":
                  return O.s(D.$ms, 3, "0");
                case "Z":
                  return P;
              }
              return null;
            })(J) || P.replace(":", "");
          }));
        }, k.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, k.diff = function(R, D, b) {
          var T, P = this, F = O.p(D), L = E(R), Y = (L.utcOffset() - this.utcOffset()) * o, z = this - L, V = function() {
            return O.m(P, L);
          };
          switch (F) {
            case d:
              T = V() / 12;
              break;
            case f:
              T = V();
              break;
            case u:
              T = V() / 3;
              break;
            case p:
              T = (z - Y) / 6048e5;
              break;
            case c:
              T = (z - Y) / 864e5;
              break;
            case l:
              T = z / r;
              break;
            case a:
              T = z / o;
              break;
            case i:
              T = z / n;
              break;
            default:
              T = z;
          }
          return b ? T : O.a(T);
        }, k.daysInMonth = function() {
          return this.endOf(f).$D;
        }, k.$locale = function() {
          return $[this.$L];
        }, k.locale = function(R, D) {
          if (!R) return this.$L;
          var b = this.clone(), T = I(R, D, !0);
          return T && (b.$L = T), b;
        }, k.clone = function() {
          return O.w(this.$d, this);
        }, k.toDate = function() {
          return new Date(this.valueOf());
        }, k.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, k.toISOString = function() {
          return this.$d.toISOString();
        }, k.toString = function() {
          return this.$d.toUTCString();
        }, S;
      })(), A = B.prototype;
      return E.prototype = A, [["$ms", s], ["$s", i], ["$m", a], ["$H", l], ["$W", c], ["$M", f], ["$y", d], ["$D", m]].forEach((function(S) {
        A[S[1]] = function(k) {
          return this.$g(k, S[0], S[1]);
        };
      })), E.extend = function(S, k) {
        return S.$i || (S(k, B, E), S.$i = !0), E;
      }, E.locale = I, E.isDayjs = N, E.unix = function(S) {
        return E(1e3 * S);
      }, E.en = $[C], E.Ls = $, E.p = {}, E;
    }));
  })(no)), no.exports;
}
var Ih = zs();
const H = /* @__PURE__ */ Ec(Ih);
function Yh({ direction: e, levelIndex: t, rowIndex: n, cellIndex: o, size: r }) {
  switch (e) {
    case "up":
      return t === 0 && n === 0 ? null : n === 0 ? {
        levelIndex: t - 1,
        rowIndex: o <= r[t - 1][r[t - 1].length - 1] - 1 ? r[t - 1].length - 1 : r[t - 1].length - 2,
        cellIndex: o
      } : {
        levelIndex: t,
        rowIndex: n - 1,
        cellIndex: o
      };
    case "down":
      return n === r[t].length - 1 ? {
        levelIndex: t + 1,
        rowIndex: 0,
        cellIndex: o
      } : n === r[t].length - 2 && o >= r[t][r[t].length - 1] ? {
        levelIndex: t + 1,
        rowIndex: 0,
        cellIndex: o
      } : {
        levelIndex: t,
        rowIndex: n + 1,
        cellIndex: o
      };
    case "left":
      return t === 0 && n === 0 && o === 0 ? null : n === 0 && o === 0 ? {
        levelIndex: t - 1,
        rowIndex: r[t - 1].length - 1,
        cellIndex: r[t - 1][r[t - 1].length - 1] - 1
      } : o === 0 ? {
        levelIndex: t,
        rowIndex: n - 1,
        cellIndex: r[t][n - 1] - 1
      } : {
        levelIndex: t,
        rowIndex: n,
        cellIndex: o - 1
      };
    case "right":
      return n === r[t].length - 1 && o === r[t][n] - 1 ? {
        levelIndex: t + 1,
        rowIndex: 0,
        cellIndex: 0
      } : o === r[t][n] - 1 ? {
        levelIndex: t,
        rowIndex: n + 1,
        cellIndex: 0
      } : {
        levelIndex: t,
        rowIndex: n,
        cellIndex: o + 1
      };
    default:
      return {
        levelIndex: t,
        rowIndex: n,
        cellIndex: o
      };
  }
}
function Oc({ controlsRef: e, direction: t, levelIndex: n, rowIndex: o, cellIndex: r, size: s }) {
  const i = Yh({
    direction: t,
    size: s,
    rowIndex: o,
    cellIndex: r,
    levelIndex: n
  });
  if (!i) return;
  const a = e.current?.[i.levelIndex]?.[i.rowIndex]?.[i.cellIndex];
  a && (a.disabled || a.getAttribute("data-hidden") || a.getAttribute("data-outside") ? Oc({
    controlsRef: e,
    direction: t,
    levelIndex: i.levelIndex,
    cellIndex: i.cellIndex,
    rowIndex: i.rowIndex,
    size: s
  }) : a.focus());
}
function Fh(e) {
  switch (e) {
    case "ArrowDown":
      return "down";
    case "ArrowUp":
      return "up";
    case "ArrowRight":
      return "right";
    case "ArrowLeft":
      return "left";
    default:
      return null;
  }
}
function Wh(e) {
  return e.current?.map((t) => t.map((n) => n.length));
}
function Hs({ controlsRef: e, levelIndex: t, rowIndex: n, cellIndex: o, event: r }) {
  const s = Fh(r.key);
  s && (r.preventDefault(), Oc({
    controlsRef: e,
    direction: s,
    levelIndex: t,
    rowIndex: n,
    cellIndex: o,
    size: Wh(e)
  }));
}
function Ae(e) {
  return e == null || e === "" ? e : H(e).format("YYYY-MM-DD");
}
function Bh(e) {
  return e == null || e === "" ? e : H(e).format("YYYY-MM-DD HH:mm:ss");
}
function zh({ minDate: e, maxDate: t }) {
  const n = H();
  return !e && !t ? Ae(n) : e && H(n).isBefore(e) ? Ae(e) : t && H(n).isAfter(t) ? Ae(t) : Ae(n);
}
const Hh = {
  locale: "en",
  firstDayOfWeek: 1,
  weekendDays: [0, 6],
  labelSeparator: "–",
  consistentWeeks: !1
}, Vh = mt(Hh);
function tn() {
  const e = Te(Vh), t = de((s) => s || e.locale, [e.locale]), n = de((s) => typeof s == "number" ? s : e.firstDayOfWeek, [e.firstDayOfWeek]), o = de((s) => Array.isArray(s) ? s : e.weekendDays, [e.weekendDays]), r = de((s) => typeof s == "string" ? s : e.labelSeparator, [e.labelSeparator]);
  return {
    ...e,
    getLocale: t,
    getFirstDayOfWeek: n,
    getWeekendDays: o,
    getLabelSeparator: r
  };
}
var Ac = { day: "m_396ce5cb" };
const Ic = (e, { size: t }) => ({ day: { "--day-size": he(t, "day-size") } }), Ho = te((e) => {
  const t = K("Day", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, date: l, disabled: c, __staticSelector: p, weekend: f, outside: u, selected: d, renderDay: m, inRange: h, firstInRange: v, lastInRange: y, hidden: _, static: w, highlightToday: x, fullWidth: C, attributes: $, ...M } = t, N = se({
    name: p || "Day",
    classes: Ac,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: $,
    vars: a,
    varsResolver: Ic,
    rootSelector: "day"
  });
  return /* @__PURE__ */ g(nt, {
    ...N("day", { style: _ ? { display: "none" } : void 0 }),
    component: w ? "div" : "button",
    disabled: c,
    "data-today": H(l).isSame(/* @__PURE__ */ new Date(), "day") || void 0,
    "data-hidden": _ || void 0,
    "data-highlight-today": x || void 0,
    "data-disabled": c || void 0,
    "data-weekend": !c && !u && f || void 0,
    "data-outside": !c && u || void 0,
    "data-selected": !c && d || void 0,
    "data-in-range": h && !c || void 0,
    "data-first-in-range": v && !c || void 0,
    "data-last-in-range": y && !c || void 0,
    "data-static": w || void 0,
    "data-full-width": C || void 0,
    unstyled: i,
    ...M,
    children: m?.(l) || H(l).date()
  });
});
Ho.classes = Ac;
Ho.varsResolver = Ic;
Ho.displayName = "@mantine/dates/Day";
function jh({ locale: e, format: t = "dd", firstDayOfWeek: n = 1 }) {
  const o = H().day(n), r = [];
  for (let s = 0; s < 7; s += 1) typeof t == "string" ? r.push(H(o).add(s, "days").locale(e).format(t)) : r.push(t(H(o).add(s, "days").format("YYYY-MM-DD")));
  return r;
}
var Yc = { weekday: "m_18a3eca" };
const Fc = (e, { size: t }) => ({ weekdaysRow: {
  "--wr-fz": we(t),
  "--wr-spacing": _e(t)
} }), Vo = te((e) => {
  const t = K("WeekdaysRow", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, locale: l, firstDayOfWeek: c, weekdayFormat: p, cellComponent: f = "th", __staticSelector: u, withWeekNumbers: d, attributes: m, ...h } = t, v = se({
    name: u || "WeekdaysRow",
    classes: Yc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: m,
    vars: a,
    varsResolver: Fc,
    rootSelector: "weekdaysRow"
  }), y = tn(), _ = jh({
    locale: y.getLocale(l),
    format: p,
    firstDayOfWeek: y.getFirstDayOfWeek(c)
  }).map((w, x) => /* @__PURE__ */ g(f, {
    ...v("weekday"),
    children: w
  }, x));
  return /* @__PURE__ */ oe(q, {
    component: "tr",
    ...v("weekdaysRow"),
    ...h,
    children: [d && /* @__PURE__ */ g(f, {
      ...v("weekday"),
      children: "#"
    }), _]
  });
});
Vo.classes = Yc;
Vo.varsResolver = Fc;
Vo.displayName = "@mantine/dates/WeekdaysRow";
function Gh(e, t = 1) {
  let n = H(e);
  if (!n.isValid()) return n;
  const o = t === 0 ? 6 : t - 1;
  for (; n.day() !== o; ) n = n.add(1, "day");
  return n.format("YYYY-MM-DD");
}
function Kh(e, t = 1) {
  let n = H(e);
  for (; n.day() !== t; ) n = n.subtract(1, "day");
  return n.format("YYYY-MM-DD");
}
function Uh({ month: e, firstDayOfWeek: t = 1, consistentWeeks: n }) {
  const o = H(e).subtract(H(e).date() - 1, "day"), r = H(o.format("YYYY-M-D")), s = r.format("YYYY-MM-DD"), i = r.add(+r.daysInMonth() - 1, "day").format("YYYY-MM-DD"), a = Gh(i, t), l = [];
  let c = H(Kh(s, t));
  for (; H(c).isBefore(a, "day"); ) {
    const p = [];
    for (let f = 0; f < 7; f += 1)
      p.push(c.format("YYYY-MM-DD")), c = c.add(1, "day");
    l.push(p);
  }
  if (n && l.length < 6) {
    const p = l[l.length - 1], f = p[p.length - 1];
    let u = H(f).add(1, "day");
    for (; l.length < 6; ) {
      const d = [];
      for (let m = 0; m < 7; m += 1)
        d.push(u.format("YYYY-MM-DD")), u = u.add(1, "day");
      l.push(d);
    }
  }
  return l;
}
function Vs(e, t) {
  return H(e).format("YYYY-MM") === H(t).format("YYYY-MM");
}
function Wc(e, t) {
  return t ? H(e).isAfter(H(t).subtract(1, "day"), "day") : !0;
}
function Bc(e, t) {
  return t ? H(e).isBefore(H(t).add(1, "day"), "day") : !0;
}
function Xh({ dates: e, minDate: t, maxDate: n, getDayProps: o, excludeDate: r, hideOutsideDates: s, month: i }) {
  const a = e.flat().filter((p) => Bc(p, n) && Wc(p, t) && !r?.(p) && !o?.(p)?.disabled && (!s || Vs(p, i))), l = a.find((p) => o?.(p)?.selected);
  if (l) return l;
  const c = a.find((p) => H().isSame(p, "date"));
  return c || a[0];
}
var oo = { exports: {} }, qh = oo.exports, Fi;
function Zh() {
  return Fi || (Fi = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(qh, (function() {
      var n = "day";
      return function(o, r, s) {
        var i = function(c) {
          return c.add(4 - c.isoWeekday(), n);
        }, a = r.prototype;
        a.isoWeekYear = function() {
          return i(this).year();
        }, a.isoWeek = function(c) {
          if (!this.$utils().u(c)) return this.add(7 * (c - this.isoWeek()), n);
          var p, f, u, d, m = i(this), h = (p = this.isoWeekYear(), f = this.$u, u = (f ? s.utc : s)().year(p).startOf("year"), d = 4 - u.isoWeekday(), u.isoWeekday() > 4 && (d += 7), u.add(d, n));
          return m.diff(h, "week") + 1;
        }, a.isoWeekday = function(c) {
          return this.$utils().u(c) ? this.day() || 7 : this.day(this.day() % 7 ? c : c - 7);
        };
        var l = a.startOf;
        a.startOf = function(c, p) {
          var f = this.$utils(), u = !!f.u(p) || p;
          return f.p(c) === "isoweek" ? u ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : l.bind(this)(c, p);
        };
      };
    }));
  })(oo)), oo.exports;
}
var Jh = Zh();
const Qh = /* @__PURE__ */ Ec(Jh);
H.extend(Qh);
function eg(e) {
  const t = e.find((n) => H(n).day() === 1);
  return H(t).isoWeek();
}
var zc = {
  month: "m_cc9820d3",
  monthCell: "m_8f457cd5",
  weekNumber: "m_6cff9dea"
};
const tg = { withCellSpacing: !0 }, Hc = (e, { size: t }) => ({ weekNumber: {
  "--wn-fz": we(t),
  "--wn-size": he(t, "wn-size")
} }), Vn = te((e) => {
  const t = K("Month", tg, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, __staticSelector: l, locale: c, firstDayOfWeek: p, weekdayFormat: f, month: u, weekendDays: d, getDayProps: m, excludeDate: h, minDate: v, maxDate: y, renderDay: _, hideOutsideDates: w, hideWeekdays: x, getDayAriaLabel: C, static: $, __getDayRef: M, __onDayKeyDown: N, __onDayClick: I, __onDayMouseEnter: E, __preventFocus: O, __stopPropagation: B, withCellSpacing: A, size: S, highlightToday: k, withWeekNumbers: R, fullWidth: D, attributes: b, ...T } = t, P = se({
    name: l || "Month",
    classes: zc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: b,
    vars: a,
    varsResolver: Hc,
    rootSelector: "month"
  }), F = tn(), L = Uh({
    month: u,
    firstDayOfWeek: F.getFirstDayOfWeek(p),
    consistentWeeks: F.consistentWeeks
  }), Y = Xh({
    dates: L,
    minDate: Ae(v),
    maxDate: Ae(y),
    getDayProps: m,
    excludeDate: h,
    hideOutsideDates: w,
    month: u
  }), { resolvedClassNames: z, resolvedStyles: V } = gn({
    classNames: n,
    styles: s,
    props: t
  }), U = L.map((ee, X) => {
    const G = ee.map((J, ie) => {
      const ae = !Vs(J, u), ne = C?.(J) || H(J).locale(c || F.locale).format("D MMMM YYYY"), ue = m?.(J), le = H(J).isSame(Y, "date");
      return /* @__PURE__ */ g("td", {
        ...P("monthCell"),
        "data-with-spacing": A || void 0,
        children: /* @__PURE__ */ g(Ho, {
          __staticSelector: l || "Month",
          classNames: z,
          styles: V,
          attributes: b,
          unstyled: i,
          "data-mantine-stop-propagation": B || void 0,
          highlightToday: k,
          renderDay: _,
          date: J,
          size: S,
          weekend: F.getWeekendDays(d).includes(H(J).get("day")),
          outside: ae,
          hidden: w ? ae : !1,
          "aria-label": ne,
          static: $,
          fullWidth: D,
          disabled: h?.(J) || !Bc(J, Ae(y)) || !Wc(J, Ae(v)),
          ref: (Q) => {
            Q && M?.(X, ie, Q);
          },
          ...ue,
          onKeyDown: (Q) => {
            ue?.onKeyDown?.(Q), N?.(Q, {
              rowIndex: X,
              cellIndex: ie,
              date: J
            });
          },
          onMouseEnter: (Q) => {
            ue?.onMouseEnter?.(Q), E?.(Q, J);
          },
          onClick: (Q) => {
            ue?.onClick?.(Q), I?.(Q, J);
          },
          onMouseDown: (Q) => {
            ue?.onMouseDown?.(Q), O && Q.preventDefault();
          },
          tabIndex: O || !le ? -1 : 0
        })
      }, J.toString());
    });
    return /* @__PURE__ */ oe("tr", {
      ...P("monthRow"),
      children: [R && /* @__PURE__ */ g("td", {
        ...P("weekNumber"),
        children: eg(ee)
      }), G]
    }, X);
  });
  return /* @__PURE__ */ oe(q, {
    component: "table",
    ...P("month"),
    size: S,
    "data-full-width": D || void 0,
    ...T,
    children: [!x && /* @__PURE__ */ g("thead", {
      ...P("monthThead"),
      children: /* @__PURE__ */ g(Vo, {
        __staticSelector: l || "Month",
        locale: c,
        firstDayOfWeek: p,
        weekdayFormat: f,
        withWeekNumbers: R,
        size: S,
        classNames: z,
        styles: V,
        unstyled: i,
        attributes: b
      })
    }), /* @__PURE__ */ g("tbody", {
      ...P("monthTbody"),
      children: U
    })]
  });
});
Vn.classes = zc;
Vn.varsResolver = Hc;
Vn.displayName = "@mantine/dates/Month";
var Vc = { pickerControl: "m_dc6a3c71" };
const jc = (e, { size: t }) => ({ pickerControl: {
  "--dpc-fz": we(t),
  "--dpc-size": he(t, "dpc-size")
} }), jn = te((e) => {
  const t = K("PickerControl", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, firstInRange: l, lastInRange: c, inRange: p, __staticSelector: f, selected: u, disabled: d, fullWidth: m, attributes: h, ...v } = t, y = se({
    name: f || "PickerControl",
    classes: Vc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: h,
    vars: a,
    varsResolver: jc,
    rootSelector: "pickerControl"
  });
  return /* @__PURE__ */ g(nt, {
    ...y("pickerControl"),
    unstyled: i,
    "data-picker-control": !0,
    "data-full-width": m || void 0,
    "data-selected": u && !d || void 0,
    "data-disabled": d || void 0,
    "data-in-range": p && !d && !u || void 0,
    "data-first-in-range": l && !d || void 0,
    "data-last-in-range": c && !d || void 0,
    disabled: d,
    ...v
  });
});
jn.classes = Vc;
jn.varsResolver = jc;
jn.displayName = "@mantine/dates/PickerControl";
function Gc({ year: e, minDate: t, maxDate: n }) {
  return !t && !n ? !1 : !!(t && H(e).isBefore(t, "year") || n && H(e).isAfter(n, "year"));
}
function ng({ years: e, minDate: t, maxDate: n, getYearControlProps: o }) {
  const r = e.flat().filter((a) => !Gc({
    year: a,
    minDate: t,
    maxDate: n
  }) && !o?.(a)?.disabled), s = r.find((a) => o?.(a)?.selected);
  if (s) return s;
  const i = r.find((a) => H().isSame(a, "year"));
  return i || r[0];
}
function Kc(e) {
  const t = H(e).year(), n = t - t % 10;
  let o = 0;
  const r = [
    [],
    [],
    [],
    []
  ];
  for (let s = 0; s < 4; s += 1) {
    const i = s === 3 ? 1 : 3;
    for (let a = 0; a < i; a += 1)
      r[s].push(H(new Date(n + o, 0)).format("YYYY-MM-DD")), o += 1;
  }
  return r;
}
var Uc = {
  yearsList: "m_9206547b",
  yearsListCell: "m_c5a19c7d"
};
const og = {
  yearsListFormat: "YYYY",
  withCellSpacing: !0
}, jo = te((e) => {
  const t = K("YearsList", og, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, decade: l, yearsListFormat: c, locale: p, minDate: f, maxDate: u, getYearControlProps: d, __staticSelector: m, __getControlRef: h, __onControlKeyDown: v, __onControlClick: y, __onControlMouseEnter: _, __preventFocus: w, __stopPropagation: x, withCellSpacing: C, fullWidth: $, size: M, attributes: N, ...I } = t, E = se({
    name: m || "YearsList",
    classes: Uc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: N,
    vars: a,
    rootSelector: "yearsList"
  }), O = tn(), B = Kc(l), A = ng({
    years: B,
    minDate: f,
    maxDate: u,
    getYearControlProps: d
  }), S = B.map((k, R) => {
    const D = k.map((b, T) => {
      const P = d?.(b), F = H(b).isSame(A, "year");
      return /* @__PURE__ */ g("td", {
        ...E("yearsListCell"),
        "data-with-spacing": C || void 0,
        children: /* @__PURE__ */ g(jn, {
          ...E("yearsListControl"),
          size: M,
          unstyled: i,
          fullWidth: $,
          "data-mantine-stop-propagation": x || void 0,
          disabled: Gc({
            year: b,
            minDate: f,
            maxDate: u
          }),
          ref: (L) => {
            L && h?.(R, T, L);
          },
          ...P,
          onKeyDown: (L) => {
            P?.onKeyDown?.(L), v?.(L, {
              rowIndex: R,
              cellIndex: T,
              date: b
            });
          },
          onClick: (L) => {
            P?.onClick?.(L), y?.(L, b);
          },
          onMouseEnter: (L) => {
            P?.onMouseEnter?.(L), _?.(L, b);
          },
          onMouseDown: (L) => {
            P?.onMouseDown?.(L), w && L.preventDefault();
          },
          tabIndex: w || !F ? -1 : 0,
          children: P?.children ?? (typeof c == "function" ? c(b) : H(b).locale(O.getLocale(p)).format(c))
        })
      }, T);
    });
    return /* @__PURE__ */ g("tr", {
      ...E("yearsListRow"),
      children: D
    }, R);
  });
  return /* @__PURE__ */ g(q, {
    component: "table",
    size: M,
    ...E("yearsList"),
    "data-full-width": $ || void 0,
    ...I,
    children: /* @__PURE__ */ g("tbody", { children: S })
  });
});
jo.classes = Uc;
jo.displayName = "@mantine/dates/YearsList";
function Xc({ month: e, minDate: t, maxDate: n }) {
  return !t && !n ? !1 : !!(t && H(e).isBefore(t, "month") || n && H(e).isAfter(n, "month"));
}
function rg({ months: e, minDate: t, maxDate: n, getMonthControlProps: o }) {
  const r = e.flat().filter((a) => !Xc({
    month: a,
    minDate: t,
    maxDate: n
  }) && !o?.(a)?.disabled), s = r.find((a) => o?.(a)?.selected);
  if (s) return s;
  const i = r.find((a) => H().isSame(a, "month"));
  return i || r[0];
}
function sg(e) {
  const t = H(e).startOf("year").toDate(), n = [
    [],
    [],
    [],
    []
  ];
  let o = 0;
  for (let r = 0; r < 4; r += 1) for (let s = 0; s < 3; s += 1)
    n[r].push(H(t).add(o, "months").format("YYYY-MM-DD")), o += 1;
  return n;
}
var qc = {
  monthsList: "m_2a6c32d",
  monthsListCell: "m_fe27622f"
};
const ig = {
  monthsListFormat: "MMM",
  withCellSpacing: !0
}, Go = te((e) => {
  const t = K("MonthsList", ig, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, __staticSelector: l, year: c, monthsListFormat: p, locale: f, minDate: u, maxDate: d, getMonthControlProps: m, __getControlRef: h, __onControlKeyDown: v, __onControlClick: y, __onControlMouseEnter: _, __preventFocus: w, __stopPropagation: x, withCellSpacing: C, fullWidth: $, size: M, attributes: N, ...I } = t, E = se({
    name: l || "MonthsList",
    classes: qc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: N,
    vars: a,
    rootSelector: "monthsList"
  }), O = tn(), B = sg(c), A = rg({
    months: B,
    minDate: Ae(u),
    maxDate: Ae(d),
    getMonthControlProps: m
  }), S = B.map((k, R) => {
    const D = k.map((b, T) => {
      const P = m?.(b), F = H(b).isSame(A, "month");
      return /* @__PURE__ */ g("td", {
        ...E("monthsListCell"),
        "data-with-spacing": C || void 0,
        children: /* @__PURE__ */ g(jn, {
          ...E("monthsListControl"),
          size: M,
          unstyled: i,
          fullWidth: $,
          __staticSelector: l || "MonthsList",
          "data-mantine-stop-propagation": x || void 0,
          disabled: Xc({
            month: b,
            minDate: Ae(u),
            maxDate: Ae(d)
          }),
          ref: (L) => {
            L && h?.(R, T, L);
          },
          ...P,
          onKeyDown: (L) => {
            P?.onKeyDown?.(L), v?.(L, {
              rowIndex: R,
              cellIndex: T,
              date: b
            });
          },
          onClick: (L) => {
            P?.onClick?.(L), y?.(L, b);
          },
          onMouseEnter: (L) => {
            P?.onMouseEnter?.(L), _?.(L, b);
          },
          onMouseDown: (L) => {
            P?.onMouseDown?.(L), w && L.preventDefault();
          },
          tabIndex: w || !F ? -1 : 0,
          children: P?.children ?? (typeof p == "function" ? p(b) : H(b).locale(O.getLocale(f)).format(p))
        })
      }, T);
    });
    return /* @__PURE__ */ g("tr", {
      ...E("monthsListRow"),
      children: D
    }, R);
  });
  return /* @__PURE__ */ g(q, {
    component: "table",
    size: M,
    ...E("monthsList"),
    "data-full-width": $ || void 0,
    ...I,
    children: /* @__PURE__ */ g("tbody", { children: S })
  });
});
Go.classes = qc;
Go.displayName = "@mantine/dates/MonthsList";
var Zc = {
  calendarHeader: "m_730a79ed",
  calendarHeaderLevel: "m_f6645d97",
  calendarHeaderControl: "m_2351eeb0",
  calendarHeaderSelect: "m_e214b549",
  calendarHeaderControlIcon: "m_367dc749"
};
const ag = {
  hasNextLevel: !0,
  withNext: !0,
  withPrevious: !0,
  headerControlsOrder: [
    "previous",
    "level",
    "next"
  ]
}, Jc = (e, { size: t }) => ({ calendarHeader: {
  "--dch-control-size": he(t, "dch-control-size"),
  "--dch-fz": we(t)
} }), Rt = te((e) => {
  const t = K("CalendarHeader", ag, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, nextIcon: l, previousIcon: c, nextLabel: p, previousLabel: f, onNext: u, onPrevious: d, onLevelClick: m, label: h, nextDisabled: v, previousDisabled: y, hasNextLevel: _, levelControlAriaLabel: w, withNext: x, withPrevious: C, headerControlsOrder: $, fullWidth: M, withNativeLevelSelect: N, yearsSelectRange: I, __staticSelector: E, __preventFocus: O, __stopPropagation: B, __calendarLevel: A, __date: S, __locale: k, __onDateChange: R, __minDate: D, __maxDate: b, __disableNativeLevelSelect: T, attributes: P, ...F } = t, L = se({
    name: E || "CalendarHeader",
    classes: Zc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: P,
    vars: a,
    varsResolver: Jc,
    rootSelector: "calendarHeader"
  }), Y = O ? (le) => le.preventDefault() : void 0, z = C && /* @__PURE__ */ yt(nt, {
    ...L("calendarHeaderControl"),
    key: "previous",
    "data-direction": "previous",
    "aria-label": f,
    onClick: d,
    unstyled: i,
    onMouseDown: Y,
    disabled: y,
    "data-disabled": y || void 0,
    tabIndex: O || y ? -1 : 0,
    "data-mantine-stop-propagation": B || void 0
  }, c || /* @__PURE__ */ g(zr, {
    ...L("calendarHeaderControlIcon"),
    "data-direction": "previous",
    size: "45%"
  })), V = (/* @__PURE__ */ new Date()).getFullYear(), U = S ? H(S).year() : V, ee = I?.[0] ?? (D ? H(D).year() : V - 100), X = I?.[1] ?? (b ? H(b).year() : V + 50), G = Math.min(ee, X, U), J = Math.max(ee, X, U), ie = (le) => {
    let Q = le;
    return D && Q.isBefore(H(D), "day") && (Q = H(D)), b && Q.isAfter(H(b), "day") && (Q = H(b)), Q.format("YYYY-MM-DD");
  }, ae = (N && S && R && A !== "decade" ? /* @__PURE__ */ yt("div", {
    ...L("calendarHeaderLevel"),
    key: "level",
    "data-static": !0,
    "data-native-level-select": !0
  }, A === "month" && /* @__PURE__ */ g("select", {
    ...L("calendarHeaderSelect"),
    "data-select": "month",
    disabled: T,
    value: H(S).month(),
    onChange: (le) => {
      R(ie(H(S).month(parseInt(le.currentTarget.value, 10))));
    },
    onMouseDown: Y,
    "aria-label": w,
    children: Array.from({ length: 12 }, (le, Q) => /* @__PURE__ */ g("option", {
      value: Q,
      children: H().locale(k || "en").month(Q).format("MMMM")
    }, Q))
  }), /* @__PURE__ */ g("select", {
    ...L("calendarHeaderSelect"),
    "data-select": "year",
    disabled: T,
    value: H(S).year(),
    onChange: (le) => {
      R(ie(H(S).year(parseInt(le.currentTarget.value, 10))));
    },
    onMouseDown: Y,
    "aria-label": w,
    children: Array.from({ length: J - G + 1 }, (le, Q) => {
      const me = G + Q;
      return /* @__PURE__ */ g("option", {
        value: me,
        children: me
      }, me);
    })
  })) : null) || /* @__PURE__ */ yt(nt, {
    component: _ ? "button" : "div",
    ...L("calendarHeaderLevel"),
    key: "level",
    onClick: _ ? m : void 0,
    unstyled: i,
    onMouseDown: _ ? Y : void 0,
    disabled: !_,
    "data-static": !_ || void 0,
    "aria-label": w,
    tabIndex: O || !_ ? -1 : 0,
    "data-mantine-stop-propagation": B || void 0
  }, h), ne = x && /* @__PURE__ */ yt(nt, {
    ...L("calendarHeaderControl"),
    key: "next",
    "data-direction": "next",
    "aria-label": p,
    onClick: u,
    unstyled: i,
    onMouseDown: Y,
    disabled: v,
    "data-disabled": v || void 0,
    tabIndex: O || v ? -1 : 0,
    "data-mantine-stop-propagation": B || void 0
  }, l || /* @__PURE__ */ g(zr, {
    ...L("calendarHeaderControlIcon"),
    "data-direction": "next",
    size: "45%"
  })), ue = $.map((le) => le === "previous" ? z : le === "level" ? ae : le === "next" ? ne : null);
  return /* @__PURE__ */ g(q, {
    ...L("calendarHeader"),
    "data-full-width": M || void 0,
    ...F,
    children: ue
  });
});
Rt.classes = Zc;
Rt.varsResolver = Jc;
Rt.displayName = "@mantine/dates/CalendarHeader";
function lg(e) {
  const t = Kc(e);
  return [t[0][0], t[3][0]];
}
const cg = { decadeLabelFormat: "YYYY" }, Ko = te((e) => {
  const { decade: t, locale: n, minDate: o, maxDate: r, yearsListFormat: s, getYearControlProps: i, __getControlRef: a, __onControlKeyDown: l, __onControlClick: c, __onControlMouseEnter: p, withCellSpacing: f, __preventFocus: u, nextIcon: d, previousIcon: m, nextLabel: h, previousLabel: v, onNext: y, onPrevious: _, nextDisabled: w, previousDisabled: x, levelControlAriaLabel: C, withNext: $, withPrevious: M, headerControlsOrder: N, decadeLabelFormat: I, classNames: E, styles: O, unstyled: B, __staticSelector: A, __stopPropagation: S, size: k, fullWidth: R, attributes: D, ...b } = K("DecadeLevel", cg, e), T = tn(), [P, F] = lg(t), L = {
    __staticSelector: A || "DecadeLevel",
    classNames: E,
    styles: O,
    unstyled: B,
    size: k,
    attributes: D
  }, Y = typeof w == "boolean" ? w : r ? !H(F).endOf("year").isBefore(r) : !1, z = typeof x == "boolean" ? x : o ? !H(P).startOf("year").isAfter(o) : !1, V = (U, ee) => H(U).locale(n || T.locale).format(ee);
  return /* @__PURE__ */ oe(q, {
    "data-decade-level": !0,
    size: k,
    ...b,
    children: [/* @__PURE__ */ g(Rt, {
      label: typeof I == "function" ? I(P, F) : `${V(P, I)} – ${V(F, I)}`,
      __preventFocus: u,
      __stopPropagation: S,
      nextIcon: d,
      previousIcon: m,
      nextLabel: h,
      previousLabel: v,
      onNext: y,
      onPrevious: _,
      nextDisabled: Y,
      previousDisabled: z,
      hasNextLevel: !1,
      levelControlAriaLabel: C,
      withNext: $,
      withPrevious: M,
      headerControlsOrder: N,
      fullWidth: R,
      ...L
    }), /* @__PURE__ */ g(jo, {
      decade: t,
      locale: n,
      minDate: o,
      maxDate: r,
      yearsListFormat: s,
      getYearControlProps: i,
      __getControlRef: a,
      __onControlKeyDown: l,
      __onControlClick: c,
      __onControlMouseEnter: p,
      __preventFocus: u,
      __stopPropagation: S,
      withCellSpacing: f,
      fullWidth: R,
      ...L
    })]
  });
});
Ko.classes = {
  ...jo.classes,
  ...Rt.classes
};
Ko.displayName = "@mantine/dates/DecadeLevel";
const ug = { yearLabelFormat: "YYYY" }, Uo = te((e) => {
  const { year: t, locale: n, minDate: o, maxDate: r, monthsListFormat: s, getMonthControlProps: i, __getControlRef: a, __onControlKeyDown: l, __onControlClick: c, __onControlMouseEnter: p, withCellSpacing: f, __preventFocus: u, nextIcon: d, previousIcon: m, nextLabel: h, previousLabel: v, onNext: y, onPrevious: _, onLevelClick: w, nextDisabled: x, previousDisabled: C, hasNextLevel: $, levelControlAriaLabel: M, withNext: N, withPrevious: I, headerControlsOrder: E, withNativeLevelSelect: O, yearsSelectRange: B, yearLabelFormat: A, __staticSelector: S, __stopPropagation: k, __onDateChange: R, __disableNativeLevelSelect: D, size: b, classNames: T, styles: P, unstyled: F, fullWidth: L, attributes: Y, ...z } = K("YearLevel", ug, e), V = tn(), U = {
    __staticSelector: S || "YearLevel",
    classNames: T,
    styles: P,
    unstyled: F,
    size: b,
    attributes: Y
  }, ee = typeof x == "boolean" ? x : r ? !H(t).endOf("year").isBefore(r) : !1, X = typeof C == "boolean" ? C : o ? !H(t).startOf("year").isAfter(o) : !1;
  return /* @__PURE__ */ oe(q, {
    "data-year-level": !0,
    size: b,
    ...z,
    children: [/* @__PURE__ */ g(Rt, {
      label: typeof A == "function" ? A(t) : H(t).locale(n || V.locale).format(A),
      __preventFocus: u,
      __stopPropagation: k,
      __calendarLevel: "year",
      __date: t,
      __locale: n || V.locale,
      __onDateChange: R,
      __disableNativeLevelSelect: D,
      __minDate: o,
      __maxDate: r,
      nextIcon: d,
      previousIcon: m,
      nextLabel: h,
      previousLabel: v,
      onNext: y,
      onPrevious: _,
      onLevelClick: w,
      nextDisabled: ee,
      previousDisabled: X,
      hasNextLevel: $,
      levelControlAriaLabel: M,
      withNext: N,
      withPrevious: I,
      headerControlsOrder: E,
      withNativeLevelSelect: O,
      yearsSelectRange: B,
      fullWidth: L,
      ...U
    }), /* @__PURE__ */ g(Go, {
      year: t,
      locale: n,
      minDate: o,
      maxDate: r,
      monthsListFormat: s,
      getMonthControlProps: i,
      __getControlRef: a,
      __onControlKeyDown: l,
      __onControlClick: c,
      __onControlMouseEnter: p,
      __preventFocus: u,
      __stopPropagation: k,
      withCellSpacing: f,
      fullWidth: L,
      ...U
    })]
  });
});
Uo.classes = {
  ...Rt.classes,
  ...Go.classes
};
Uo.displayName = "@mantine/dates/YearLevel";
const dg = { monthLabelFormat: "MMMM YYYY" }, Xo = te((e) => {
  const { month: t, locale: n, firstDayOfWeek: o, weekdayFormat: r, weekendDays: s, getDayProps: i, excludeDate: a, minDate: l, maxDate: c, renderDay: p, hideOutsideDates: f, hideWeekdays: u, getDayAriaLabel: d, __getDayRef: m, __onDayKeyDown: h, __onDayClick: v, __onDayMouseEnter: y, withCellSpacing: _, highlightToday: w, withWeekNumbers: x, __preventFocus: C, __stopPropagation: $, nextIcon: M, previousIcon: N, nextLabel: I, previousLabel: E, onNext: O, onPrevious: B, onLevelClick: A, nextDisabled: S, previousDisabled: k, hasNextLevel: R, levelControlAriaLabel: D, withNext: b, withPrevious: T, headerControlsOrder: P, withNativeLevelSelect: F, yearsSelectRange: L, monthLabelFormat: Y, classNames: z, styles: V, unstyled: U, __staticSelector: ee, __onDateChange: X, __disableNativeLevelSelect: G, size: J, static: ie, fullWidth: ae, attributes: ne, ...ue } = K("MonthLevel", dg, e), le = tn(), Q = {
    __staticSelector: ee || "MonthLevel",
    classNames: z,
    styles: V,
    unstyled: U,
    size: J,
    attributes: ne
  }, me = typeof S == "boolean" ? S : c ? !H(t).endOf("month").isBefore(c) : !1, be = typeof k == "boolean" ? k : l ? !H(t).startOf("month").isAfter(l) : !1;
  return /* @__PURE__ */ oe(q, {
    "data-month-level": !0,
    size: J,
    ...ue,
    children: [/* @__PURE__ */ g(Rt, {
      label: typeof Y == "function" ? Y(t) : H(t).locale(n || le.locale).format(Y),
      __preventFocus: C,
      __stopPropagation: $,
      __calendarLevel: "month",
      __date: t,
      __locale: n || le.locale,
      __onDateChange: X,
      __disableNativeLevelSelect: G,
      __minDate: l,
      __maxDate: c,
      nextIcon: M,
      previousIcon: N,
      nextLabel: I,
      previousLabel: E,
      onNext: O,
      onPrevious: B,
      onLevelClick: A,
      nextDisabled: me,
      previousDisabled: be,
      hasNextLevel: R,
      levelControlAriaLabel: D,
      withNext: b,
      withPrevious: T,
      headerControlsOrder: P,
      withNativeLevelSelect: F,
      yearsSelectRange: L,
      fullWidth: ae,
      ...Q
    }), /* @__PURE__ */ g(Vn, {
      month: t,
      locale: n,
      firstDayOfWeek: o,
      weekdayFormat: r,
      weekendDays: s,
      getDayProps: i,
      excludeDate: a,
      minDate: l,
      maxDate: c,
      renderDay: p,
      hideOutsideDates: f,
      hideWeekdays: u,
      getDayAriaLabel: d,
      __getDayRef: m,
      __onDayKeyDown: h,
      __onDayClick: v,
      __onDayMouseEnter: y,
      __preventFocus: C,
      __stopPropagation: $,
      static: ie,
      withCellSpacing: _,
      highlightToday: w,
      withWeekNumbers: x,
      fullWidth: ae,
      ...Q
    })]
  });
});
Xo.classes = {
  ...Vn.classes,
  ...Rt.classes
};
Xo.displayName = "@mantine/dates/MonthLevel";
var Qc = { levelsGroup: "m_30b26e33" };
const It = te((e) => {
  const t = K("LevelsGroup", null, e), { classNames: n, className: o, style: r, styles: s, unstyled: i, vars: a, __staticSelector: l, fullWidth: c, attributes: p, ...f } = t, u = se({
    name: l || "LevelsGroup",
    classes: Qc,
    props: t,
    className: o,
    style: r,
    classNames: n,
    styles: s,
    unstyled: i,
    attributes: p,
    vars: a,
    rootSelector: "levelsGroup"
  });
  return /* @__PURE__ */ g(q, {
    ...u("levelsGroup"),
    "data-full-width": c || void 0,
    ...f
  });
});
It.classes = Qc;
It.displayName = "@mantine/dates/LevelsGroup";
const fg = { numberOfColumns: 1 }, qo = te((e) => {
  const { decade: t, locale: n, minDate: o, maxDate: r, yearsListFormat: s, getYearControlProps: i, __onControlClick: a, __onControlMouseEnter: l, withCellSpacing: c, __preventFocus: p, nextIcon: f, previousIcon: u, nextLabel: d, previousLabel: m, onNext: h, onPrevious: v, nextDisabled: y, previousDisabled: _, headerControlsOrder: w, classNames: x, styles: C, unstyled: $, __staticSelector: M, __stopPropagation: N, numberOfColumns: I, levelControlAriaLabel: E, decadeLabelFormat: O, size: B, fullWidth: A, vars: S, attributes: k, ...R } = K("DecadeLevelGroup", fg, e), D = Z([]), b = Array(I).fill(0).map((T, P) => {
    const F = H(t).add(P * 10, "years").format("YYYY-MM-DD");
    return /* @__PURE__ */ g(Ko, {
      size: B,
      yearsListFormat: s,
      decade: F,
      withNext: P === I - 1,
      withPrevious: P === 0,
      decadeLabelFormat: O,
      __onControlClick: a,
      __onControlMouseEnter: l,
      __onControlKeyDown: (L, Y) => Hs({
        levelIndex: P,
        rowIndex: Y.rowIndex,
        cellIndex: Y.cellIndex,
        event: L,
        controlsRef: D
      }),
      __getControlRef: (L, Y, z) => {
        Array.isArray(D.current[P]) || (D.current[P] = []), Array.isArray(D.current[P][L]) || (D.current[P][L] = []), D.current[P][L][Y] = z;
      },
      levelControlAriaLabel: typeof E == "function" ? E(F) : E,
      locale: n,
      minDate: o,
      maxDate: r,
      __preventFocus: p,
      __stopPropagation: N,
      nextIcon: f,
      previousIcon: u,
      nextLabel: d,
      previousLabel: m,
      onNext: h,
      onPrevious: v,
      nextDisabled: y,
      previousDisabled: _,
      getYearControlProps: i,
      __staticSelector: M || "DecadeLevelGroup",
      classNames: x,
      styles: C,
      unstyled: $,
      withCellSpacing: c,
      headerControlsOrder: w,
      fullWidth: A,
      attributes: k
    }, P);
  });
  return /* @__PURE__ */ g(It, {
    classNames: x,
    styles: C,
    __staticSelector: M || "DecadeLevelGroup",
    size: B,
    unstyled: $,
    fullWidth: A,
    attributes: k,
    ...R,
    children: b
  });
});
qo.classes = {
  ...It.classes,
  ...Ko.classes
};
qo.displayName = "@mantine/dates/DecadeLevelGroup";
const pg = { numberOfColumns: 1 }, Zo = te((e) => {
  const { year: t, locale: n, minDate: o, maxDate: r, monthsListFormat: s, getMonthControlProps: i, __onControlClick: a, __onControlMouseEnter: l, withCellSpacing: c, __preventFocus: p, nextIcon: f, previousIcon: u, nextLabel: d, previousLabel: m, onNext: h, onPrevious: v, onLevelClick: y, nextDisabled: _, previousDisabled: w, hasNextLevel: x, headerControlsOrder: C, withNativeLevelSelect: $, yearsSelectRange: M, classNames: N, styles: I, unstyled: E, __staticSelector: O, __stopPropagation: B, __onDateChange: A, __disableNativeLevelSelect: S, numberOfColumns: k, levelControlAriaLabel: R, yearLabelFormat: D, size: b, fullWidth: T, vars: P, attributes: F, ...L } = K("YearLevelGroup", pg, e), Y = Z([]), z = Array(k).fill(0).map((V, U) => {
    const ee = H(t).add(U, "years").format("YYYY-MM-DD");
    return /* @__PURE__ */ g(Uo, {
      size: b,
      monthsListFormat: s,
      year: ee,
      withNext: U === k - 1,
      withPrevious: U === 0,
      yearLabelFormat: D,
      __stopPropagation: B,
      __onControlClick: a,
      __onControlMouseEnter: l,
      __onControlKeyDown: (X, G) => Hs({
        levelIndex: U,
        rowIndex: G.rowIndex,
        cellIndex: G.cellIndex,
        event: X,
        controlsRef: Y
      }),
      __getControlRef: (X, G, J) => {
        Array.isArray(Y.current[U]) || (Y.current[U] = []), Array.isArray(Y.current[U][X]) || (Y.current[U][X] = []), Y.current[U][X][G] = J;
      },
      levelControlAriaLabel: typeof R == "function" ? R(ee) : R,
      locale: n,
      minDate: o,
      maxDate: r,
      __preventFocus: p,
      nextIcon: f,
      previousIcon: u,
      nextLabel: d,
      previousLabel: m,
      onNext: h,
      onPrevious: v,
      onLevelClick: y,
      nextDisabled: _,
      previousDisabled: w,
      hasNextLevel: x,
      withNativeLevelSelect: $,
      yearsSelectRange: M,
      __onDateChange: A,
      __disableNativeLevelSelect: S,
      getMonthControlProps: i,
      classNames: N,
      styles: I,
      unstyled: E,
      __staticSelector: O || "YearLevelGroup",
      withCellSpacing: c,
      headerControlsOrder: C,
      fullWidth: T,
      attributes: F
    }, U);
  });
  return /* @__PURE__ */ g(It, {
    classNames: N,
    styles: I,
    __staticSelector: O || "YearLevelGroup",
    size: b,
    unstyled: E,
    fullWidth: T,
    attributes: F,
    ...L,
    children: z
  });
});
Zo.classes = {
  ...Uo.classes,
  ...It.classes
};
Zo.displayName = "@mantine/dates/YearLevelGroup";
const mg = { numberOfColumns: 1 }, Jo = te((e) => {
  const { month: t, locale: n, firstDayOfWeek: o, weekdayFormat: r, weekendDays: s, getDayProps: i, excludeDate: a, minDate: l, maxDate: c, renderDay: p, hideOutsideDates: f, hideWeekdays: u, getDayAriaLabel: d, __onDayClick: m, __onDayMouseEnter: h, withCellSpacing: v, highlightToday: y, withWeekNumbers: _, __preventFocus: w, nextIcon: x, previousIcon: C, nextLabel: $, previousLabel: M, onNext: N, onPrevious: I, onLevelClick: E, nextDisabled: O, previousDisabled: B, hasNextLevel: A, headerControlsOrder: S, withNativeLevelSelect: k, yearsSelectRange: R, classNames: D, styles: b, unstyled: T, numberOfColumns: P, levelControlAriaLabel: F, monthLabelFormat: L, __staticSelector: Y, __stopPropagation: z, __onDateChange: V, __disableNativeLevelSelect: U, size: ee, static: X, fullWidth: G, vars: J, attributes: ie, ...ae } = K("MonthLevelGroup", mg, e), ne = Z([]), ue = Array(P).fill(0).map((le, Q) => {
    const me = H(t).add(Q, "months").format("YYYY-MM-DD");
    return /* @__PURE__ */ g(Xo, {
      month: me,
      withNext: Q === P - 1,
      withPrevious: Q === 0,
      monthLabelFormat: L,
      __stopPropagation: z,
      __onDayClick: m,
      __onDayMouseEnter: h,
      __onDayKeyDown: (be, Re) => Hs({
        levelIndex: Q,
        rowIndex: Re.rowIndex,
        cellIndex: Re.cellIndex,
        event: be,
        controlsRef: ne
      }),
      __getDayRef: (be, Re, Ne) => {
        Array.isArray(ne.current[Q]) || (ne.current[Q] = []), Array.isArray(ne.current[Q][be]) || (ne.current[Q][be] = []), ne.current[Q][be][Re] = Ne;
      },
      levelControlAriaLabel: typeof F == "function" ? F(me) : F,
      locale: n,
      firstDayOfWeek: o,
      weekdayFormat: r,
      weekendDays: s,
      getDayProps: i,
      excludeDate: a,
      minDate: l,
      maxDate: c,
      renderDay: p,
      hideOutsideDates: f,
      hideWeekdays: u,
      getDayAriaLabel: d,
      __preventFocus: w,
      nextIcon: x,
      previousIcon: C,
      nextLabel: $,
      previousLabel: M,
      onNext: N,
      onPrevious: I,
      onLevelClick: E,
      nextDisabled: O,
      previousDisabled: B,
      hasNextLevel: A,
      withNativeLevelSelect: k,
      yearsSelectRange: R,
      __onDateChange: V,
      __disableNativeLevelSelect: U,
      classNames: D,
      styles: b,
      unstyled: T,
      __staticSelector: Y || "MonthLevelGroup",
      size: ee,
      static: X,
      withCellSpacing: v,
      highlightToday: y,
      withWeekNumbers: _,
      headerControlsOrder: S,
      fullWidth: G,
      attributes: ie
    }, Q);
  });
  return /* @__PURE__ */ g(It, {
    classNames: D,
    styles: b,
    __staticSelector: Y || "MonthLevelGroup",
    size: ee,
    fullWidth: G,
    attributes: ie,
    ...ae,
    children: ue
  });
});
Jo.classes = {
  ...It.classes,
  ...Xo.classes
};
Jo.displayName = "@mantine/dates/MonthLevelGroup";
const Wi = (e) => e === "range" ? [null, null] : e === "multiple" ? [] : null, Bi = (e, t) => {
  const n = t ? Bh : Ae;
  return Array.isArray(e) ? e.map(n) : n(e);
};
function eu({ type: e, value: t, defaultValue: n, onChange: o, withTime: r = !1 }) {
  const s = Z(e), [i, a, l] = _t({
    value: Bi(t, r),
    defaultValue: Bi(n, r),
    finalValue: Wi(e),
    onChange: o
  });
  let c = i;
  return s.current !== e && (s.current = e, t === void 0 && (c = n !== void 0 ? n : Wi(e), a(c))), [
    c,
    a,
    l
  ];
}
function Rr(e, t) {
  return e ? e === "month" ? 0 : e === "year" ? 1 : 2 : t || 0;
}
function hg(e) {
  return e === 0 ? "month" : e === 1 ? "year" : "decade";
}
function Dn(e, t, n) {
  return hg(vu(Rr(e, 0), Rr(t, 0), Rr(n, 2)));
}
const gg = {
  maxLevel: "decade",
  minLevel: "month",
  __updateDateOnYearSelect: !0,
  __updateDateOnMonthSelect: !0,
  enableKeyboardNavigation: !0
}, Qo = te((e) => {
  const t = K("Calendar", gg, e), { vars: n, maxLevel: o, minLevel: r, defaultLevel: s, level: i, onLevelChange: a, date: l, defaultDate: c, onDateChange: p, numberOfColumns: f, columnsToScroll: u, ariaLabels: d, nextLabel: m, previousLabel: h, onYearSelect: v, onMonthSelect: y, onYearMouseEnter: _, onMonthMouseEnter: w, headerControlsOrder: x, __updateDateOnYearSelect: C, __updateDateOnMonthSelect: $, __setDateRef: M, __setLevelRef: N, firstDayOfWeek: I, weekdayFormat: E, weekendDays: O, getDayProps: B, excludeDate: A, renderDay: S, hideOutsideDates: k, hideWeekdays: R, getDayAriaLabel: D, monthLabelFormat: b, nextIcon: T, previousIcon: P, __onDayClick: F, __onDayMouseEnter: L, withCellSpacing: Y, highlightToday: z, withWeekNumbers: V, monthsListFormat: U, getMonthControlProps: ee, yearLabelFormat: X, yearsListFormat: G, getYearControlProps: J, decadeLabelFormat: ie, classNames: ae, styles: ne, unstyled: ue, minDate: le, maxDate: Q, locale: me, __staticSelector: be, size: Re, __preventFocus: Ne, __stopPropagation: We, onNextDecade: ke, onPreviousDecade: Ge, onNextYear: ge, onPreviousYear: Dt, onNextMonth: De, onPreviousMonth: nn, static: fe, enableKeyboardNavigation: Be, withNativeLevelSelect: on, yearsSelectRange: Ze, fullWidth: Yt, attributes: rn, ref: tr, ...nr } = t, { resolvedClassNames: Le, resolvedStyles: lt } = gn({
    classNames: ae,
    styles: ne,
    props: t
  }), [$t, ht] = _t({
    value: i ? Dn(i, r, o) : void 0,
    defaultValue: s ? Dn(s, r, o) : void 0,
    finalValue: Dn(void 0, r, o),
    onChange: a
  }), [or, Ke, $e] = eu({
    type: "default",
    value: Ae(l),
    defaultValue: Ae(c),
    onChange: p
  }), Ee = $e && !p;
  Xs(M, () => (ve) => {
    Ke(ve);
  }), Xs(N, () => (ve) => {
    ht(ve);
  });
  const Ft = {
    __staticSelector: be || "Calendar",
    styles: lt,
    classNames: Le,
    unstyled: ue,
    size: Re,
    attributes: rn
  }, sn = u || f || 1, rr = Z(null);
  rr.current === null && (rr.current = zh({
    minDate: le,
    maxDate: Q
  }));
  const gt = or || rr.current, ou = () => {
    const ve = H(gt).add(sn, "month").format("YYYY-MM-DD");
    De?.(ve), Ke(ve);
  }, ru = () => {
    const ve = H(gt).subtract(sn, "month").format("YYYY-MM-DD");
    nn?.(ve), Ke(ve);
  }, sr = () => {
    const ve = H(gt).add(sn, "year").format("YYYY-MM-DD");
    ge?.(ve), Ke(ve);
  }, ir = () => {
    const ve = H(gt).subtract(sn, "year").format("YYYY-MM-DD");
    Dt?.(ve), Ke(ve);
  }, ar = () => {
    const ve = H(gt).add(10 * sn, "year").format("YYYY-MM-DD");
    ke?.(ve), Ke(ve);
  }, lr = () => {
    const ve = H(gt).subtract(10 * sn, "year").format("YYYY-MM-DD");
    Ge?.(ve), Ke(ve);
  }, js = Z(null);
  return ce(() => {
    if (!Be || fe) return;
    const ve = (Oe) => {
      if (!js.current?.contains(document.activeElement)) return;
      const Gn = Oe.ctrlKey || Oe.metaKey, Gs = Oe.shiftKey;
      switch (Oe.key) {
        case "ArrowUp":
          Gn && Gs ? (Oe.preventDefault(), lr()) : Gn && (Oe.preventDefault(), ir());
          break;
        case "ArrowDown":
          Gn && Gs ? (Oe.preventDefault(), ar()) : Gn && (Oe.preventDefault(), sr());
          break;
        case "y":
        case "Y":
          $t === "month" && (Oe.preventDefault(), ht("year"));
      }
    };
    return document.addEventListener("keydown", ve), () => {
      document.removeEventListener("keydown", ve);
    };
  }, [
    Be,
    fe,
    $t,
    sr,
    ir,
    ar,
    lr
  ]), /* @__PURE__ */ oe(q, {
    ref: Me(js, tr),
    size: Re,
    "data-calendar": !0,
    "data-full-width": Yt || void 0,
    ...nr,
    children: [
      $t === "month" && /* @__PURE__ */ g(Jo, {
        month: gt,
        minDate: le,
        maxDate: Q,
        firstDayOfWeek: I,
        weekdayFormat: E,
        weekendDays: O,
        getDayProps: B,
        excludeDate: A,
        renderDay: S,
        hideOutsideDates: k,
        hideWeekdays: R,
        getDayAriaLabel: D,
        onNext: ou,
        onPrevious: ru,
        hasNextLevel: o !== "month",
        onLevelClick: () => ht("year"),
        numberOfColumns: f,
        locale: me,
        levelControlAriaLabel: d?.monthLevelControl,
        nextLabel: d?.nextMonth ?? m,
        nextIcon: T,
        previousLabel: d?.previousMonth ?? h,
        previousIcon: P,
        monthLabelFormat: b,
        __onDayClick: F,
        __onDayMouseEnter: L,
        __onDateChange: Ke,
        __disableNativeLevelSelect: Ee,
        __preventFocus: Ne,
        __stopPropagation: We,
        static: fe,
        withCellSpacing: Y,
        highlightToday: z,
        withWeekNumbers: V,
        withNativeLevelSelect: on,
        yearsSelectRange: Ze,
        headerControlsOrder: x,
        fullWidth: Yt,
        ...Ft
      }),
      $t === "year" && /* @__PURE__ */ g(Zo, {
        year: gt,
        numberOfColumns: f,
        minDate: le,
        maxDate: Q,
        monthsListFormat: U,
        getMonthControlProps: ee,
        locale: me,
        onNext: sr,
        onPrevious: ir,
        hasNextLevel: o !== "month" && o !== "year",
        onLevelClick: () => ht("decade"),
        levelControlAriaLabel: d?.yearLevelControl,
        nextLabel: d?.nextYear ?? m,
        nextIcon: T,
        previousLabel: d?.previousYear ?? h,
        previousIcon: P,
        yearLabelFormat: X,
        __onControlMouseEnter: w,
        __onControlClick: (ve, Oe) => {
          $ && Ke(Oe), ht(Dn("month", r, o)), y?.(Oe);
        },
        __onDateChange: Ke,
        __disableNativeLevelSelect: Ee,
        __preventFocus: Ne,
        __stopPropagation: We,
        withCellSpacing: Y,
        withNativeLevelSelect: on,
        yearsSelectRange: Ze,
        headerControlsOrder: x,
        fullWidth: Yt,
        ...Ft
      }),
      $t === "decade" && /* @__PURE__ */ g(qo, {
        decade: gt,
        minDate: le,
        maxDate: Q,
        yearsListFormat: G,
        getYearControlProps: J,
        locale: me,
        onNext: ar,
        onPrevious: lr,
        numberOfColumns: f,
        nextLabel: d?.nextDecade ?? m,
        nextIcon: T,
        previousLabel: d?.previousDecade ?? h,
        previousIcon: P,
        decadeLabelFormat: ie,
        __onControlMouseEnter: _,
        __onControlClick: (ve, Oe) => {
          C && Ke(Oe), ht(Dn("year", r, o)), v?.(Oe);
        },
        __preventFocus: Ne,
        __stopPropagation: We,
        withCellSpacing: Y,
        headerControlsOrder: x,
        fullWidth: Yt,
        ...Ft
      })
    ]
  });
});
Qo.classes = {
  ...qo.classes,
  ...Zo.classes,
  ...Jo.classes
};
Qo.displayName = "@mantine/dates/Calendar";
function vg(e) {
  const { maxLevel: t, minLevel: n, defaultLevel: o, level: r, onLevelChange: s, nextIcon: i, previousIcon: a, date: l, defaultDate: c, onDateChange: p, numberOfColumns: f, columnsToScroll: u, ariaLabels: d, nextLabel: m, previousLabel: h, onYearSelect: v, onMonthSelect: y, onYearMouseEnter: _, onMonthMouseEnter: w, onNextMonth: x, onPreviousMonth: C, onNextYear: $, onPreviousYear: M, onNextDecade: N, onPreviousDecade: I, withCellSpacing: E, highlightToday: O, withNativeLevelSelect: B, yearsSelectRange: A, __updateDateOnYearSelect: S, __updateDateOnMonthSelect: k, __setDateRef: R, __setLevelRef: D, withWeekNumbers: b, headerControlsOrder: T, firstDayOfWeek: P, weekdayFormat: F, weekendDays: L, getDayProps: Y, excludeDate: z, renderDay: V, hideOutsideDates: U, hideWeekdays: ee, getDayAriaLabel: X, monthLabelFormat: G, monthsListFormat: J, getMonthControlProps: ie, yearLabelFormat: ae, yearsListFormat: ne, getYearControlProps: ue, decadeLabelFormat: le, allowSingleDateInRange: Q, allowDeselect: me, minDate: be, maxDate: Re, locale: Ne, ...We } = e;
  return {
    calendarProps: {
      maxLevel: t,
      minLevel: n,
      defaultLevel: o,
      level: r,
      onLevelChange: s,
      nextIcon: i,
      previousIcon: a,
      date: l,
      defaultDate: c,
      onDateChange: p,
      numberOfColumns: f,
      columnsToScroll: u,
      ariaLabels: d,
      nextLabel: m,
      previousLabel: h,
      onYearSelect: v,
      onMonthSelect: y,
      onYearMouseEnter: _,
      onMonthMouseEnter: w,
      onNextMonth: x,
      onPreviousMonth: C,
      onNextYear: $,
      onPreviousYear: M,
      onNextDecade: N,
      onPreviousDecade: I,
      withCellSpacing: E,
      highlightToday: O,
      withNativeLevelSelect: B,
      yearsSelectRange: A,
      __updateDateOnYearSelect: S,
      __updateDateOnMonthSelect: k,
      __setDateRef: R,
      withWeekNumbers: b,
      headerControlsOrder: T,
      firstDayOfWeek: P,
      weekdayFormat: F,
      weekendDays: L,
      getDayProps: Y,
      excludeDate: z,
      renderDay: V,
      hideOutsideDates: U,
      hideWeekdays: ee,
      getDayAriaLabel: X,
      monthLabelFormat: G,
      monthsListFormat: J,
      getMonthControlProps: ie,
      yearLabelFormat: ae,
      yearsListFormat: ne,
      getYearControlProps: ue,
      decadeLabelFormat: le,
      allowSingleDateInRange: Q,
      allowDeselect: me,
      minDate: be,
      maxDate: Re,
      locale: Ne
    },
    others: We
  };
}
function zi(e, t) {
  const n = [...t].sort((o, r) => H(o).isAfter(H(r)) ? 1 : -1);
  return H(n[0]).startOf("day").subtract(1, "ms").isBefore(e) && H(n[1]).endOf("day").add(1, "ms").isAfter(e);
}
function yg({ type: e, level: t, value: n, defaultValue: o, onChange: r, allowSingleDateInRange: s, allowDeselect: i, onMouseLeave: a }) {
  const [l, c] = eu({
    type: e,
    value: n,
    defaultValue: o,
    onChange: r
  }), [p, f] = re(e === "range" && l[0] && !l[1] ? l[0] : null), [u, d] = re(null), m = (C) => {
    if (e === "range") {
      if (p && !l[1]) {
        if (H(C).isSame(p, t) && !s) {
          f(null), d(null), c([null, null]);
          return;
        }
        const $ = [C, p];
        $.sort((M, N) => H(M).isAfter(H(N)) ? 1 : -1), c($), d(null), f(null);
        return;
      }
      if (l[0] && !l[1] && H(C).isSame(l[0], t) && !s) {
        f(null), d(null), c([null, null]);
        return;
      }
      c([C, null]), d(null), f(C);
      return;
    }
    if (e === "multiple") {
      l.some(($) => H($).isSame(C, t)) ? c(l.filter(($) => !H($).isSame(C, t))) : c([...l, C]);
      return;
    }
    l && i && H(C).isSame(l, t) ? c(null) : c(C);
  }, h = (C) => p && u ? zi(C, [u, p]) : l[0] && l[1] ? zi(C, l) : !1, v = e === "range" ? (C) => {
    a?.(C), d(null);
  } : a, y = (C) => l[0] && H(C).isSame(l[0], t) ? !(u && H(u).isBefore(l[0])) : !1, _ = (C) => l[1] ? H(C).isSame(l[1], t) : !l[0] || !u ? !1 : H(u).isBefore(l[0]) && H(C).isSame(l[0], t), w = (C) => {
    if (e === "range") return {
      selected: l.some((M) => M && H(M).isSame(C, t)),
      inRange: h(C),
      firstInRange: y(C),
      lastInRange: _(C),
      "data-autofocus": !!l[0] && H(l[0]).isSame(C, t) || void 0
    };
    if (e === "multiple") return {
      selected: l.some((M) => M && H(M).isSame(C, t)),
      "data-autofocus": !!l[0] && H(l[0]).isSame(C, t) || void 0
    };
    const $ = H(l).isSame(C, t);
    return {
      selected: $,
      "data-autofocus": $ || void 0
    };
  }, x = e === "range" && p ? d : () => {
  };
  return ce(() => {
    if (e === "range")
      if (l[0] && !l[1]) f(l[0]);
      else {
        const C = l[0] == null && l[1] == null, $ = l[0] != null && l[1] != null;
        (C || $) && (f(null), d(null));
      }
  }, [l]), {
    onDateChange: m,
    onRootMouseLeave: v,
    onHoveredDateChange: x,
    getControlProps: w,
    _value: l,
    setValue: c
  };
}
var bg = {
  datePickerRoot: "m_765a40cf",
  presetsList: "m_d6a681e1",
  presetButton: "m_acd30b22"
};
const tu = (e, { size: t }) => ({ datePickerRoot: { "--preset-font-size": we(t) } }), wg = {
  type: "default",
  defaultLevel: "month",
  numberOfColumns: 1,
  size: "sm"
}, er = te((e) => {
  const t = K("DatePicker", wg, e), { allowDeselect: n, allowSingleDateInRange: o, value: r, defaultValue: s, onChange: i, onMouseLeave: a, classNames: l, styles: c, __staticSelector: p, __onDayClick: f, __onDayMouseEnter: u, __onPresetSelect: d, __stopPropagation: m, presets: h, className: v, style: y, unstyled: _, size: w, vars: x, attributes: C, fullWidth: $, ...M } = t, { calendarProps: N, others: I } = vg(M), E = Z(null), O = Z(null), B = se({
    name: p || "DatePicker",
    classes: bg,
    props: t,
    className: v,
    style: y,
    classNames: l,
    styles: c,
    unstyled: _,
    attributes: C,
    rootSelector: h ? "datePickerRoot" : void 0,
    varsResolver: tu,
    vars: x
  }), { onDateChange: A, onRootMouseLeave: S, onHoveredDateChange: k, getControlProps: R, _value: D, setValue: b } = yg({
    type: I.type,
    level: "day",
    allowDeselect: n,
    allowSingleDateInRange: o,
    value: r,
    defaultValue: s,
    onChange: i,
    onMouseLeave: a
  }), { resolvedClassNames: T, resolvedStyles: P } = gn({
    classNames: l,
    styles: c,
    props: t
  }), F = /* @__PURE__ */ g(Qo, {
    classNames: T,
    styles: P,
    __staticSelector: p || "DatePicker",
    onMouseLeave: S,
    size: w,
    fullWidth: $,
    ...N,
    ...h ? {} : I,
    __stopPropagation: m,
    __setDateRef: E,
    __setLevelRef: O,
    minLevel: N.minLevel || "month",
    __onDayMouseEnter: (z, V) => {
      k(V), u?.(z, V);
    },
    __onDayClick: (z, V) => {
      A(V), f?.(z, V);
    },
    getDayProps: (z) => ({
      ...R(z),
      ...N.getDayProps?.(z)
    }),
    getMonthControlProps: (z) => ({
      selected: typeof D == "string" ? Vs(z, D) : !1,
      ...N.getMonthControlProps?.(z)
    }),
    getYearControlProps: (z) => ({
      selected: typeof D == "string" ? H(z).isSame(D, "year") : !1,
      ...N.getYearControlProps?.(z)
    }),
    hideOutsideDates: N.hideOutsideDates ?? N.numberOfColumns !== 1,
    attributes: C,
    ...h ? {} : {
      className: v,
      style: y
    }
  });
  if (!h) return F;
  const L = (z) => {
    const V = Array.isArray(z) ? z[0] : z;
    V !== void 0 && (E.current?.(V), O.current?.("month"), d ? d(z) : b(z));
  }, Y = h.map((z, V) => /* @__PURE__ */ g(nt, {
    ...B("presetButton"),
    onClick: () => L(z.value),
    onMouseDown: (U) => U.preventDefault(),
    "data-mantine-stop-propagation": m || void 0,
    children: z.label
  }, V));
  return /* @__PURE__ */ oe(q, {
    ...B("datePickerRoot"),
    size: w,
    ...I,
    children: [/* @__PURE__ */ g("div", {
      ...B("presetsList"),
      children: Y
    }), F]
  });
});
er.classes = Qo.classes;
er.varsResolver = tu;
er.displayName = "@mantine/dates/DatePicker";
var ro = { exports: {} }, Cg = ro.exports, Hi;
function _g() {
  return Hi || (Hi = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o(zs());
    })(Cg, (function(n) {
      function o(m) {
        return m && typeof m == "object" && "default" in m ? m : { default: m };
      }
      var r = o(n), s = "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"), i = "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"), a = "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"), l = "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"), c = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
      function p(m, h, v) {
        var y, _;
        return v === "m" ? h ? "минута" : "минуту" : m + " " + (y = +m, _ = { mm: h ? "минута_минуты_минут" : "минуту_минуты_минут", hh: "час_часа_часов", dd: "день_дня_дней", MM: "месяц_месяца_месяцев", yy: "год_года_лет" }[v].split("_"), y % 10 == 1 && y % 100 != 11 ? _[0] : y % 10 >= 2 && y % 10 <= 4 && (y % 100 < 10 || y % 100 >= 20) ? _[1] : _[2]);
      }
      var f = function(m, h) {
        return c.test(h) ? s[m.month()] : i[m.month()];
      };
      f.s = i, f.f = s;
      var u = function(m, h) {
        return c.test(h) ? a[m.month()] : l[m.month()];
      };
      u.s = l, u.f = a;
      var d = { name: "ru", weekdays: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"), weekdaysShort: "вск_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"), months: f, monthsShort: u, weekStart: 1, yearStart: 4, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY г.", LLL: "D MMMM YYYY г., H:mm", LLLL: "dddd, D MMMM YYYY г., H:mm" }, relativeTime: { future: "через %s", past: "%s назад", s: "несколько секунд", m: p, mm: p, h: "час", hh: p, d: "день", dd: p, M: "месяц", MM: p, y: "год", yy: p }, ordinal: function(m) {
        return m;
      }, meridiem: function(m) {
        return m < 4 ? "ночи" : m < 12 ? "утра" : m < 17 ? "дня" : "вечера";
      } };
      return r.default.locale(d, null, !0), d;
    }));
  })(ro)), ro.exports;
}
_g();
var so = { exports: {} }, xg = so.exports, Vi;
function Sg() {
  return Vi || (Vi = 1, (function(e, t) {
    (function(n, o) {
      e.exports = o(zs());
    })(xg, (function(n) {
      function o(f) {
        return f && typeof f == "object" && "default" in f ? f : { default: f };
      }
      var r = o(n), s = "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"), i = "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_"), a = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
      function l(f, u, d) {
        var m, h;
        return d === "m" ? u ? "хвилина" : "хвилину" : d === "h" ? u ? "година" : "годину" : f + " " + (m = +f, h = { ss: u ? "секунда_секунди_секунд" : "секунду_секунди_секунд", mm: u ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин", hh: u ? "година_години_годин" : "годину_години_годин", dd: "день_дні_днів", MM: "місяць_місяці_місяців", yy: "рік_роки_років" }[d].split("_"), m % 10 == 1 && m % 100 != 11 ? h[0] : m % 10 >= 2 && m % 10 <= 4 && (m % 100 < 10 || m % 100 >= 20) ? h[1] : h[2]);
      }
      var c = function(f, u) {
        return a.test(u) ? s[f.month()] : i[f.month()];
      };
      c.s = i, c.f = s;
      var p = { name: "uk", weekdays: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"), weekdaysShort: "ндл_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"), months: c, monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"), weekStart: 1, relativeTime: { future: "за %s", past: "%s тому", s: "декілька секунд", m: l, mm: l, h: l, hh: l, d: "день", dd: l, M: "місяць", MM: l, y: "рік", yy: l }, ordinal: function(f) {
        return f;
      }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY р.", LLL: "D MMMM YYYY р., HH:mm", LLLL: "dddd, D MMMM YYYY р., HH:mm" } };
      return r.default.locale(p, null, !0), p;
    }));
  })(so)), so.exports;
}
Sg();
function jg({
  value: e,
  minDate: t,
  maxDate: n,
  locale: o,
  numberOfColumns: r,
  onCommit: s,
  "aria-label": i,
  labels: a
}) {
  const [l, c] = re(e ?? [null, null]), p = e?.[0] ?? null, f = e?.[1] ?? null;
  return ce(() => {
    c([p, f]);
  }, [p, f]), /* @__PURE__ */ g(
    er,
    {
      type: "range",
      allowSingleDateInRange: !0,
      value: l,
      onChange: (u) => {
        c(u);
        const [d, m] = u;
        d !== null && m !== null && s(d <= m ? [d, m] : [m, d]);
      },
      minDate: t ?? void 0,
      maxDate: n,
      defaultDate: f ?? n,
      locale: o,
      numberOfColumns: r,
      "aria-label": i,
      ariaLabels: a,
      classNames: { weekday: "grv-muted" },
      hideOutsideDates: !0,
      weekendDays: []
    }
  );
}
function Gg({ variant: e = "light", color: t = "ink", size: n = "sm", radius: o = "sm", tt: r = "none", ...s }) {
  return /* @__PURE__ */ g(
    zn,
    {
      variant: e,
      color: t,
      size: n,
      radius: o,
      tt: r,
      styles: { root: { maxWidth: "none" }, label: { overflow: "visible", textOverflow: "clip" } },
      ...s
    }
  );
}
function Kg({ withBorder: e = !0, radius: t = "lg", p: n = "lg", ...o }) {
  return /* @__PURE__ */ g(At, { withBorder: e, radius: t, p: n, ...o });
}
function Ug({ size: e = "sm", ...t }) {
  return /* @__PURE__ */ g(Jt, { size: e, ...t });
}
function Xg({ color: e = "ink.1", ...t }) {
  return /* @__PURE__ */ g(Io, { color: e, ...t });
}
function Rg({ horizontalSpacing: e = "md", verticalSpacing: t = "sm", ...n }) {
  return /* @__PURE__ */ g(Ce, { horizontalSpacing: e, verticalSpacing: t, ...n });
}
const qg = Object.assign(Rg, {
  Thead: Ce.Thead,
  Tbody: Ce.Tbody,
  Tfoot: Ce.Tfoot,
  Tr: Ce.Tr,
  Th: Ce.Th,
  Td: Ce.Td,
  Caption: Ce.Caption
});
function jr({ label: e, name: t }) {
  const [n, o] = re(!1), [r, s] = re(!1), [i, a] = re(!1), [l, c] = re(!1), p = (n || r || i) && !l, f = ho(), u = Qi(() => {
    c(!0), a(!1);
  });
  return ce(() => {
    if (!p) return;
    const d = (m) => {
      m.key === "Escape" && (m.stopPropagation(), c(!0), a(!1));
    };
    return document.addEventListener("keydown", d, !0), () => document.removeEventListener("keydown", d, !0);
  }, [p]), /* @__PURE__ */ oe(
    "span",
    {
      ref: u,
      className: "grv-info-wrap",
      onMouseEnter: () => {
        o(!0), c(!1);
      },
      onMouseLeave: () => o(!1),
      children: [
        /* @__PURE__ */ g(
          xn,
          {
            opened: p,
            withinPortal: !0,
            role: "tooltip",
            label: e,
            multiline: !0,
            maw: "calc(100vw - 2rem)",
            style: { whiteSpace: "pre-line" },
            transitionProps: { duration: 0 },
            children: /* @__PURE__ */ g(
              "button",
              {
                type: "button",
                className: "grv-info",
                "aria-label": t,
                "aria-describedby": f,
                onFocus: () => {
                  s(!0), c(!1);
                },
                onBlur: () => s(!1),
                onKeyDown: (d) => {
                  d.stopPropagation();
                },
                onClick: (d) => {
                  if (d.stopPropagation(), l) {
                    c(!1), a(!0);
                    return;
                  }
                  if (i) {
                    a(!1), c(!0);
                    return;
                  }
                  a(!0);
                },
                children: "i"
              }
            )
          }
        ),
        /* @__PURE__ */ g("span", { id: f, className: "grv-visually-hidden", children: e })
      ]
    }
  );
}
function Dg({ label: e, name: t, variant: n = "label", "data-testid": o = "partial-mark" }) {
  return n === "compact" ? /* @__PURE__ */ g("span", { className: "grv-warn grv-partial-compact", role: "img", "aria-label": t, title: t, "data-testid": o, children: /* @__PURE__ */ oe("svg", { viewBox: "0 0 10 10", width: "1em", height: "1em", "aria-hidden": "true", focusable: "false", children: [
    /* @__PURE__ */ g("circle", { cx: "5", cy: "5", r: "4.25", fill: "none", stroke: "currentColor", strokeWidth: "1.5" }),
    /* @__PURE__ */ g("path", { d: "M5 0.75 A4.25 4.25 0 0 1 5 9.25 Z", fill: "currentColor" })
  ] }) }) : /* @__PURE__ */ g("span", { className: "grv-warn grv-partial-label", role: "img", "aria-label": t, title: t, "data-testid": o, children: /* @__PURE__ */ g("span", { "aria-hidden": "true", children: e }) });
}
function Zg({ value: e, label: t, delta: n, sub: o, hint: r, partial: s }) {
  return /* @__PURE__ */ oe(At, { withBorder: !0, radius: "lg", p: "lg", className: "grv-stat", children: [
    /* @__PURE__ */ g("div", { className: "grv-metric", children: e }),
    /* @__PURE__ */ oe("div", { className: "grv-label", children: [
      t,
      r && /* @__PURE__ */ g(jr, { name: r.name, label: r.text })
    ] }),
    (n !== void 0 || o) && /* @__PURE__ */ oe(Gt, { component: "div", className: "grv-stat-sub", children: [
      n !== void 0 && /* @__PURE__ */ g($g, { delta: n }),
      n !== void 0 && o ? " · " : "",
      o
    ] }),
    s && /* @__PURE__ */ oe(Gt, { component: "div", className: "grv-stat-partial", "data-testid": "stat-partial", children: [
      /* @__PURE__ */ g(Dg, { label: s.label, name: s.name }),
      " · ",
      s.reason,
      s.hint && /* @__PURE__ */ g(jr, { name: s.hint.name, label: s.hint.text })
    ] })
  ] });
}
function $g({ delta: e }) {
  if ("withheld" in e)
    return /* @__PURE__ */ g("span", { className: "grv-muted", role: "img", "aria-label": e.withheld, title: e.withheld, "data-delta": "withheld", children: e.glyph });
  const t = Math.round(Math.abs(e.percent)), n = t === 0 ? "" : e.percent > 0 ? "↑ " : "↓ ", o = e.tone === "good" ? "grv-good" : e.tone === "bad" ? "grv-bad" : "grv-delta";
  return /* @__PURE__ */ oe("span", { className: o, "data-delta": e.tone, children: [
    n,
    t,
    "%"
  ] });
}
const Pg = (...e) => e.filter(Boolean).join(" ") || void 0, ji = (e) => e === "start" ? "grv-table-pin-start" : e === "end" ? "grv-table-pin-end" : void 0;
function Mg(e) {
  const t = e.length - 1, n = e[0]?.pinned === "start", o = e.length > 1 && e[t]?.pinned === "end";
  return e.map(
    (r, s) => s === 0 && n ? "start" : s === t && o ? "end" : void 0
  );
}
function Jg({
  columns: e,
  rows: t,
  sections: n,
  rowKey: o,
  caption: r,
  sort: s,
  onSort: i,
  onRowClick: a,
  scrollHint: l
}) {
  const c = Z(null), [p, f] = re(!1), u = Z(!1);
  return mo(() => {
    const d = c.current;
    if (!d || !l) return;
    const m = () => d.scrollWidth > d.clientWidth + 1;
    if (typeof ResizeObserver != "function") {
      u.current = m(), f(u.current);
      return;
    }
    const h = new ResizeObserver(() => {
      const y = m();
      y !== u.current && (u.current = y, cu(() => f(y)));
    });
    h.observe(d);
    const v = d.firstElementChild;
    return v && h.observe(v), () => h.disconnect();
  }, [l]), // The frame reserves the hint's line whenever a hint string is passed, from the prop
  // alone, and the hint is drawn into that line absolutely. Showing or hiding it then
  // moves neither the table nor the scroller, so a hint that arrives after the table's
  // first layout cannot shift it, in any engine.
  /* @__PURE__ */ oe("div", { className: "grv-table-frame", "data-scroll-hint": l ? "" : void 0, children: [
    l && p && /* @__PURE__ */ g("div", { className: "grv-table-hint", "aria-hidden": "true", children: l }),
    /* @__PURE__ */ g("div", { className: "grv-table-scroll", ref: c, children: /* @__PURE__ */ g(
      Tg,
      {
        columns: e,
        rows: t,
        sections: n,
        rowKey: o,
        caption: r,
        sort: s,
        onSort: i,
        onRowClick: a
      }
    ) })
  ] });
}
const Tg = su(function({
  columns: t,
  rows: n,
  sections: o,
  rowKey: r,
  caption: s,
  sort: i,
  onSort: a,
  onRowClick: l
}) {
  const c = Mg(t), p = r ?? t[0]?.key, f = o ?? [{ key: "rows", rows: n ?? [] }];
  function u(d, m) {
    const h = d[p], v = typeof h == "string" || typeof h == "number" ? String(h) : m;
    return /* @__PURE__ */ g(
      "tr",
      {
        onClick: l ? () => l(v) : void 0,
        tabIndex: l ? 0 : void 0,
        onKeyDown: l ? (y) => {
          y.target === y.currentTarget && (y.key !== "Enter" && y.key !== " " || (y.preventDefault(), l(v)));
        } : void 0,
        className: l ? "grv-table-row-clickable" : void 0,
        children: t.map((y, _) => /* @__PURE__ */ g("td", { className: Pg(y.numeric && "grv-table-num", ji(c[_])), children: d[y.key] }, y.key))
      },
      v
    );
  }
  return /* @__PURE__ */ oe("table", { className: "grv-table", children: [
    s && /* @__PURE__ */ g("caption", { className: "grv-visually-hidden", children: s }),
    /* @__PURE__ */ g("thead", { children: /* @__PURE__ */ g("tr", { children: t.map((d, m) => /* @__PURE__ */ oe(
      "th",
      {
        scope: "col",
        className: ji(c[m]),
        style: d.numeric ? { textAlign: "right" } : void 0,
        "aria-label": d.header,
        "aria-sort": d.sortable ? i?.key === d.key ? i.dir === "asc" ? "ascending" : "descending" : "none" : void 0,
        children: [
          d.sortable && a ? /* @__PURE__ */ oe(
            "button",
            {
              type: "button",
              className: "grv-table-sort",
              onClick: () => a(d.key),
              "data-active": i?.key === d.key ? "" : void 0,
              children: [
                d.header,
                /* @__PURE__ */ g(
                  "span",
                  {
                    "data-sort-dir": i?.key === d.key ? i.dir === "asc" ? "asc" : "desc" : "none",
                    "aria-hidden": "true",
                    children: i?.key === d.key ? i.dir === "asc" ? "↑" : "↓" : "↕"
                  }
                )
              ]
            }
          ) : d.header,
          d.hint && /* @__PURE__ */ g(jr, { name: d.hint.name, label: d.hint.text })
        ]
      },
      d.key
    )) }) }),
    f.map((d) => /* @__PURE__ */ oe("tbody", { children: [
      d.separator !== void 0 && /* @__PURE__ */ g("tr", { className: "grv-table-separator", children: /* @__PURE__ */ g("td", { colSpan: t.length, children: /* @__PURE__ */ g("span", { children: d.separator }) }) }),
      d.rows.map((m, h) => u(m, `${d.key}-${h}`))
    ] }, d.key))
  ] });
}), nu = {
  reliableAt: 100,
  provisionalAt: 50,
  directionAt: 20
};
function Ng(e, t = nu) {
  return e >= t.reliableAt ? "reliable" : e >= t.provisionalAt ? "provisional" : "insufficient";
}
const kg = { reliable: 3, provisional: 2, insufficient: 1 };
function Qg({
  conversions: e,
  thresholds: t,
  progress: n,
  ...o
}) {
  const r = Ng(e, t), s = t ?? nu, i = kg[r], a = s.reliableAt / 3;
  return /* @__PURE__ */ g(
    "span",
    {
      className: "grv-ticks",
      role: "img",
      "aria-label": o["aria-label"] ?? `${r} (${e})`,
      "data-band": r,
      children: [0, 1, 2].map((l) => {
        if (!n)
          return /* @__PURE__ */ g("i", { className: `grv-tick ${l < i ? "grv-tick-on" : "grv-tick-off"}` }, l);
        const c = Math.max(0, Math.min(1, (e - l * a) / a)), p = Math.round(c * 100);
        return /* @__PURE__ */ g(
          "i",
          {
            className: "grv-tick grv-tick-progress",
            style: {
              backgroundImage: `linear-gradient(to top, currentColor ${p}%, transparent ${p}%)`
            }
          },
          l
        );
      })
    }
  );
}
const Gi = "light-dark(var(--mantine-color-ink-6), var(--mantine-color-ink-3))", Lg = "light-dark(var(--mantine-color-ink-5), var(--mantine-color-dark-3))", Eg = {
  scale: "good",
  hold: "brand",
  watch: "ink",
  rework: "bad",
  kill: "bad",
  insufficient: "ink",
  notStarted: "ink"
}, Og = {
  scale: "light",
  hold: "light",
  watch: "outline",
  rework: "light",
  kill: "light",
  insufficient: "outline",
  notStarted: "transparent"
};
function ev({ verdict: e, label: t }) {
  const n = e === "insufficient" || e === "notStarted";
  return /* @__PURE__ */ g(
    zn,
    {
      color: Eg[e],
      variant: Og[e],
      "data-verdict": e,
      size: "sm",
      radius: "sm",
      tt: "none",
      fw: 500,
      styles: {
        root: {
          maxWidth: "none",
          ...e === "insufficient" ? { borderStyle: "dashed", borderColor: Lg } : {},
          ...n ? { color: Gi } : {}
        },
        label: { overflow: "visible", textOverflow: "clip", ...n ? { color: Gi } : {} }
      },
      children: t
    }
  );
}
function tv({ title: e, children: t, icon: n }) {
  return /* @__PURE__ */ oe(At, { withBorder: !0, radius: "lg", p: "md", className: "grv-insight", children: [
    n,
    /* @__PURE__ */ oe("div", { children: [
      /* @__PURE__ */ g("div", { className: "grv-label", style: { marginBottom: 4 }, children: e }),
      /* @__PURE__ */ g(Gt, { component: "div", className: "grv-insight-body", children: t })
    ] })
  ] });
}
function nv({ items: e, active: t, onSelect: n, ariaLabel: o }) {
  return /* @__PURE__ */ g("nav", { className: "grv-nav", "aria-label": o, children: e.map((r) => /* @__PURE__ */ oe(
    "button",
    {
      type: "button",
      className: "grv-nav-item",
      "data-active": r.value === t || void 0,
      "aria-current": r.value === t ? "page" : void 0,
      onClick: () => n?.(r.value),
      children: [
        /* @__PURE__ */ g("span", { children: r.label }),
        r.count !== void 0 && /* @__PURE__ */ g("span", { className: "grv-nav-count", children: r.count })
      ]
    },
    r.value
  )) });
}
function ov({ children: e, trailing: t }) {
  return /* @__PURE__ */ g(At, { withBorder: !0, radius: "lg", p: "md", children: /* @__PURE__ */ oe(In, { justify: "space-between", wrap: "wrap", gap: "lg", children: [
    /* @__PURE__ */ g("div", { className: "grv-filter", children: e }),
    t
  ] }) });
}
function rv({ children: e, action: t, tone: n = "bad" }) {
  const o = n === "info" ? "brand" : n;
  return /* @__PURE__ */ g(
    At,
    {
      withBorder: !0,
      radius: "lg",
      p: "md",
      role: "status",
      style: {
        background: `light-dark(var(--mantine-color-${o}-0), var(--mantine-color-${o}-9))`,
        borderColor: `light-dark(var(--mantine-color-${o}-1), var(--mantine-color-${o}-8))`
      },
      children: /* @__PURE__ */ oe(In, { justify: "space-between", wrap: "nowrap", gap: "lg", children: [
        /* @__PURE__ */ g(Gt, { size: "md", style: { color: `light-dark(var(--mantine-color-${o}-7), var(--mantine-color-${o}-3))` }, children: e }),
        t
      ] })
    }
  );
}
export {
  rv as AlertBanner,
  q as Box,
  Wg as Button,
  Bg as ButtonLink,
  Kg as Card,
  uc as Center,
  Ug as Checkbox,
  Qg as ConfidenceTicks,
  nu as DEFAULT_CONFIDENCE_THRESHOLDS,
  jg as DateRangeInput,
  Xg as Divider,
  ov as FilterBar,
  Ml as Flex,
  Yo as Grid,
  In as Group,
  Fg as GrovusProvider,
  jr as InfoMark,
  tv as InsightCard,
  wn as Loader,
  Jg as MetricTable,
  At as Paper,
  Dg as PartialMark,
  qt as ScrollArea,
  Vg as Segmented,
  Hg as Select,
  nv as SidebarNav,
  _c as SimpleGrid,
  vh as Space,
  Ys as Stack,
  Zg as StatCard,
  qg as Table,
  Gg as Tag,
  Gt as Text,
  zg as TextInput,
  Bs as Title,
  ev as VerdictTag,
  Nh as bad,
  Ph as brand,
  Ng as confidenceBand,
  Lh as dark,
  Th as good,
  Eh as grovusColors,
  Oh as grovusTheme,
  Mh as ink,
  kh as warn
};
